/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * BLC
 * # User roles  | Role                | Platform  | | ------------------- | --------- | | `admin`     | Admin | | `blc-mentoring`     | Mentoring | | `blc-coaching`      | Coaching  | | `company-mentoring` | Mentoring | | `company-coaching`  | Coaching  | | `mentor`            | Mentoring | | `mentee`            | Mentoring | | `coach`             | Coaching  | | `coachee`           | Coaching  |   # Status codes  - 200 – OK – Eyerything is working - 201 – OK – New resource has been created - 204 – OK – The resource was successfully deleted  - 400 – Bad Request – The request was invalid or cannot be served. The exact error should be explained in the error payload. E.g. „The JSON is not valid“ - 401 – Unauthorized – The request requires an user authentication - 404 – Not found – There is no resource behind the URI.  - 500 – Internal Server Error - Any other uncaught error.   # Pagination  All paginated endpoints will accept the following query string  | Key | Default | Description | | --- | --- | --- | | `limit` | 20 | The number of results per page. | | `page` | 1 | The page to return. |  And the result will contain the following  | Key | Description | | --- | --- | | `results` | The array of results. Empty array if no results (not null). | | `page` | The current page. | | `limit` |  The number of results per page. | | `total` | The total number of results. |   # Updating a list of items  Since the screens for updating a list of items have a \"Save\" button, that means that the user will modify the data (e.g. add/remove/update items), and then hit \"Save\" to make the transaction. Because of this, updating a list of items will be done with a single PUT request which contains the whole list of items after the update.  This makes things more simple, and separate request for creating/deleting/updating items do not make much sense in this case since you have a \"Save\" button for saving the whole list.  This only applies to lists of items that are not referenceable, for example studies, experience, contacts etc.   # Updating Sessions  The following fields can be updated for a session depending on it's state  | State       | Can be updated                   | Description                                                  | | ----------- | -------------------------------- | ------------------------------------------------------------ | | `Pending`   | `date`                           | The user cannot *update* a `pending` session, he must `schedule` it. To do so, he will need to set the `date` field. | | `Scheduled` | `date`                           | The user can update the `date` of a session while it is scheduled. | | `Done`      | `goals`, `achievements`, `files` | The user can update the `goals`, `achievements` and `files` of a session while it is done, but **not** the `date`. |   # Model Links  In places where a link to a model is needed, there is the `Link` model which contains an `ID` and a `name`.  For example, when displaying a process, we need to display a column for the coachee and a column for the company. However, we do not need all details about them directly in the table, but we probably still want to let the user click on it to get more details. So in this case, you can use the `Link` model to display the column but also let the user click on it to get more details.   # Uploading documents  Currently, the API for uploading documents accepts the following object  | Key    | Description                 | | ------ | --------------------------- | | `data` | Base64 encoded file.        | | `type` | Type of the file (e.g. pdf) | | `name` | The name of the file        |  The `name` and `type` here are required because the image will be uploaded by base64 encoding it, so we must send those details separately.  This could be solved by uploding the file directly using multipart file upload. However, I am not sure if `go-swagger` can correctly generate the handler for this. So you have 3 possible options:  - Investigate if `go-swagger` can correctly generate a handler for uploading files - Manually generate the handler for this case - Use the above object by manually setting the `type` and `name` # User roles  | Role                | Platform  | | ------------------- | --------- | | `admin`     | Admin | | `blc-mentoring`     | Mentoring | | `blc-coaching`      | Coaching  | | `company-mentoring` | Mentoring | | `company-coaching`  | Coaching  | | `mentor`            | Mentoring | | `mentee`            | Mentoring | | `coach`             | Coaching  | | `coachee`           | Coaching  |   # Status codes  - 200 – OK – Eyerything is working - 201 – OK – New resource has been created - 204 – OK – The resource was successfully deleted  - 400 – Bad Request – The request was invalid or cannot be served. The exact error should be explained in the error payload. E.g. „The JSON is not valid“ - 401 – Unauthorized – The request requires an user authentication - 404 – Not found – There is no resource behind the URI.  - 500 – In # User roles  | Role                | Platform  | | ------------------- | --------- | | `admin`     | Admin | | `blc-mentoring`     | Mentoring | | `blc-coaching`      | Coaching  | | `company-mentoring` | Mentoring | | `company-coaching`  | Coaching  | | `mentor`            | Mentoring | | `mentee`            | Mentoring | | `coach`             | Coaching  | | `coachee`           | Coaching  |   # Status codes  - 200 – OK – Eyerything is working - 201 – OK – New resource has been created - 204 – OK – The resource was successfully deleted  - 400 – Bad Request – The request was invalid or cannot be served. The exact error should be explained in the error payload. E.g. „The JSON is not valid“ - 401 – Unauthorized – The request requires an user authentication - 404 – Not found – There is no resource behind the URI.  - 500 – Internal Server Error - Any other uncaught error.   # Pagination  All paginated endpoints will accept the following query string  | Key | Default | Description | | --- | --- | --- | | `limit` | 20 | The number of results per page. | | `page` | 1 | The page to return. |  And the result will contain the following  | Key | Description | | --- | --- | | `results` | The array of results. Empty array if no results (not null). | | `page` | The current page. | | `limit` |  The number of results per page. | | `total` | The total number of results. |   # Updating a list of items  Since the screens for updating a list of items have a \"Save\" button, that means that the user will modify the data (e.g. add/remove/update items), and then hit \"Save\" to make the transaction. Because of this, updating a list of items will be done with a single PUT request which contains the whole list of items after the update.  This makes things more simple, and separate request for creating/deleting/updating items do not make much sense in this case since you have a \"Save\" button for saving the whole list.  This only applies to lists of items that are not referenceable, for example studies, experience, contacts etc.   # Updating Sessions  The following fields can be updated for a session depending on it's state  | State       | Can be updated                   | Description                                                  | | ----------- | -------------------------------- | ------------------------------------------------------------ | | `Pending`   | `date`                           | The user cannot *update* a `pending` session, he must `schedule` it. To do so, he will need to set the `date` field. | | `Scheduled` | `date`                           | The user can update the `date` of a session while it is scheduled. | | `Done`      | `goals`, `achievements`, `files` | The user can update the `goals`, `achievements` and `files` of a session while it is done, but **not** the `date`. |   # Model Links  In places where a link to a model is needed, there is the `Link` model which contains an `ID` and a `name`.  For example, when displaying a process, we need to display a column for the coachee and a column for the company. However, we do not need all details about them directly in the table, but we probably still want to let the user click on it to get more details. So in this case, you can use the `Link` model to display the column but also let the user click on it to get more details.   # Uploading documents  Currently, the API for uploading documents accepts the following object  | Key    | Description                 | | ------ | --------------------------- | | `data` | Base64 encoded file.        | | `type` | Type of the file (e.g. pdf) | | `name` | The name of the file        |  The `name` and `type` here are required because the image will be uploaded by base64 encoding it, so we must send those details separately.  This could be solved by uploding the file directly using multipart file upload. However, I am not sure if `go-swagger` can correctly generate the handler for this. So you have 3 possible options:  - Investigate if `go-swagger` can correctly generate a handler for uploading files - Manually generate the handler for this case - Use the above object by manually setting the `type` and `name` # User roles  | Role                | Platform  | | ------------------- | --------- | | `admin`     | Admin | | `blc-mentoring`     | Mentoring | | `blc-coaching`      | Coaching  | | `company-mentoring` | Mentoring | | `company-coaching`  | Coaching  | | `mentor`            | Mentoring | | `mentee`            | Mentoring | | `coach`             | Coaching  | | `coachee`           | Coaching  |   # Status codes  - 200 – OK – Eyerything is working - 201 – OK – New resource has been created - 204 – OK – The resource was successfully deleted  - 400 – Bad Request – The request was invalid or cannot be served. The exact error should be explained in the error payload. E.g. „The JSON is not valid“ - 401 – Unauthorized – The request requires an user authentication - 404 – Not found – There is no resource behind the URI.  - 500 – In # User roles  | Role                | Platform  | | ------------------- | --------- | | `admin`     | Admin | | `blc-mentoring`     | Mentoring | | `blc-coaching`      | Coaching  | | `company-mentoring` | Mentoring | | `company-coaching`  | Coaching  | | `mentor`            | Mentoring | | `mentee`            | Mentoring | | `coach`             | Coaching  | | `coachee`           | Coaching  |   # Status codes  - 200 – OK – Eyerything is working - 201 – OK – New resource has been created - 204 – OK – The resource was successfully deleted  - 400 – Bad Request – The request was invalid or cannot be served. The exact error should be explained in the error payload. E.g. „The JSON is not valid“ - 401 – Unauthorized – The request requires an user authentication - 404 – Not found – There is no resource behind the URI.  - 500 – Internal Server Error - Any other uncaught error.   # Pagination  All paginated endpoints will accept the following query string  | Key | Default | Description | | --- | --- | --- | | `limit` | 20 | The number of results per page. | | `page` | 1 | The page to return. |  And the result will contain the following  | Key | Description | | --- | --- | | `results` | The array of results. Empty array if no results (not null). | | `page` | The current page. | | `limit` |  The number of results per page. | | `total` | The total number of results. |   # Updating a list of items  Since the screens for updating a list of items have a \"Save\" button, that means that the user will modify the data (e.g. add/remove/update items), and then hit \"Save\" to make the transaction. Because of this, updating a list of items will be done with a single PUT request which contains the whole list of items after the update.  This makes things more simple, and separate request for creating/deleting/updating items do not make much sense in this case since you have a \"Save\" button for saving the whole list.  This only applies to lists of items that are not referenceable, for example studies, experience, contacts etc.   # Updating Sessions  The following fields can be updated for a session depending on it's state  | State       | Can be updated                   | Description                                                  | | ----------- | -------------------------------- | ------------------------------------------------------------ | | `Pending`   | `date`                           | The user cannot *update* a `pending` session, he must `schedule` it. To do so, he will need to set the `date` field. | | `Scheduled` | `date`                           | The user can update the `date` of a session while it is scheduled. | | `Done`      | `goals`, `achievements`, `files` | The user can update the `goals`, `achievements` and `files` of a session while it is done, but **not** the `date`. |   # Model Links  In places where a link to a model is needed, there is the `Link` model which contains an `ID` and a `name`.  For example, when displaying a process, we need to display a column for the coachee and a column for the company. However, we do not need all details about them directly in the table, but we probably still want to let the user click on it to get more details. So in this case, you can use the `Link` model to display the column but also let the user click on it to get more details.   # Uploading documents  Currently, the API for uploading documents accepts the following object  | Key    | Description                 | | ------ | --------------------------- | | `data` | Base64 encoded file.        | | `type` | Type of the file (e.g. pdf) | | `name` | The name of the file        |  The `name` and `type` here are required because the image will be uploaded by base64 encoding it, so we must send those details separately.  This could be solved by uploding the file directly using multipart file upload. However, I am not sure if `go-swagger` can correctly generate the handler for this. So you have 3 possible options:  - Investigate if `go-swagger` can correctly generate a handler for uploading files - Manually generate the handler for this case - Use the above object by manually setting the `type` and `name` # User roles  | Role                | Platform  | | ------------------- | --------- | | `admin`     | Admin | | `blc-mentoring`     | Mentoring | | `blc-coaching`      | Coaching  | | `company-mentoring` | Mentoring | | `company-coaching`  | Coaching  | | `mentor`            | Mentoring | | `mentee`            | Mentoring | | `coach`             | Coaching  | | `coachee`           | Coaching  |   # Status codes  - 200 – OK – Eyerything is working - 201 – OK – New resource has been created - 204 – OK – The resource was successfully deleted  - 400 – Bad Request – The request was invalid or cannot be served. The exact error should be explained in the error payload. E.g. „The JSON is not valid“ - 401 – Unauthorized – The request requires an user authentication - 404 – Not found – There is no resource behind the URI.  - 500 – In # User roles  | Role                | Platform  | | ------------------- | --------- | | `admin`     | Admin | | `blc-mentoring`     | Mentoring | | `blc-coaching`      | Coaching  | | `company-mentoring` | Mentoring | | `company-coaching`  | Coaching  | | `mentor`            | Mentoring | | `mentee`            | Mentoring | | `coach`             | Coaching  | | `coachee`           | Coaching  |   # Status codes  - 200 – OK – Eyerything is working - 201 – OK – New resource has been created - 204 – OK – The resource was successfully deleted  - 400 – Bad Request – The request was invalid or cannot be served. The exact error should be explained in the error payload. E.g. „The JSON is not valid“ - 401 – Unauthorized – The request requires an user authentication - 404 – Not found – There is no resource behind the URI.  - 500 – Internal Server Error - Any other uncaught error.   # Pagination  All paginated endpoints will accept the following query string  | Key | Default | Description | | --- | --- | --- | | `limit` | 20 | The number of results per page. | | `page` | 1 | The page to return. |  And the result will contain the following  | Key | Description | | --- | --- | | `results` | The array of results. Empty array if no results (not null). | | `page` | The current page. | | `limit` |  The number of results per page. | | `total` | The total number of results. |   # Updating a list of items  Since the screens for updating a list of items have a \"Save\" button, that means that the user will modify the data (e.g. add/remove/update items), and then hit \"Save\" to make the transaction. Because of this, updating a list of items will be done with a single PUT request which contains the whole list of items after the update.  This makes things more simple, and separate request for creating/deleting/updating items do not make much sense in this case since you have a \"Save\" button for saving the whole list.  This only applies to lists of items that are not referenceable, for example studies, experience, contacts etc.   # Updating Sessions  The following fields can be updated for a session depending on it's state  | State       | Can be updated                   | Description                                                  | | ----------- | -------------------------------- | ------------------------------------------------------------ | | `Pending`   | `date`                           | The user cannot *update* a `pending` session, he must `schedule` it. To do so, he will need to set the `date` field. | | `Scheduled` | `date`                           | The user can update the `date` of a session while it is scheduled. | | `Done`      | `goals`, `achievements`, `files` | The user can update the `goals`, `achievements` and `files` of a session while it is done, but **not** the `date`. |   # Model Links  In places where a link to a model is needed, there is the `Link` model which contains an `ID` and a `name`.  For example, when displaying a process, we need to display a column for the coachee and a column for the company. However, we do not need all details about them directly in the table, but we probably still want to let the user click on it to get more details. So in this case, you can use the `Link` model to display the column but also let the user click on it to get more details.   # Uploading documents  Currently, the API for uploading documents accepts the following object  | Key    | Description                 | | ------ | --------------------------- | | `data` | Base64 encoded file.        | | `type` | Type of the file (e.g. pdf) | | `name` | The name of the file        |  The `name` and `type` here are required because the image will be uploaded by base64 encoding it, so we must send those details separately.  This could be solved by uploding the file directly using multipart file upload. However, I am not sure if `go-swagger` can correctly generate the handler for this. So you have 3 possible options:  - Investigate if `go-swagger` can correctly generate a handler for uploading files - Manually generate the handler for this case - Use the above object by manually setting the `type` and `name` # User roles  | Role                | Platform  | | ------------------- | --------- | | `admin`     | Admin | | `blc-mentoring`     | Mentoring | | `blc-coaching`      | Coaching  | | `company-mentoring` | Mentoring | | `company-coaching`  | Coaching  | | `mentor`            | Mentoring | | `mentee`            | Mentoring | | `coach`             | Coaching  | | `coachee`           | Coaching  |   # Status codes  - 200 – OK – Eyerything is working - 201 – OK – New resource has been created - 204 – OK – The resource was successfully deleted  - 400 – Bad Request – The request was invalid or cannot be served. The exact error should be explained in the error payload. E.g. „The JSON is not valid“ - 401 – Unauthorized – The request requires an user authentication - 404 – Not found – There is no resource behind the URI.  - 500 – In # User roles  | Role                | Platform  | | ------------------- | --------- | | `admin`     | Admin | | `blc-mentoring`     | Mentoring | | `blc-coaching`      | Coaching  | | `company-mentoring` | Mentoring | | `company-coaching`  | Coaching  | | `mentor`            | Mentoring | | `mentee`            | Mentoring | | `coach`             | Coaching  | | `coachee`           | Coaching  |   # Status codes  - 200 – OK – Eyerything is working - 201 – OK – New resource has been created - 204 – OK – The resource was successfully deleted  - 400 – Bad Request – The request was invalid or cannot be served. The exact error should be explained in the error payload. E.g. „The JSON is not valid“ - 401 – Unauthorized – The request requires an user authentication - 404 – Not found – There is no resource behind the URI.  - 500 – Internal Server Error - Any other uncaught error.   # Pagination  All paginated endpoints will accept the following query string  | Key | Default | Description | | --- | --- | --- | | `limit` | 20 | The number of results per page. | | `page` | 1 | The page to return. |  And the result will contain the following  | Key | Description | | --- | --- | | `results` | The array of results. Empty array if no results (not null). | | `page` | The current page. | | `limit` |  The number of results per page. | | `total` | The total number of results. |   # Updating a list of items  Since the screens for updating a list of items have a \"Save\" button, that means that the user will modify the data (e.g. add/remove/update items), and then hit \"Save\" to make the transaction. Because of this, updating a list of items will be done with a single PUT request which contains the whole list of items after the update.  This makes things more simple, and separate request for creating/deleting/updating items do not make much sense in this case since you have a \"Save\" button for saving the whole list.  This only applies to lists of items that are not referenceable, for example studies, experience, contacts etc.   # Updating Sessions  The following fields can be updated for a session depending on it's state  | State       | Can be updated                   | Description                                                  | | ----------- | -------------------------------- | ------------------------------------------------------------ | | `Pending`   | `date`                           | The user cannot *update* a `pending` session, he must `schedule` it. To do so, he will need to set the `date` field. | | `Scheduled` | `date`                           | The user can update the `date` of a session while it is scheduled. | | `Done`      | `goals`, `achievements`, `files` | The user can update the `goals`, `achievements` and `files` of a session while it is done, but **not** the `date`. |   # Model Links  In places where a link to a model is needed, there is the `Link` model which contains an `ID` and a `name`.  For example, when displaying a process, we need to display a column for the coachee and a column for the company. However, we do not need all details about them directly in the table, but we probably still want to let the user click on it to get more details. So in this case, you can use the `Link` model to display the column but also let the user click on it to get more details.   # Uploading documents  Currently, the API for uploading documents accepts the following object  | Key    | Description                 | | ------ | --------------------------- | | `data` | Base64 encoded file.        | | `type` | Type of the file (e.g. pdf) | | `name` | The name of the file        |  The `name` and `type` here are required because the image will be uploaded by base64 encoding it, so we must send those details separately.  This could be solved by uploding the file directly using multipart file upload. However, I am not sure if `go-swagger` can correctly generate the handler for this. So you have 3 possible options:  - Investigate if `go-swagger` can correctly generate a handler for uploading files - Manually generate the handler for this case - Use the above object by manually setting the `type` and `name` # User roles  | Role                | Platform  | | ------------------- | --------- | | `admin`     | Admin | | `blc-mentoring`     | Mentoring | | `blc-coaching`      | Coaching  | | `company-mentoring` | Mentoring | | `company-coaching`  | Coaching  | | `mentor`            | Mentoring | | `mentee`            | Mentoring | | `coach`             | Coaching  | | `coachee`           | Coaching  |   # Status codes  - 200 – OK – Eyerything is working - 201 – OK – New resource has been created - 204 – OK – The resource was successfully deleted  - 400 – Bad Request – The request was invalid or cannot be served. The exact error should be explained in the error payload. E.g. „The JSON is not valid“ - 401 – Unauthorized – The request requires an user authentication - 404 – Not found – There is no resource behind the URI.  - 500 – Internal Server Error - Any other uncaught error.   # Pagination  All paginated endpoints will accept the following query string  | Key | Default | Description | | --- | --- | --- | | `limit` | 20 | The number of results per page. | | `page` | 1 | The page to return. |  And the result will contain the following  | Key | Description | | --- | --- | | `results` | The array of results. Empty array if no results (not null). | | `page` | The current page. | | `limit` |  The number of results per page. | | `total` | The total number of results. |   # Updating a list of items  Since the screens for updating a list of items have a \"Save\" button, that means that the user will modify the data (e.g. add/remove/update items), and then hit \"Save\" to make the transaction. Because of this, updating a list of items will be done with a single PUT request which contains the whole list of items after the update.  This makes things more simple, and separate request for creating/deleting/updating items do not make much sense in this case since you have a \"Save\" button for saving the whole list.  This only applies to lists of items that are not referenceable, for example studies, experience, contacts etc.   # Updating Sessions  The following fields can be updated for a session depending on it's state  | State       | Can be updated                   | Description                                                  | | ----------- | -------------------------------- | ------------------------------------------------------------ | | `Pending`   | `date`                           | The user cannot *update* a `pending` session, he must `schedule` it. To do so, he will need to set the `date` field. | | `Scheduled` | `date`                           | The user can update the `date` of a session while it is scheduled. | | `Done`      | `goals`, `achievements`, `files` | The user can update the `goals`, `achievements` and `files` of a session while it is done, but **not** the `date`. |   # Model Links  In places where a link to a model is needed, there is the `Link` model which contains an `ID` and a `name`.  For example, when displaying a process, we need to display a column for the coachee and a column for the company. However, we do not need all details about them directly in the table, but we probably still want to let the user click on it to get more details. So in this case, you can use the `Link` model to display the column but also let the user click on it to get more details.   # Uploading documents  Currently, the API for uploading documents accepts the following object  | Key    | Description                 | | ------ | --------------------------- | | `data` | Base64 encoded file.        | | `type` | Type of the file (e.g. pdf) | | `name` | The name of the file        |  The `name` and `type` here are required because the image will be uploaded by base64 encoding it, so we must send those details separately.  This could be solved by uploding the file directly using multipart file upload. However, I am not sure if `go-swagger` can correctly generate the handler for this. So you have 3 possible options:  - Investigate if `go-swagger` can correctly generate a handler for uploading files - Manually generate the handler for this case - Use the above object by manually setting the `type` and `name`
 *
 * OpenAPI spec version:
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as url from 'url'
import * as portableFetch from 'portable-fetch'
import { Configuration } from './configuration'

const BASE_PATH = 'http://localhost:3000/v1'.replace(/\/+$/, '')

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
  csv: ',',
  ssv: ' ',
  tsv: '\t',
  pipes: '|',
}

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
  (url: string, init?: any): Promise<Response>
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
  url: string
  options: any
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
  protected configuration: Configuration

  constructor(
    configuration?: Configuration,
    protected basePath: string = BASE_PATH,
    protected fetch: FetchAPI = portableFetch
  ) {
    if (configuration) {
      this.configuration = configuration
      this.basePath = configuration.basePath || this.basePath
    }
  }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
  name: 'RequiredError'
  constructor(public field: string, msg?: string) {
    super(msg)
  }
}

/**
 *
 * @export
 * @interface AccountInfo
 */
export interface AccountInfo {
  /**
   *
   * @type {string}
   * @memberof AccountInfo
   */
  email: string
  /**
   *
   * @type {AccountType}
   * @memberof AccountInfo
   */
  type: AccountType
  /**
   *
   * @type {boolean}
   * @memberof AccountInfo
   */
  active: boolean
}

/**
 *
 * @export
 * @enum {string}
 */
export enum AccountType {
  Admin = <any>'admin',
  Coach = <any>'coach',
  Coachee = <any>'coachee',
  Mentor = <any>'mentor',
  Mentee = <any>'mentee',
  CompanyMentoring = <any>'company-mentoring',
  CompanyCoaching = <any>'company-coaching',
  BlcMentoring = <any>'blc-mentoring',
  BlcCoaching = <any>'blc-coaching',
}

/**
 *
 * @export
 * @enum {string}
 */
export enum AccountTypeInvitation {
  Coach = <any>'coach',
  Coachee = <any>'coachee',
  Mentor = <any>'mentor',
  Mentee = <any>'mentee',
  CompanyMentoring = <any>'company-mentoring',
  CompanyCoaching = <any>'company-coaching',
}

/**
 *
 * @export
 * @interface AuthResponse
 */
export interface AuthResponse {
  /**
   *
   * @type {string}
   * @memberof AuthResponse
   */
  token: string
  /**
   *
   * @type {AccountType}
   * @memberof AuthResponse
   */
  type: AccountType
}

/**
 *
 * @export
 * @interface Body
 */
export interface Body {
  /**
   *
   * @type {string}
   * @memberof Body
   */
  commitment: string
  /**
   *
   * @type {string}
   * @memberof Body
   */
  superiorCommitment: string
  /**
   *
   * @type {boolean}
   * @memberof Body
   */
  done?: boolean
}

/**
 *
 * @export
 * @interface Body1
 */
export interface Body1 {
  /**
   *
   * @type {string}
   * @memberof Body1
   */
  commitment: string
  /**
   *
   * @type {string}
   * @memberof Body1
   */
  superiorCommitment: string
  /**
   *
   * @type {boolean}
   * @memberof Body1
   */
  done?: boolean
}

/**
 *
 * @export
 * @interface Body10
 */
export interface Body10 {
  /**
   *
   * @type {string}
   * @memberof Body10
   */
  token: string
  /**
   *
   * @type {string}
   * @memberof Body10
   */
  password: string
  /**
   *
   * @type {PersonalInfo}
   * @memberof Body10
   */
  personal: PersonalInfo
  /**
   *
   * @type {Array&lt;Study&gt;}
   * @memberof Body10
   */
  studies: Array<Study>
  /**
   *
   * @type {Array&lt;Experience&gt;}
   * @memberof Body10
   */
  experience: Array<Experience>
}

/**
 *
 * @export
 * @interface Body11
 */
export interface Body11 {
  /**
   *
   * @type {boolean}
   * @memberof Body11
   */
  automaticMatch: boolean
  /**
   *
   * @type {string}
   * @memberof Body11
   */
  automaticMatchEmailList: string
  /**
   *
   * @type {number}
   * @memberof Body11
   */
  companyId: number
  /**
   *
   * @type {ProgramDetails}
   * @memberof Body11
   */
  details: ProgramDetails
  /**
   *
   * @type {Array&lt;ProcessLink&gt;}
   * @memberof Body11
   */
  processes: Array<ProcessLink>
  /**
   *
   * @type {boolean}
   * @memberof Body11
   */
  finalEvaluation: boolean
}

/**
 *
 * @export
 * @interface Body12
 */
export interface Body12 {
  /**
   *
   * @type {string}
   * @memberof Body12
   */
  token: string
  /**
   *
   * @type {string}
   * @memberof Body12
   */
  password: string
  /**
   *
   * @type {PersonalInfo}
   * @memberof Body12
   */
  personal: PersonalInfo
  /**
   *
   * @type {Array&lt;Study&gt;}
   * @memberof Body12
   */
  studies: Array<Study>
  /**
   *
   * @type {Array&lt;Experience&gt;}
   * @memberof Body12
   */
  experience: Array<Experience>
}

/**
 *
 * @export
 * @interface Body13
 */
export interface Body13 {
  /**
   *
   * @type {string}
   * @memberof Body13
   */
  email: string
}

/**
 *
 * @export
 * @interface Body14
 */
export interface Body14 {
  /**
   *
   * @type {string}
   * @memberof Body14
   */
  token: string
  /**
   *
   * @type {string}
   * @memberof Body14
   */
  password: string
}

/**
 *
 * @export
 * @interface Body15
 */
export interface Body15 {
  /**
   *
   * @type {string}
   * @memberof Body15
   */
  name: string
  /**
   *
   * @type {number}
   * @memberof Body15
   */
  sessions: number
  /**
   *
   * @type {Array&lt;ProcessLinkWithId&gt;}
   * @memberof Body15
   */
  processes: Array<ProcessLinkWithId>
  /**
   *
   * @type {boolean}
   * @memberof Body15
   */
  automaticMatch: boolean
  /**
   *
   * @type {string}
   * @memberof Body15
   */
  automaticMatchEmailList?: string
}

/**
 *
 * @export
 * @interface Body16
 */
export interface Body16 {
  /**
   * Only updateable if the session is not done UNIXTIME
   * @type {number}
   * @memberof Body16
   */
  date?: number
  /**
   *
   * @type {string}
   * @memberof Body16
   */
  goals?: string
  /**
   *
   * @type {string}
   * @memberof Body16
   */
  achievements?: string
}

/**
 *
 * @export
 * @interface Body17
 */
export interface Body17 {
  /**
   *
   * @type {number}
   * @memberof Body17
   */
  date: number
}

/**
 *
 * @export
 * @interface Body18
 */
export interface Body18 {
  /**
   *
   * @type {string}
   * @memberof Body18
   */
  goals: string
  /**
   *
   * @type {string}
   * @memberof Body18
   */
  achievements: string
}

/**
 *
 * @export
 * @interface Body19
 */
export interface Body19 {
  /**
   *
   * @type {string}
   * @memberof Body19
   */
  summary: string
}

/**
 *
 * @export
 * @interface Body2
 */
export interface Body2 {
  /**
   *
   * @type {string}
   * @memberof Body2
   */
  indicators?: string
}

/**
 *
 * @export
 * @interface Body20
 */
export interface Body20 {
  /**
   *
   * @type {Array&lt;Study&gt;}
   * @memberof Body20
   */
  studies: Array<Study>
  /**
   *
   * @type {Array&lt;CoachingExperience&gt;}
   * @memberof Body20
   */
  experience: Array<CoachingExperience>
  /**
   *
   * @type {Array&lt;CoachingCertificate&gt;}
   * @memberof Body20
   */
  certificates: Array<CoachingCertificate>
}

/**
 *
 * @export
 * @interface Body21
 */
export interface Body21 {
  /**
   *
   * @type {string}
   * @memberof Body21
   */
  currentPassword: string
  /**
   *
   * @type {string}
   * @memberof Body21
   */
  newPassword: string
}

/**
 *
 * @export
 * @interface Body22
 */
export interface Body22 {
  /**
   *
   * @type {string}
   * @memberof Body22
   */
  email: string
  /**
   *
   * @type {AccountTypeInvitation}
   * @memberof Body22
   */
  type: AccountTypeInvitation
}

/**
 *
 * @export
 * @interface Body3
 */
export interface Body3 {
  /**
   *
   * @type {string}
   * @memberof Body3
   */
  challenge: string
  /**
   *
   * @type {string}
   * @memberof Body3
   */
  objectives: string
  /**
   *
   * @type {boolean}
   * @memberof Body3
   */
  done?: boolean
}

/**
 *
 * @export
 * @interface Body4
 */
export interface Body4 {
  /**
   *
   * @type {string}
   * @memberof Body4
   */
  token: string
  /**
   *
   * @type {string}
   * @memberof Body4
   */
  password: string
  /**
   *
   * @type {PersonalInfo}
   * @memberof Body4
   */
  personal: PersonalInfo
  /**
   *
   * @type {Array&lt;Study&gt;}
   * @memberof Body4
   */
  studies: Array<Study>
  /**
   *
   * @type {Array&lt;Experience&gt;}
   * @memberof Body4
   */
  experience: Array<Experience>
  /**
   *
   * @type {Boss}
   * @memberof Body4
   */
  boss: Boss
}

/**
 *
 * @export
 * @interface Body5
 */
export interface Body5 {
  /**
   * This is the registration token which comes from the registration link sent by email.
   * @type {string}
   * @memberof Body5
   */
  token: string
  /**
   *
   * @type {string}
   * @memberof Body5
   */
  password: string
  /**
   *
   * @type {PersonalInfo}
   * @memberof Body5
   */
  personal: PersonalInfo
  /**
   *
   * @type {Array&lt;Study&gt;}
   * @memberof Body5
   */
  studies: Array<Study>
  /**
   *
   * @type {Array&lt;Experience&gt;}
   * @memberof Body5
   */
  experience: Array<Experience>
  /**
   *
   * @type {Array&lt;Study&gt;}
   * @memberof Body5
   */
  coachingStudies: Array<Study>
  /**
   *
   * @type {Array&lt;CoachingExperience&gt;}
   * @memberof Body5
   */
  coachingExperience: Array<CoachingExperience>
  /**
   *
   * @type {Array&lt;CoachingCertificate&gt;}
   * @memberof Body5
   */
  coachingCertificates: Array<CoachingCertificate>
}

/**
 *
 * @export
 * @interface Body6
 */
export interface Body6 {
  /**
   *
   * @type {boolean}
   * @memberof Body11
   */
  automaticMatch: boolean
  /**
   *
   * @type {string}
   * @memberof Body11
   */
  automaticMatchEmailList: string
  /**
   *
   * @type {number}
   * @memberof Body6
   */
  companyId: number
  /**
   *
   * @type {ProgramDetails}
   * @memberof Body6
   */
  details: ProgramDetails
  /**
   *
   * @type {ProgramTripartita}
   * @memberof Body6
   */
  tripartita: ProgramTripartita
  /**
   *
   * @type {Array&lt;ProcessLink&gt;}
   * @memberof Body6
   */
  processes: Array<ProcessLink>
  /**
   *
   * @type {Array&lt;CoachingprogramCoachPrices&gt;}
   * @memberof Body6
   */
  coachPrices: Array<CoachingprogramCoachPrices>
  /**
   *
   * @type {ProgramPrices}
   * @memberof Body6
   */
  prices: ProgramPrices
  /**
   *
   * @type {boolean}
   * @memberof Body6
   */
  finalEvaluation: boolean
}

/**
 *
 * @export
 * @interface Body7
 */
export interface Body7 {
  /**
   *
   * @type {CompanyDetails}
   * @memberof Body7
   */
  details: CompanyDetails
  /**
   *
   * @type {Contacts}
   * @memberof Body7
   */
  contacts: Contacts
}

/**
 *
 * @export
 * @interface Body8
 */
export interface Body8 {
  /**
   *
   * @type {string}
   * @memberof Body8
   */
  email: string
  /**
   *
   * @type {string}
   * @memberof Body8
   */
  type: Body8.TypeEnum
  /**
   *
   * @type {CompanyDetails}
   * @memberof Body8
   */
  details: CompanyDetails
  /**
   *
   * @type {Array&lt;Contact&gt;}
   * @memberof Body8
   */
  contacts: Array<Contact>
}

/**
 * @export
 * @namespace Body8
 */
export namespace Body8 {
  /**
   * @export
   * @enum {string}
   */
  export enum TypeEnum {
    Mentoring = <any>'company-mentoring',
    Coaching = <any>'company-coaching',
  }
}

/**
 *
 * @export
 * @interface Body9
 */
export interface Body9 {
  /**
   *
   * @type {string}
   * @memberof Body9
   */
  token: string
  /**
   *
   * @type {string}
   * @memberof Body9
   */
  password: string
}

/**
 *
 * @export
 * @interface Boss
 */
export interface Boss {
  /**
   *
   * @type {string}
   * @memberof Boss
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof Boss
   */
  position: string
}

/**
 *
 * @export
 * @interface CoachingCertificate
 */
export interface CoachingCertificate {
  /**
   *
   * @type {string}
   * @memberof CoachingCertificate
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof CoachingCertificate
   */
  grade: string
  /**
   *
   * @type {number}
   * @memberof CoachingCertificate
   */
  hours: number
}

/**
 *
 * @export
 * @interface CoachingExperience
 */
export interface CoachingExperience {
  /**
   *
   * @type {Sector}
   * @memberof CoachingExperience
   */
  sector: Sector
  /**
   *
   * @type {string}
   * @memberof CoachingExperience
   */
  company: string
}

/**
 *
 * @export
 * @interface CoachingInfo
 */
export interface CoachingInfo {
  /**
   *
   * @type {Array&lt;Study&gt;}
   * @memberof CoachingInfo
   */
  studies: Array<Study>
  /**
   *
   * @type {Array&lt;CoachingExperience&gt;}
   * @memberof CoachingInfo
   */
  experience: Array<CoachingExperience>
  /**
   *
   * @type {Array&lt;CoachingCertificate&gt;}
   * @memberof CoachingInfo
   */
  certificates: Array<CoachingCertificate>
}

/**
 *
 * @export
 * @interface CoachingprogramCoachPrices
 */
export interface CoachingprogramCoachPrices {
  /**
   *
   * @type {string}
   * @memberof CoachingprogramCoachPrices
   */
  email: string
  /**
   *
   * @type {number}
   * @memberof CoachingprogramCoachPrices
   */
  price: number
}

/**
 *
 * @export
 * @interface Companies
 */
export interface Companies extends Array<Company> {}

/**
 *
 * @export
 * @interface Company
 */
export interface Company extends CompanyDetails {
  /**
   *
   * @type {number}
   * @memberof Company
   */
  id: number
  /**
   *
   * @type {Contacts}
   * @memberof Company
   */
  contacts?: Contacts
}

/**
 *
 * @export
 * @interface CompanyDetails
 */
export interface CompanyDetails {
  /**
   *
   * @type {string}
   * @memberof CompanyDetails
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof CompanyDetails
   */
  cif: string
  /**
   *
   * @type {string}
   * @memberof CompanyDetails
   */
  address: string
  /**
   *
   * @type {string}
   * @memberof CompanyDetails
   */
  phone?: string
  /**
   *
   * @type {string}
   * @memberof CompanyDetails
   */
  mobile: string
  /**
   *
   * @type {string}
   * @memberof CompanyDetails
   */
  contactName: string
}

/**
 *
 * @export
 * @interface Contact
 */
export interface Contact {
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  email: string
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  position: string
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  company: string
  /**
   *
   * @type {Sector}
   * @memberof Contact
   */
  sector: Sector
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  phone?: string
  /**
   *
   * @type {string}
   * @memberof Contact
   */
  mobile: string
}

/**
 *
 * @export
 * @interface Contacts
 */
export interface Contacts extends Array<Contact> {}

/**
 *
 * @export
 * @interface Credentials
 */
export interface Credentials {
  /**
   *
   * @type {string}
   * @memberof Credentials
   */
  email: string
  /**
   *
   * @type {string}
   * @memberof Credentials
   */
  password: string
}

/**
 *
 * @export
 * @interface Error
 */
export interface Error {
  /**
   *
   * @type {string}
   * @memberof Error
   */
  message: string
  /**
   *
   * @type {number}
   * @memberof Error
   */
  code: number
}

/**
 *
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
  /**
   *
   * @type {Error}
   * @memberof ErrorResponse
   */
  error: Error
}

/**
 *
 * @export
 * @interface Experience
 */
export interface Experience {
  /**
   *
   * @type {string}
   * @memberof Experience
   */
  position: string
  /**
   *
   * @type {string}
   * @memberof Experience
   */
  company: string
  /**
   *
   * @type {Sector}
   * @memberof Experience
   */
  sector: Sector
  /**
   * UNIXTIME
   * @type {number}
   * @memberof Experience
   */
  start: number
  /**
   * UNIXTIME
   * @type {number}
   * @memberof Experience
   */
  end: number
}

/**
 *
 * @export
 * @enum {string}
 */
export enum ExportResourceType {
  Programs = <any>'programs',
  Processes = <any>'processes',
  Sessions = <any>'sessions',
  Mentors = <any>'mentors',
  Mentees = <any>'mentees',
  Companies = <any>'companies',
}

/**
 *
 * @export
 * @interface FinalEvaluation
 */
export interface FinalEvaluation {
  /**
   *
   * @type {number}
   * @memberof FinalEvaluation
   */
  id?: number
  /**
   *
   * @type {string}
   * @memberof FinalEvaluation
   */
  summary?: string
  /**
   *
   * @type {boolean}
   * @memberof FinalEvaluation
   */
  done: boolean
}

/**
 *
 * @export
 * @interface FinalTripartita
 */
export interface FinalTripartita {
  /**
   *
   * @type {string}
   * @memberof FinalTripartita
   */
  commitment?: string
  /**
   *
   * @type {string}
   * @memberof FinalTripartita
   */
  superiorCommitment?: string
  /**
   *
   * @type {boolean}
   * @memberof FinalTripartita
   */
  done: boolean
  /**
   *
   * @type {number}
   * @memberof FinalTripartita
   */
  id: number
}

/**
 *
 * @export
 * @enum {string}
 */
export enum Gender {
  M = <any>'m',
  F = <any>'f',
}

/**
 *
 * @export
 * @interface InitialTripartita
 */
export interface InitialTripartita {
  /**
   *
   * @type {string}
   * @memberof InitialTripartita
   */
  challenge?: string
  /**
   *
   * @type {string}
   * @memberof InitialTripartita
   */
  objectives?: string
  /**
   *
   * @type {string}
   * @memberof InitialTripartita
   */
  indicators?: string
  /**
   *
   * @type {boolean}
   * @memberof InitialTripartita
   */
  done: boolean
  /**
   *
   * @type {number}
   * @memberof InitialTripartita
   */
  id: number
}

/**
 *
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse200
   */
  file?: string
}

/**
 *
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
  /**
   *
   * @type {Companies}
   * @memberof InlineResponse2001
   */
  results: Companies
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  limit: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse2001
   */
  total: number
}

/**
 *
 * @export
 * @interface InlineResponse20010
 */
export interface InlineResponse20010 {
  /**
   *
   * @type {Array&lt;User&gt;}
   * @memberof InlineResponse20010
   */
  results: Array<User>
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  limit: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse20010
   */
  total: number
}

/**
 *
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
  /**
   *
   * @type {Resources}
   * @memberof InlineResponse2002
   */
  results: Resources
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  limit: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse2002
   */
  total: number
}

/**
 *
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
  /**
   *
   * @type {Sessions}
   * @memberof InlineResponse2003
   */
  results: Sessions
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  limit: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse2003
   */
  total: number
}

/**
 *
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 {
  /**
   *
   * @type {Programs}
   * @memberof InlineResponse2004
   */
  results: Programs
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  limit: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse2004
   */
  total: number
}

/**
 *
 * @export
 * @interface InlineResponse2005
 */
export interface InlineResponse2005 {
  /**
   *
   * @type {SessionsCompany}
   * @memberof InlineResponse2005
   */
  results: SessionsCompany
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  limit: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse2005
   */
  total: number
}

/**
 *
 * @export
 * @interface InlineResponse2006
 */
export interface InlineResponse2006 {
  /**
   *
   * @type {Processes}
   * @memberof InlineResponse2006
   */
  results: Processes
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  page: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  limit: number
  /**
   *
   * @type {number}
   * @memberof InlineResponse2006
   */
  total: number
}

/**
 *
 * @export
 * @interface InlineResponse2007
 */
export interface InlineResponse2007 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse2007
   */
  message?: string
}

/**
 *
 * @export
 * @interface InlineResponse2008
 */
export interface InlineResponse2008 {
  /**
   *
   * @type {Array&lt;Study&gt;}
   * @memberof InlineResponse2008
   */
  studies: Array<Study>
  /**
   *
   * @type {Array&lt;CoachingExperience&gt;}
   * @memberof InlineResponse2008
   */
  experience: Array<CoachingExperience>
  /**
   *
   * @type {Array&lt;CoachingCertificate&gt;}
   * @memberof InlineResponse2008
   */
  certificates: Array<CoachingCertificate>
}

/**
 *
 * @export
 * @interface InlineResponse2009
 */
export interface InlineResponse2009 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse2009
   */
  id: number
}

/**
 *
 * @export
 * @interface IntermediateTripartita
 */
export interface IntermediateTripartita {
  /**
   *
   * @type {string}
   * @memberof IntermediateTripartita
   */
  commitment?: string
  /**
   *
   * @type {string}
   * @memberof IntermediateTripartita
   */
  superiorCommitment?: string
  /**
   *
   * @type {boolean}
   * @memberof IntermediateTripartita
   */
  done: boolean
  /**
   *
   * @type {number}
   * @memberof IntermediateTripartita
   */
  id: number
}

/**
 *
 * @export
 * @interface Link
 */
export interface Link {
  /**
   *
   * @type {number}
   * @memberof Link
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof Link
   */
  name: string
}

/**
 *
 * @export
 * @interface PersonalInfo
 */
export interface PersonalInfo {
  /**
   *
   * @type {string}
   * @memberof PersonalInfo
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof PersonalInfo
   */
  surname: string
  /**
   *
   * @type {string}
   * @memberof PersonalInfo
   */
  dni: string
  /**
   *
   * @type {string}
   * @memberof PersonalInfo
   */
  phone?: string
  /**
   *
   * @type {string}
   * @memberof PersonalInfo
   */
  mobile: string
  /**
   * UNIX
   * @type {number}
   * @memberof PersonalInfo
   */
  birthday: number
  /**
   *
   * @type {Gender}
   * @memberof PersonalInfo
   */
  gender: Gender
  /**
   * If this is returned by the API (e.g. if you request a user's details), then it will be a URL to the photo.  If you are posting/updating the data, then it must be a base64 encoded image.
   * @type {string}
   * @memberof PersonalInfo
   */
  photo: string
  /**
   * UNIX
   * @type {number}
   * @memberof PersonalInfo
   */
  lastAccess: number
}

/**
 *
 * @export
 * @interface Process
 */
export interface Process {
  /**
   *
   * @type {number}
   * @memberof Process
   */
  id: number
  /**
   *
   * @type {ProcessStatus}
   * @memberof Process
   */
  status: ProcessStatus
  /**
   *
   * @type {ProcessAccountLink}
   * @memberof Process
   */
  teacher: ProcessAccountLink
  /**
   *
   * @type {Link}
   * @memberof Process
   */
  company: Link
  /**
   *
   * @type {ProcessAccountLink}
   * @memberof Process
   */
  student: ProcessAccountLink
  /**
   *
   * @type {boolean}
   * @memberof Process
   */
  isContractAccepted?: boolean
  /**
   *
   * @type {FinalEvaluation}
   * @memberof Process
   */
  finalEvaluation?: FinalEvaluation
}

/**
 *
 * @export
 * @interface ProcessAccountLink
 */
export interface ProcessAccountLink {
  /**
   *
   * @type {number}
   * @memberof ProcessAccountLink
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof ProcessAccountLink
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof ProcessAccountLink
   */
  email: string
  /**
   *
   * @type {boolean}
   * @memberof ProcessAccountLink
   */
  active: boolean
}

/**
 *
 * @export
 * @interface ProcessCompany
 */
export interface ProcessCompany {
  /**
   *
   * @type {number}
   * @memberof ProcessCompany
   */
  id: number
  /**
   *
   * @type {ProcessStatus}
   * @memberof ProcessCompany
   */
  status: ProcessStatus
  /**
   *
   * @type {Link}
   * @memberof ProcessCompany
   */
  account1: Link
  /**
   *
   * @type {Link}
   * @memberof ProcessCompany
   */
  account2: Link
  /**
   *
   * @type {number}
   * @memberof ProcessCompany
   */
  sessionsTotal: number
  /**
   *
   * @type {number}
   * @memberof ProcessCompany
   */
  sessionsDone: number
}

/**
 *
 * @export
 * @interface ProcessLink
 */
export interface ProcessLink {
  /**
   *
   * @type {string}
   * @memberof ProcessLink
   */
  student: string
  /**
   *
   * @type {string}
   * @memberof ProcessLink
   */
  teacher: string
}

/**
 *
 * @export
 * @interface ProcessLinkWithId
 */
export interface ProcessLinkWithId {
  /**
   *
   * @type {string}
   * @memberof ProcessLinkWithId
   */
  student: string
  /**
   *
   * @type {string}
   * @memberof ProcessLinkWithId
   */
  teacher: string
  /**
   * process id
   * @type {number}
   * @memberof ProcessLinkWithId
   */
  id?: number
}

/**
 *
 * @export
 * @enum {string}
 */
export enum ProcessStatus {
  Ongoing = <any>'ongoing',
  Done = <any>'done',
}

/**
 *
 * @export
 * @interface ProcessTripartita
 */
export interface ProcessTripartita {
  /**
   *
   * @type {InitialTripartita}
   * @memberof ProcessTripartita
   */
  initial?: InitialTripartita
  /**
   *
   * @type {IntermediateTripartita}
   * @memberof ProcessTripartita
   */
  intermediate?: IntermediateTripartita
  /**
   *
   * @type {FinalTripartita}
   * @memberof ProcessTripartita
   */
  _final?: FinalTripartita
}

/**
 *
 * @export
 * @interface Processes
 */
export interface Processes extends Array<Process> {}

/**
 *
 * @export
 * @interface ProcessesCompany
 */
export interface ProcessesCompany extends Array<ProcessCompany> {}

/**
 *
 * @export
 * @interface Program
 */
export interface Program {
  /**
   *
   * @type {number}
   * @memberof Program
   */
  id: number
  /**
   *
   * @type {ProgramDetails}
   * @memberof Program
   */
  details: ProgramDetails
  /**
   *
   * @type {Company}
   * @memberof Program
   */
  company: Company
  /**
   *
   * @type {ProgramTripartita}
   * @memberof Program
   */
  tripartita?: ProgramTripartita
  /**
   *
   * @type {number}
   * @memberof Program
   */
  completed: number
  /**
   *
   * @type {ProgramPrices}
   * @memberof Program
   */
  prices?: ProgramPrices
}

/**
 *
 * @export
 * @interface ProgramDetails
 */
export interface ProgramDetails {
  /**
   *
   * @type {string}
   * @memberof ProgramDetails
   */
  name: string
  /**
   * UNIXTIME
   * @type {number}
   * @memberof ProgramDetails
   */
  start: number
  end: number
  deleted: number
  /**
   *
   * @type {number}
   * @memberof ProgramDetails
   */
  sessions: number
}

/**
 *
 * @export
 * @interface ProgramPrices
 */
export interface ProgramPrices {
  /**
   *
   * @type {number}
   * @memberof ProgramPrices
   */
  companyPrice: number
  /**
   *
   * @type {number}
   * @memberof ProgramPrices
   */
  coachPrice: number
}

/**
 *
 * @export
 * @interface ProgramTripartita
 */
export interface ProgramTripartita {
  /**
   *
   * @type {boolean}
   * @memberof ProgramTripartita
   */
  initial: boolean
  /**
   *
   * @type {boolean}
   * @memberof ProgramTripartita
   */
  intermediate: boolean
  /**
   *
   * @type {boolean}
   * @memberof ProgramTripartita
   */
  _final: boolean
}

/**
 *
 * @export
 * @interface Programs
 */
export interface Programs extends Array<Program> {}

/**
 *
 * @export
 * @interface Resource
 */
export interface Resource {
  /**
   *
   * @type {number}
   * @memberof Resource
   */
  id: number
  /**
   *
   * @type {string}
   * @memberof Resource
   */
  name: string
  /**
   *
   * @type {Link}
   * @memberof Resource
   */
  by: Link
  /**
   * UNIXTIME
   * @type {number}
   * @memberof Resource
   */
  uploadedOn: number
  /**
   *
   * @type {string}
   * @memberof Resource
   */
  url: string
}

/**
 *
 * @export
 * @interface Resources
 */
export interface Resources extends Array<Resource> {}

/**
 *
 * @export
 * @enum {string}
 */
export enum Sector {
  BusinessAdministration = <any>'business-administration',
  PublicAdministration = <any>'public-administration',
  CustomerService = <any>'customer-service',
  Audiovisual = <any>'audiovisual',
  BeautyWellness = <any>'beauty-wellness',
  Sales = <any>'sales',
  Logistics = <any>'logistics',
  Design = <any>'design',
  Education = <any>'education',
  Coaching = <any>'coaching',
  Finance = <any>'finance',
  It = <any>'it',
  Engineering = <any>'engineering',
  Construction = <any>'construction',
  Research = <any>'research',
  Justice = <any>'justice',
  Music = <any>'music',
  Manufacturing = <any>'manufacturing',
  Machinery = <any>'machinery',
  Other = <any>'other',
  Health = <any>'health',
  Security = <any>'security',
  Transportation = <any>'transportation',
  Tourism = <any>'tourism',
}

/**
 *
 * @export
 * @interface Session
 */
export interface Session extends SessionDetails {
  /**
   *
   * @type {number}
   * @memberof Session
   */
  id: number
  /**
   *
   * @type {boolean}
   * @memberof Session
   */
  done: boolean
  /**
   *
   * @type {Array&lt;Resource&gt;}
   * @memberof Session
   */
  resources: Array<Resource>
}

/**
 *
 * @export
 * @interface SessionCompany
 */
export interface SessionCompany {
  /**
   *
   * @type {number}
   * @memberof SessionCompany
   */
  id: number
  /**
   *
   * @type {SessionStatus}
   * @memberof SessionCompany
   */
  status: SessionStatus
  /**
   * UNIXTIME
   * @type {number}
   * @memberof SessionCompany
   */
  date: number
}

/**
 *
 * @export
 * @interface SessionDetails
 */
export interface SessionDetails {
  /**
   * UNIXTIME
   * @type {number}
   * @memberof SessionDetails
   */
  date?: number
  /**
   *
   * @type {string}
   * @memberof SessionDetails
   */
  goals?: string
  /**
   *
   * @type {string}
   * @memberof SessionDetails
   */
  achievements?: string
  /**
   *
   * @type {SessionStatus}
   * @memberof SessionDetails
   */
  status: SessionStatus
}

/**
 *
 * @export
 * @enum {string}
 */
export enum SessionStatus {
  Pending = <any>'pending',
  Scheduled = <any>'scheduled',
  Done = <any>'done',
}

/**
 *
 * @export
 * @interface Sessions
 */
export interface Sessions extends Array<Session> {}

/**
 *
 * @export
 * @interface SessionsCompany
 */
export interface SessionsCompany extends Array<SessionCompany> {}

/**
 *
 * @export
 * @interface Study
 */
export interface Study {
  /**
   *
   * @type {string}
   * @memberof Study
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof Study
   */
  school: string
}

/**
 *
 * @export
 * @interface User
 */
export interface User {
  /**
   *
   * @type {number}
   * @memberof User
   */
  id: number
  /**
   *
   * @type {AccountInfo}
   * @memberof User
   */
  account: AccountInfo
  /**
   *
   * @type {PersonalInfo}
   * @memberof User
   */
  personal: PersonalInfo
  /**
   *
   * @type {Array&lt;Study&gt;}
   * @memberof User
   */
  studies: Array<Study>
  /**
   *
   * @type {Array&lt;Experience&gt;}
   * @memberof User
   */
  experience: Array<Experience>
  /**
   *
   * @type {CoachingInfo}
   * @memberof User
   */
  coaching?: CoachingInfo
  /**
   *
   * @type {Boss}
   * @memberof User
   */
  boss?: Boss
}

/**
 * BLCApi - fetch parameter creator
 * @export
 */
export const BLCApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling acceptContract.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/accept-contract`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Check User
     * @param {string} email
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkUser(email: string, type: string, options: any = {}): FetchArgs {
      // verify required parameter 'email' is not null or undefined
      if (email === null || email === undefined) {
        throw new RequiredError(
          'email',
          'Required parameter email was null or undefined when calling checkUser.'
        )
      }
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling checkUser.'
        )
      }
      const localVarPath = `/users/{email}/{type}`
        .replace(`{${'email'}}`, encodeURIComponent(String(email)))
        .replace(`{${'type'}}`, encodeURIComponent(String(type)))
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(evaluationId: number, options: any = {}): FetchArgs {
      // verify required parameter 'evaluationId' is not null or undefined
      if (evaluationId === null || evaluationId === undefined) {
        throw new RequiredError(
          'evaluationId',
          'Required parameter evaluationId was null or undefined when calling completeEvaluation.'
        )
      }
      const localVarPath = `/programs/processes/evaluations/{evaluationId}/complete`.replace(
        `{${'evaluationId'}}`,
        encodeURIComponent(String(evaluationId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(
      sessionId: number,
      body: Body18,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling completeSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling completeSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/complete`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body18' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create Coaching Program
     * @param {Body6} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCoachingProgram(body: Body6, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling createCoachingProgram.'
        )
      }
      const localVarPath = `/coaching/program`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body6' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create Company
     * @param {Body8} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCompany(body: Body8, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling createCompany.'
        )
      }
      const localVarPath = `/companies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body8' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create Mentoring Program
     * @param {Body11} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMentoringProgram(body: Body11, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling createMentoringProgram.'
        )
      }
      const localVarPath = `/mentoring/program`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body11' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Remove Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcess(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling deleteProcess.'
        )
      }
      const localVarPath = `/programs/process/{processId}`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign(
        { method: 'DELETE' },
        options
      )
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(userId: number, options: any = {}): FetchArgs {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling deleteUser.'
        )
      }
      const localVarPath = `/users/{userId}`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign(
        { method: 'DELETE' },
        options
      )
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportCompanies(
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/export/companies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling exportProcesses.'
        )
      }
      const localVarPath = `/export/programs/{programId}/processes`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportPrograms(
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/export/programs`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportSessions(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling exportSessions.'
        )
      }
      const localVarPath = `/export/programs/processes/{ProcessId}/sessions`.replace(
        `{${'ProcessId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Users
     * @param {string} type
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportUsers(
      type: string,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling exportUsers.'
        )
      }
      const localVarPath = `/export/users`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling forgotPassword.'
        )
      }
      const localVarPath = `/password/forgot`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body13' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanies(limit?: number, page?: number, options: any = {}): FetchArgs {
      const localVarPath = `/companies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Company
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompany(companyId: number, options: any = {}): FetchArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          'companyId',
          'Required parameter companyId was null or undefined when calling getCompany.'
        )
      }
      const localVarPath = `/companies/{companyId}`.replace(
        `{${'companyId'}}`,
        encodeURIComponent(String(companyId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(type?: string, options: any = {}): FetchArgs {
      const localVarPath = `/user/experience`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },

    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLastAccess(type?: string, options: any = {}): FetchArgs {
      const localVarPath = `/user/lastaccess`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(options: any = {}): FetchArgs {
      const localVarPath = `/user/personal`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getProcess.'
        )
      }
      const localVarPath = `/programs/process/{processId}`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getProcessResources.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/resources`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling getProcesses.'
        )
      }
      const localVarPath = `/programs/{programId}/processes`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Program
     * @param {number} programId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProgram(programId: number, options: any = {}): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling getProgram.'
        )
      }
      const localVarPath = `/programs/{programId}`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(limit?: number, page?: number, options: any = {}): FetchArgs {
      const localVarPath = `/programs`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
     getProgramsFinished(limit?: number, page?: number, options: any = {}): FetchArgs {
      const localVarPath = `/programs/finished`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getSessions.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/sessions`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * This is only called by BLC and it doesn't include the session details, since they are not allowed to see it.
     * @summary List Sessions Company
     * @param {string} programId
     * @param {string} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsForCompany(
      programId: string,
      processId: string,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling getSessionsForCompany.'
        )
      }
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getSessionsForCompany.'
        )
      }
      const localVarPath = `/programs/{programId}/processes/{processId}/sessions-company`
        .replace(`{${'programId'}}`, encodeURIComponent(String(programId)))
        .replace(`{${'processId'}}`, encodeURIComponent(String(processId)))
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(type?: string, options: any = {}): FetchArgs {
      const localVarPath = `/user/studies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(userId: number, options: any = {}): FetchArgs {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling getUser.'
        )
      }
      const localVarPath = `/users/{userId}`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Users
     * @param {string} type The type of the account, e.g. \&quot;coach\&quot;, \&quot;coachee\&quot;
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers(
      type: string,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling getUsers.'
        )
      }
      const localVarPath = `/users`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Invite User
     * @param {Body22} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteUser(body: Body22, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling inviteUser.'
        )
      }
      const localVarPath = `/users/invite`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body22' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(processID: number, options: any = {}): FetchArgs {
      // verify required parameter 'processID' is not null or undefined
      if (processID === null || processID === undefined) {
        throw new RequiredError(
          'processID',
          'Required parameter processID was null or undefined when calling listTripartita.'
        )
      }
      const localVarPath = `/programs/processes/{processID}/tripartita`.replace(
        `{${'processID'}}`,
        encodeURIComponent(String(processID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(body: Credentials, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling loginCoaching.'
        )
      }
      const localVarPath = `/coaching/login`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Credentials' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(body: Credentials, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling loginMentoring.'
        )
      }
      const localVarPath = `/mentoring/login`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Credentials' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coachee Register
     * @param {Body4} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoachee(body: Body4, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerCoachee.'
        )
      }
      const localVarPath = `/coachees`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body4' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling resetPassword.'
        )
      }
      const localVarPath = `/password/reset`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body14' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(
      sessionId: number,
      body: Body17,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling scheduleSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling scheduleSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/schedule`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body17' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Company
     * @param {number} companyId
     * @param {Body7} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompany(
      companyId: number,
      body: Body7,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          'companyId',
          'Required parameter companyId was null or undefined when calling updateCompany.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateCompany.'
        )
      }
      const localVarPath = `/companies/{companyId}`.replace(
        `{${'companyId'}}`,
        encodeURIComponent(String(companyId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body7' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(
      evaluationId: number,
      body: Body19,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'evaluationId' is not null or undefined
      if (evaluationId === null || evaluationId === undefined) {
        throw new RequiredError(
          'evaluationId',
          'Required parameter evaluationId was null or undefined when calling updateEvaluation.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateEvaluation.'
        )
      }
      const localVarPath = `/programs/processes/evaluations/{evaluationId}`.replace(
        `{${'evaluationId'}}`,
        encodeURIComponent(String(evaluationId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body19' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(
      type: string,
      body: Array<Experience>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling updateExperience.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateExperience.'
        )
      }
      const localVarPath = `/user/experience/{type}`.replace(
        `{${'type'}}`,
        encodeURIComponent(String(type))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Array&lt;Experience&gt;' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Final
     * @param {number} tripartitaID
     * @param {Body1} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinalTripartita(
      tripartitaID: number,
      body: Body1,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateFinalTripartita.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateFinalTripartita.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/final`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body1' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Initial Coach
     * @param {number} tripartitaID
     * @param {Body3} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoach(
      tripartitaID: number,
      body: Body3,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateInitialTripartitaCoach.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateInitialTripartitaCoach.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/initial/coach`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body3' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Initial Coachee
     * @param {number} tripartitaID
     * @param {Body2} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoachee(
      tripartitaID: number,
      body: Body2,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateInitialTripartitaCoachee.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateInitialTripartitaCoachee.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/initial/coachee`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body2' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateIntermediateTripartita.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateIntermediateTripartita.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/intermediate`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(body: Body21, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updatePassword.'
        )
      }
      const localVarPath = `/user/password`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body21' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(body: PersonalInfo, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updatePersonalInfo.'
        )
      }
      const localVarPath = `/user/personal`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'PersonalInfo' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Program
     * @param {number} programId
     * @param {Body15} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProgram(
      programId: number,
      body: Body15,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling updateProgram.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateProgram.'
        )
      }
      const localVarPath = `/programs/{programId}`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body15' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },

    /**
     *
     * @summary Remove Process
     * @param {number} programId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
     deleteProgram(programId: number, body: Body15, options: any = {}): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling deleteProgram.'
        )
      }
      const localVarPath = `/programs/{programId}`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign(
        { method: 'DELETE' },
        options
      )
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      const needsSerialization =
      <any>'Body15' !== 'string' ||
      localVarRequestOptions.headers['Content-Type'] === 'application/json'
    localVarRequestOptions.body = needsSerialization
      ? JSON.stringify(body || {})
      : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },


    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(
      sessionId: number,
      body: Body16,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling updateSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body16' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },

    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSession(
      sessionId: number,
      body: Body16,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling updateSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign(
        { method: 'DELETE' },
        options
      )
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body16' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(
      type: string,
      body: Array<Study>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling updateStudies.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateStudies.'
        )
      }
      const localVarPath = `/user/studies/{type}`.replace(
        `{${'type'}}`,
        encodeURIComponent(String(type))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Array&lt;Study&gt;' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(
      processId: number,
      file: any,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling uploadProcessResource.'
        )
      }
      // verify required parameter 'file' is not null or undefined
      if (file === null || file === undefined) {
        throw new RequiredError(
          'file',
          'Required parameter file was null or undefined when calling uploadProcessResource.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/resources`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new url.URLSearchParams()

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (file !== undefined) {
        localVarFormParams.set('file', file as any)
      }

      localVarHeaderParameter['Content-Type'] =
        'application/x-www-form-urlencoded'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      localVarRequestOptions.body = localVarFormParams.toString()

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * BLCApi - functional programming interface
 * @export
 */
export const BLCApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).acceptContract(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Check User
     * @param {string} email
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkUser(
      email: string,
      type: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).checkUser(email, type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(
      evaluationId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).completeEvaluation(evaluationId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(
      sessionId: number,
      body: Body18,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).completeSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Create Coaching Program
     * @param {Body6} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCoachingProgram(
      body: Body6,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Program> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).createCoachingProgram(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Create Company
     * @param {Body8} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCompany(
      body: Body8,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).createCompany(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Create Mentoring Program
     * @param {Body11} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMentoringProgram(
      body: Body11,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Program> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).createMentoringProgram(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Remove Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcess(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).deleteProcess(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Delete User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(
      userId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).deleteUser(userId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportCompanies(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).exportCompanies(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).exportProcesses(programId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportPrograms(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).exportPrograms(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).exportSessions(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Users
     * @param {string} type
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportUsers(
      type: string,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).exportUsers(type, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(
      body: Body13,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).forgotPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanies(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2001> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).getCompanies(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Company
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompany(
      companyId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).getCompany(companyId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(
      type?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Experience>> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).getExperience(type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
/**
     *
     * @summary Get getLastAccess
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLastAccess(
      type?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Experience>> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).getExperience(type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },

    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<PersonalInfo> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).getPersonalInfo(options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Process> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).getProcess(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2002> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).getProcessResources(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2006> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).getProcesses(programId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Program
     * @param {number} programId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProgram(
      programId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Program> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).getProgram(programId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2004> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).getPrograms(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    }, 
    /**
    *
    * @summary List Programs
    * @param {number} [limit]
    * @param {number} [page]
    * @param {*} [options] Override http request option.
    * @throws {RequiredError}
    */
   getProgramsFinished(
     limit?: number,
     page?: number,
     options?: any
   ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2004> {
     const localVarFetchArgs = BLCApiFetchParamCreator(
       configuration
     ).getProgramsFinished(limit, page, options)
     return (
       fetch: FetchAPI = portableFetch,
       basePath: string = BASE_PATH
     ) => {
       return fetch(
         basePath + localVarFetchArgs.url,
         localVarFetchArgs.options
       ).then((response) => {
         if (response.status >= 200 && response.status < 300) {
           return response.json()
         } else {
           throw response
         }
       })
     }
   },
    /**
     *
     * @summary Remove Process
     * @param {number} programId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
     deleteProgram(
      programId: number,  
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).deleteProgram(programId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2003> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).getSessions(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * This is only called by BLC and it doesn't include the session details, since they are not allowed to see it.
     * @summary List Sessions Company
     * @param {string} programId
     * @param {string} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsForCompany(
      programId: string,
      processId: string,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2005> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).getSessionsForCompany(programId, processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(
      type?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Study>> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).getStudies(type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(
      userId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<User> {
      const localVarFetchArgs = BLCApiFetchParamCreator(configuration).getUser(
        userId,
        options
      )
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Users
     * @param {string} type The type of the account, e.g. \&quot;coach\&quot;, \&quot;coachee\&quot;
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers(
      type: string,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20010> {
      const localVarFetchArgs = BLCApiFetchParamCreator(configuration).getUsers(
        type,
        limit,
        page,
        options
      )
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Invite User
     * @param {Body22} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteUser(
      body: Body22,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2009> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).inviteUser(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(
      processID: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<ProcessTripartita> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).listTripartita(processID, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(
      body: Credentials,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).loginCoaching(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(
      body: Credentials,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).loginMentoring(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coachee Register
     * @param {Body4} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoachee(
      body: Body4,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).registerCoachee(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(
      body: Body14,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).resetPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(
      sessionId: number,
      body: Body17,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).scheduleSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Company
     * @param {number} companyId
     * @param {Body7} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompany(
      companyId: number,
      body: Body7,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).updateCompany(companyId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(
      evaluationId: number,
      body: Body19,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<FinalEvaluation> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).updateEvaluation(evaluationId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(
      type: string,
      body: Array<Experience>,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Experience>> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).updateExperience(type, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Final
     * @param {number} tripartitaID
     * @param {Body1} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinalTripartita(
      tripartitaID: number,
      body: Body1,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<FinalTripartita> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).updateFinalTripartita(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Initial Coach
     * @param {number} tripartitaID
     * @param {Body3} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoach(
      tripartitaID: number,
      body: Body3,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InitialTripartita> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).updateInitialTripartitaCoach(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Initial Coachee
     * @param {number} tripartitaID
     * @param {Body2} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoachee(
      tripartitaID: number,
      body: Body2,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InitialTripartita> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).updateInitialTripartitaCoachee(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<IntermediateTripartita> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).updateIntermediateTripartita(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(
      body: Body21,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).updatePassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(
      body: PersonalInfo,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<PersonalInfo> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).updatePersonalInfo(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Program
     * @param {number} programId
     * @param {Body15} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProgram(
      programId: number,
      body: Body15,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Program> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).updateProgram(programId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(
      sessionId: number,
      body: Body16,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Session> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).updateSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },

    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteSession(
      sessionId: number,
      body: Body16,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Session> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).deleteSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(
      type: string,
      body: Array<Study>,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Study>> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).updateStudies(type, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(
      processId: number,
      file: any,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Resource> {
      const localVarFetchArgs = BLCApiFetchParamCreator(
        configuration
      ).uploadProcessResource(processId, file, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * BLCApi - factory interface
 * @export
 */
export const BLCApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(processId: number, options?: any) {
      return BLCApiFp(configuration).acceptContract(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Check User
     * @param {string} email
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkUser(email: string, type: string, options?: any) {
      return BLCApiFp(configuration).checkUser(
        email,
        type,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(evaluationId: number, options?: any) {
      return BLCApiFp(configuration).completeEvaluation(evaluationId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(sessionId: number, body: Body18, options?: any) {
      return BLCApiFp(configuration).completeSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Create Coaching Program
     * @param {Body6} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCoachingProgram(body: Body6, options?: any) {
      return BLCApiFp(configuration).createCoachingProgram(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Create Company
     * @param {Body8} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCompany(body: Body8, options?: any) {
      return BLCApiFp(configuration).createCompany(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Create Mentoring Program
     * @param {Body11} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMentoringProgram(body: Body11, options?: any) {
      return BLCApiFp(configuration).createMentoringProgram(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Remove Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcess(processId: number, options?: any) {
      return BLCApiFp(configuration).deleteProcess(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Delete User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(userId: number, options?: any) {
      return BLCApiFp(configuration).deleteUser(userId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportCompanies(limit?: number, page?: number, options?: any) {
      return BLCApiFp(configuration).exportCompanies(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return BLCApiFp(configuration).exportProcesses(
        programId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportPrograms(limit?: number, page?: number, options?: any) {
      return BLCApiFp(configuration).exportPrograms(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return BLCApiFp(configuration).exportSessions(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Users
     * @param {string} type
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportUsers(type: string, limit?: number, page?: number, options?: any) {
      return BLCApiFp(configuration).exportUsers(
        type,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options?: any) {
      return BLCApiFp(configuration).forgotPassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanies(limit?: number, page?: number, options?: any) {
      return BLCApiFp(configuration).getCompanies(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Company
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompany(companyId: number, options?: any) {
      return BLCApiFp(configuration).getCompany(companyId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(type?: string, options?: any) {
      return BLCApiFp(configuration).getExperience(type, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(options?: any) {
      return BLCApiFp(configuration).getPersonalInfo(options)(fetch, basePath)
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: number, options?: any) {
      return BLCApiFp(configuration).getProcess(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return BLCApiFp(configuration).getProcessResources(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return BLCApiFp(configuration).getProcesses(
        programId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Program
     * @param {number} programId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProgram(programId: number, options?: any) {
      return BLCApiFp(configuration).getProgram(programId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(limit?: number, page?: number, options?: any) {
      return BLCApiFp(configuration).getPrograms(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return BLCApiFp(configuration).getSessions(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     * This is only called by BLC and it doesn't include the session details, since they are not allowed to see it.
     * @summary List Sessions Company
     * @param {string} programId
     * @param {string} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsForCompany(
      programId: string,
      processId: string,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return BLCApiFp(configuration).getSessionsForCompany(
        programId,
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(type?: string, options?: any) {
      return BLCApiFp(configuration).getStudies(type, options)(fetch, basePath)
    },
    /**
     *
     * @summary Get User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(userId: number, options?: any) {
      return BLCApiFp(configuration).getUser(userId, options)(fetch, basePath)
    },
    /**
     *
     * @summary List Users
     * @param {string} type The type of the account, e.g. \&quot;coach\&quot;, \&quot;coachee\&quot;
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers(type: string, limit?: number, page?: number, options?: any) {
      return BLCApiFp(configuration).getUsers(
        type,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Invite User
     * @param {Body22} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteUser(body: Body22, options?: any) {
      return BLCApiFp(configuration).inviteUser(body, options)(fetch, basePath)
    },
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(processID: number, options?: any) {
      return BLCApiFp(configuration).listTripartita(processID, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(body: Credentials, options?: any) {
      return BLCApiFp(configuration).loginCoaching(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(body: Credentials, options?: any) {
      return BLCApiFp(configuration).loginMentoring(body, options)(
        fetch,
        basePath
      )
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coachee Register
     * @param {Body4} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoachee(body: Body4, options?: any) {
      return BLCApiFp(configuration).registerCoachee(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options?: any) {
      return BLCApiFp(configuration).resetPassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(sessionId: number, body: Body17, options?: any) {
      return BLCApiFp(configuration).scheduleSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Company
     * @param {number} companyId
     * @param {Body7} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompany(companyId: number, body: Body7, options?: any) {
      return BLCApiFp(configuration).updateCompany(
        companyId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(evaluationId: number, body: Body19, options?: any) {
      return BLCApiFp(configuration).updateEvaluation(
        evaluationId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(type: string, body: Array<Experience>, options?: any) {
      return BLCApiFp(configuration).updateExperience(
        type,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Final
     * @param {number} tripartitaID
     * @param {Body1} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinalTripartita(tripartitaID: number, body: Body1, options?: any) {
      return BLCApiFp(configuration).updateFinalTripartita(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Initial Coach
     * @param {number} tripartitaID
     * @param {Body3} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoach(
      tripartitaID: number,
      body: Body3,
      options?: any
    ) {
      return BLCApiFp(configuration).updateInitialTripartitaCoach(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Initial Coachee
     * @param {number} tripartitaID
     * @param {Body2} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoachee(
      tripartitaID: number,
      body: Body2,
      options?: any
    ) {
      return BLCApiFp(configuration).updateInitialTripartitaCoachee(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options?: any
    ) {
      return BLCApiFp(configuration).updateIntermediateTripartita(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(body: Body21, options?: any) {
      return BLCApiFp(configuration).updatePassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(body: PersonalInfo, options?: any) {
      return BLCApiFp(configuration).updatePersonalInfo(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Program
     * @param {number} programId
     * @param {Body15} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProgram(programId: number, body: Body15, options?: any) {
      return BLCApiFp(configuration).updateProgram(
        programId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(sessionId: number, body: Body16, options?: any) {
      return BLCApiFp(configuration).updateSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(type: string, body: Array<Study>, options?: any) {
      return BLCApiFp(configuration).updateStudies(
        type,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(processId: number, file: any, options?: any) {
      return BLCApiFp(configuration).uploadProcessResource(
        processId,
        file,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * BLCApi - object-oriented interface
 * @export
 * @class BLCApi
 * @extends {BaseAPI}
 */
export class BLCApi extends BaseAPI {
  /**
   *
   * @summary Accept contract
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public acceptContract(processId: number, options?: any) {
    return BLCApiFp(this.configuration).acceptContract(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Check User
   * @param {} email
   * @param {} type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public checkUser(email: string, type: string, options?: any) {
    return BLCApiFp(this.configuration).checkUser(
      email,
      type,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Complete Evaluation
   * @param {} evaluationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public completeEvaluation(evaluationId: number, options?: any) {
    return BLCApiFp(this.configuration).completeEvaluation(
      evaluationId,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Complete Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public completeSession(sessionId: number, body: Body18, options?: any) {
    return BLCApiFp(this.configuration).completeSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Create Coaching Program
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public createCoachingProgram(body: Body6, options?: any) {
    return BLCApiFp(this.configuration).createCoachingProgram(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Create Company
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public createCompany(body: Body8, options?: any) {
    return BLCApiFp(this.configuration).createCompany(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Create Mentoring Program
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public createMentoringProgram(body: Body11, options?: any) {
    return BLCApiFp(this.configuration).createMentoringProgram(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Remove Process
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public deleteProcess(processId: number, options?: any) {
    return BLCApiFp(this.configuration).deleteProcess(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Delete User
   * @param {} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public deleteUser(userId: number, options?: any) {
    return BLCApiFp(this.configuration).deleteUser(userId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Companies
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public exportCompanies(limit?: number, page?: number, options?: any) {
    return BLCApiFp(this.configuration).exportCompanies(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Processes
   * @param {} programId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public exportProcesses(
    programId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return BLCApiFp(this.configuration).exportProcesses(
      programId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Programs
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public exportPrograms(limit?: number, page?: number, options?: any) {
    return BLCApiFp(this.configuration).exportPrograms(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Sessions
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public exportSessions(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return BLCApiFp(this.configuration).exportSessions(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Users
   * @param {} type
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public exportUsers(
    type: string,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return BLCApiFp(this.configuration).exportUsers(
      type,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   * Sends a mail with the reset link for the given email.
   * @summary Forgot password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public forgotPassword(body: Body13, options?: any) {
    return BLCApiFp(this.configuration).forgotPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Companies
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getCompanies(limit?: number, page?: number, options?: any) {
    return BLCApiFp(this.configuration).getCompanies(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Company
   * @param {} companyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getCompany(companyId: number, options?: any) {
    return BLCApiFp(this.configuration).getCompany(companyId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Experience
   * @param {} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getExperience(type?: string, options?: any) {
    return BLCApiFp(this.configuration).getExperience(type, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get getLastAccess
   * @param {} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getLastAccess(type?: string, options?: any) {
    return BLCApiFp(this.configuration).getLastAccess(type, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Personal Info
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getPersonalInfo(options?: any) {
    return BLCApiFp(this.configuration).getPersonalInfo(options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Process
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getProcess(processId: number, options?: any) {
    return BLCApiFp(this.configuration).getProcess(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Process Resources
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getProcessResources(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return BLCApiFp(this.configuration).getProcessResources(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Processes
   * @param {} programId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getProcesses(
    programId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return BLCApiFp(this.configuration).getProcesses(
      programId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Program
   * @param {} programId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getProgram(programId: number, options?: any) {
    return BLCApiFp(this.configuration).getProgram(programId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Programs
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getPrograms(limit?: number, page?: number, options?: any) {
    return BLCApiFp(this.configuration).getPrograms(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Programs
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
   public getProgramsFinished(limit?: number, page?: number, options?: any) {
    return BLCApiFp(this.configuration).getProgramsFinished(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Sessions
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getSessions(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return BLCApiFp(this.configuration).getSessions(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   * This is only called by BLC and it doesn't include the session details, since they are not allowed to see it.
   * @summary List Sessions Company
   * @param {} programId
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getSessionsForCompany(
    programId: string,
    processId: string,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return BLCApiFp(this.configuration).getSessionsForCompany(
      programId,
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Studies
   * @param {} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getStudies(type?: string, options?: any) {
    return BLCApiFp(this.configuration).getStudies(type, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get User
   * @param {} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getUser(userId: number, options?: any) {
    return BLCApiFp(this.configuration).getUser(userId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Users
   * @param {} type The type of the account, e.g. \&quot;coach\&quot;, \&quot;coachee\&quot;
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public getUsers(type: string, limit?: number, page?: number, options?: any) {
    return BLCApiFp(this.configuration).getUsers(
      type,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Invite User
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public inviteUser(body: Body22, options?: any) {
    return BLCApiFp(this.configuration).inviteUser(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Tripartita
   * @param {} processID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public listTripartita(processID: number, options?: any) {
    return BLCApiFp(this.configuration).listTripartita(processID, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Coaching Login
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public loginCoaching(body: Credentials, options?: any) {
    return BLCApiFp(this.configuration).loginCoaching(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Mentoring Login
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public loginMentoring(body: Credentials, options?: any) {
    return BLCApiFp(this.configuration).loginMentoring(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * # Note  The `photo` in `personal` is a base64 encoded image.
   * @summary Coachee Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public registerCoachee(body: Body4, options?: any) {
    return BLCApiFp(this.configuration).registerCoachee(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Reset password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public resetPassword(body: Body14, options?: any) {
    return BLCApiFp(this.configuration).resetPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Schedule Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public scheduleSession(sessionId: number, body: Body17, options?: any) {
    return BLCApiFp(this.configuration).scheduleSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Company
   * @param {} companyId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public updateCompany(companyId: number, body: Body7, options?: any) {
    return BLCApiFp(this.configuration).updateCompany(
      companyId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Evaluation
   * @param {} evaluationId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public updateEvaluation(evaluationId: number, body: Body19, options?: any) {
    return BLCApiFp(this.configuration).updateEvaluation(
      evaluationId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Experience
   * @param {} type
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public updateExperience(
    type: string,
    body: Array<Experience>,
    options?: any
  ) {
    return BLCApiFp(this.configuration).updateExperience(
      type,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Final
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public updateFinalTripartita(
    tripartitaID: number,
    body: Body1,
    options?: any
  ) {
    return BLCApiFp(this.configuration).updateFinalTripartita(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Initial Coach
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public updateInitialTripartitaCoach(
    tripartitaID: number,
    body: Body3,
    options?: any
  ) {
    return BLCApiFp(this.configuration).updateInitialTripartitaCoach(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Initial Coachee
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public updateInitialTripartitaCoachee(
    tripartitaID: number,
    body: Body2,
    options?: any
  ) {
    return BLCApiFp(this.configuration).updateInitialTripartitaCoachee(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Intermediate
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public updateIntermediateTripartita(
    tripartitaID: number,
    body: Body,
    options?: any
  ) {
    return BLCApiFp(this.configuration).updateIntermediateTripartita(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Change password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public updatePassword(body: Body21, options?: any) {
    return BLCApiFp(this.configuration).updatePassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Personal Info
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public updatePersonalInfo(body: PersonalInfo, options?: any) {
    return BLCApiFp(this.configuration).updatePersonalInfo(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Program
   * @param {} programId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public updateProgram(programId: number, body: Body15, options?: any) {
    return BLCApiFp(this.configuration).updateProgram(
      programId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  public deleteProgram(programId: number, options?: any) {
    return BLCApiFp(this.configuration).deleteProgram(
      programId,
      options
    )(this.fetch, this.basePath)
  }

  /**
   * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
   * @summary Update Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public updateSession(sessionId: number, body: Body16, options?: any) {
    return BLCApiFp(this.configuration).updateSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
   * @summary Update Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public deleteSession(
    sessionId: number,
    processId: any,
    body: Body16,
    options?: any
  ) {
    return BLCApiFp(this.configuration).deleteSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Studies
   * @param {} type
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public updateStudies(type: string, body: Array<Study>, options?: any) {
    return BLCApiFp(this.configuration).updateStudies(
      type,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Upload Process Resource
   * @param {} processId
   * @param {} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BLCApi
   */
  public uploadProcessResource(processId: number, file: any, options?: any) {
    return BLCApiFp(this.configuration).uploadProcessResource(
      processId,
      file,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * CoachApi - fetch parameter creator
 * @export
 */
export const CoachApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(evaluationId: number, options: any = {}): FetchArgs {
      // verify required parameter 'evaluationId' is not null or undefined
      if (evaluationId === null || evaluationId === undefined) {
        throw new RequiredError(
          'evaluationId',
          'Required parameter evaluationId was null or undefined when calling completeEvaluation.'
        )
      }
      const localVarPath = `/programs/processes/evaluations/{evaluationId}/complete`.replace(
        `{${'evaluationId'}}`,
        encodeURIComponent(String(evaluationId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(
      sessionId: number,
      body: Body18,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling completeSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling completeSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/complete`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body18' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling forgotPassword.'
        )
      }
      const localVarPath = `/password/forgot`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body13' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Coaching
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCoaching(options: any = {}): FetchArgs {
      const localVarPath = `/user/coaching`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(type?: string, options: any = {}): FetchArgs {
      const localVarPath = `/user/experience`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(options: any = {}): FetchArgs {
      const localVarPath = `/user/personal`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getProcess.'
        )
      }
      const localVarPath = `/programs/process/{processId}`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getProcessResources.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/resources`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling getProcesses.'
        )
      }
      const localVarPath = `/programs/{programId}/processes`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(limit?: number, page?: number, options: any = {}): FetchArgs {
      const localVarPath = `/programs`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(sessionId: number, options: any = {}): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling getSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling getSessionResources.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/resources`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getSessions.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/sessions`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(type?: string, options: any = {}): FetchArgs {
      const localVarPath = `/user/studies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(processID: number, options: any = {}): FetchArgs {
      // verify required parameter 'processID' is not null or undefined
      if (processID === null || processID === undefined) {
        throw new RequiredError(
          'processID',
          'Required parameter processID was null or undefined when calling listTripartita.'
        )
      }
      const localVarPath = `/programs/processes/{processID}/tripartita`.replace(
        `{${'processID'}}`,
        encodeURIComponent(String(processID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(body: Credentials, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling loginCoaching.'
        )
      }
      const localVarPath = `/coaching/login`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Credentials' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coach Register
     * @param {Body5} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoach(body: Body5, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerCoach.'
        )
      }
      const localVarPath = `/coaches`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body5' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling resetPassword.'
        )
      }
      const localVarPath = `/password/reset`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body14' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(
      sessionId: number,
      body: Body17,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling scheduleSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling scheduleSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/schedule`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body17' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Coaching
     * @param {Body20} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCoaching(body: Body20, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateCoaching.'
        )
      }
      const localVarPath = `/user/coaching`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body20' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(
      evaluationId: number,
      body: Body19,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'evaluationId' is not null or undefined
      if (evaluationId === null || evaluationId === undefined) {
        throw new RequiredError(
          'evaluationId',
          'Required parameter evaluationId was null or undefined when calling updateEvaluation.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateEvaluation.'
        )
      }
      const localVarPath = `/programs/processes/evaluations/{evaluationId}`.replace(
        `{${'evaluationId'}}`,
        encodeURIComponent(String(evaluationId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body19' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(
      type: string,
      body: Array<Experience>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling updateExperience.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateExperience.'
        )
      }
      const localVarPath = `/user/experience/{type}`.replace(
        `{${'type'}}`,
        encodeURIComponent(String(type))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Array&lt;Experience&gt;' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Final
     * @param {number} tripartitaID
     * @param {Body1} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinalTripartita(
      tripartitaID: number,
      body: Body1,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateFinalTripartita.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateFinalTripartita.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/final`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body1' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Initial Coach
     * @param {number} tripartitaID
     * @param {Body3} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoach(
      tripartitaID: number,
      body: Body3,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateInitialTripartitaCoach.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateInitialTripartitaCoach.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/initial/coach`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body3' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateIntermediateTripartita.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateIntermediateTripartita.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/intermediate`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(body: Body21, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updatePassword.'
        )
      }
      const localVarPath = `/user/password`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body21' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(body: PersonalInfo, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updatePersonalInfo.'
        )
      }
      const localVarPath = `/user/personal`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'PersonalInfo' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(
      sessionId: number,
      body: Body16,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling updateSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body16' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(
      type: string,
      body: Array<Study>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling updateStudies.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateStudies.'
        )
      }
      const localVarPath = `/user/studies/{type}`.replace(
        `{${'type'}}`,
        encodeURIComponent(String(type))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Array&lt;Study&gt;' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(
      processId: number,
      file: any,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling uploadProcessResource.'
        )
      }
      // verify required parameter 'file' is not null or undefined
      if (file === null || file === undefined) {
        throw new RequiredError(
          'file',
          'Required parameter file was null or undefined when calling uploadProcessResource.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/resources`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new url.URLSearchParams()

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (file !== undefined) {
        localVarFormParams.set('file', file as any)
      }

      localVarHeaderParameter['Content-Type'] =
        'application/x-www-form-urlencoded'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      localVarRequestOptions.body = localVarFormParams.toString()

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Upload Session Resource
     * @param {number} sessionId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionResource(
      sessionId: number,
      file: any,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling uploadSessionResource.'
        )
      }
      // verify required parameter 'file' is not null or undefined
      if (file === null || file === undefined) {
        throw new RequiredError(
          'file',
          'Required parameter file was null or undefined when calling uploadSessionResource.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/resources`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new url.URLSearchParams()

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (file !== undefined) {
        localVarFormParams.set('file', file as any)
      }

      localVarHeaderParameter['Content-Type'] =
        'application/x-www-form-urlencoded'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      localVarRequestOptions.body = localVarFormParams.toString()

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CoachApi - functional programming interface
 * @export
 */
export const CoachApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(
      evaluationId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).completeEvaluation(evaluationId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(
      sessionId: number,
      body: Body18,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).completeSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(
      body: Body13,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).forgotPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Coaching
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCoaching(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2008> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).getCoaching(options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(
      type?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Experience>> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).getExperience(type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<PersonalInfo> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).getPersonalInfo(options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Process> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).getProcess(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2002> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).getProcessResources(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2006> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).getProcesses(programId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2004> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).getPrograms(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(
      sessionId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Session> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).getSession(sessionId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2002> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).getSessionResources(sessionId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2003> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).getSessions(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(
      type?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Study>> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).getStudies(type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(
      processID: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<ProcessTripartita> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).listTripartita(processID, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(
      body: Credentials,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).loginCoaching(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coach Register
     * @param {Body5} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoach(
      body: Body5,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).registerCoach(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(
      body: Body14,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).resetPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(
      sessionId: number,
      body: Body17,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).scheduleSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Coaching
     * @param {Body20} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCoaching(
      body: Body20,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2008> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).updateCoaching(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(
      evaluationId: number,
      body: Body19,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<FinalEvaluation> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).updateEvaluation(evaluationId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(
      type: string,
      body: Array<Experience>,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Experience>> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).updateExperience(type, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Final
     * @param {number} tripartitaID
     * @param {Body1} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinalTripartita(
      tripartitaID: number,
      body: Body1,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<FinalTripartita> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).updateFinalTripartita(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Initial Coach
     * @param {number} tripartitaID
     * @param {Body3} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoach(
      tripartitaID: number,
      body: Body3,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InitialTripartita> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).updateInitialTripartitaCoach(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<IntermediateTripartita> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).updateIntermediateTripartita(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(
      body: Body21,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).updatePassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(
      body: PersonalInfo,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<PersonalInfo> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).updatePersonalInfo(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(
      sessionId: number,
      body: Body16,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Session> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).updateSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(
      type: string,
      body: Array<Study>,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Study>> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).updateStudies(type, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(
      processId: number,
      file: any,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Resource> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).uploadProcessResource(processId, file, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Upload Session Resource
     * @param {number} sessionId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionResource(
      sessionId: number,
      file: any,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Resource> {
      const localVarFetchArgs = CoachApiFetchParamCreator(
        configuration
      ).uploadSessionResource(sessionId, file, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * CoachApi - factory interface
 * @export
 */
export const CoachApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(evaluationId: number, options?: any) {
      return CoachApiFp(configuration).completeEvaluation(
        evaluationId,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(sessionId: number, body: Body18, options?: any) {
      return CoachApiFp(configuration).completeSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options?: any) {
      return CoachApiFp(configuration).forgotPassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Coaching
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCoaching(options?: any) {
      return CoachApiFp(configuration).getCoaching(options)(fetch, basePath)
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(type?: string, options?: any) {
      return CoachApiFp(configuration).getExperience(type, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(options?: any) {
      return CoachApiFp(configuration).getPersonalInfo(options)(fetch, basePath)
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: number, options?: any) {
      return CoachApiFp(configuration).getProcess(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return CoachApiFp(configuration).getProcessResources(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return CoachApiFp(configuration).getProcesses(
        programId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(limit?: number, page?: number, options?: any) {
      return CoachApiFp(configuration).getPrograms(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(sessionId: number, options?: any) {
      return CoachApiFp(configuration).getSession(sessionId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return CoachApiFp(configuration).getSessionResources(
        sessionId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return CoachApiFp(configuration).getSessions(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(type?: string, options?: any) {
      return CoachApiFp(configuration).getStudies(type, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(processID: number, options?: any) {
      return CoachApiFp(configuration).listTripartita(processID, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(body: Credentials, options?: any) {
      return CoachApiFp(configuration).loginCoaching(body, options)(
        fetch,
        basePath
      )
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coach Register
     * @param {Body5} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoach(body: Body5, options?: any) {
      return CoachApiFp(configuration).registerCoach(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options?: any) {
      return CoachApiFp(configuration).resetPassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(sessionId: number, body: Body17, options?: any) {
      return CoachApiFp(configuration).scheduleSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Coaching
     * @param {Body20} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCoaching(body: Body20, options?: any) {
      return CoachApiFp(configuration).updateCoaching(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(evaluationId: number, body: Body19, options?: any) {
      return CoachApiFp(configuration).updateEvaluation(
        evaluationId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(type: string, body: Array<Experience>, options?: any) {
      return CoachApiFp(configuration).updateExperience(
        type,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Final
     * @param {number} tripartitaID
     * @param {Body1} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinalTripartita(tripartitaID: number, body: Body1, options?: any) {
      return CoachApiFp(configuration).updateFinalTripartita(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Initial Coach
     * @param {number} tripartitaID
     * @param {Body3} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoach(
      tripartitaID: number,
      body: Body3,
      options?: any
    ) {
      return CoachApiFp(configuration).updateInitialTripartitaCoach(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options?: any
    ) {
      return CoachApiFp(configuration).updateIntermediateTripartita(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(body: Body21, options?: any) {
      return CoachApiFp(configuration).updatePassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(body: PersonalInfo, options?: any) {
      return CoachApiFp(configuration).updatePersonalInfo(body, options)(
        fetch,
        basePath
      )
    },
    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(sessionId: number, body: Body16, options?: any) {
      return CoachApiFp(configuration).updateSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(type: string, body: Array<Study>, options?: any) {
      return CoachApiFp(configuration).updateStudies(
        type,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(processId: number, file: any, options?: any) {
      return CoachApiFp(configuration).uploadProcessResource(
        processId,
        file,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Upload Session Resource
     * @param {number} sessionId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionResource(sessionId: number, file: any, options?: any) {
      return CoachApiFp(configuration).uploadSessionResource(
        sessionId,
        file,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * CoachApi - object-oriented interface
 * @export
 * @class CoachApi
 * @extends {BaseAPI}
 */
export class CoachApi extends BaseAPI {
  /**
   *
   * @summary Complete Evaluation
   * @param {} evaluationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public completeEvaluation(evaluationId: number, options?: any) {
    return CoachApiFp(this.configuration).completeEvaluation(
      evaluationId,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Complete Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public completeSession(sessionId: number, body: Body18, options?: any) {
    return CoachApiFp(this.configuration).completeSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   * Sends a mail with the reset link for the given email.
   * @summary Forgot password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public forgotPassword(body: Body13, options?: any) {
    return CoachApiFp(this.configuration).forgotPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Coaching
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public getCoaching(options?: any) {
    return CoachApiFp(this.configuration).getCoaching(options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Experience
   * @param {} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public getExperience(type?: string, options?: any) {
    return CoachApiFp(this.configuration).getExperience(type, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Personal Info
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public getPersonalInfo(options?: any) {
    return CoachApiFp(this.configuration).getPersonalInfo(options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Process
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public getProcess(processId: number, options?: any) {
    return CoachApiFp(this.configuration).getProcess(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Process Resources
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public getProcessResources(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return CoachApiFp(this.configuration).getProcessResources(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Processes
   * @param {} programId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public getProcesses(
    programId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return CoachApiFp(this.configuration).getProcesses(
      programId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Programs
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public getPrograms(limit?: number, page?: number, options?: any) {
    return CoachApiFp(this.configuration).getPrograms(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Session
   * @param {} sessionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public getSession(sessionId: number, options?: any) {
    return CoachApiFp(this.configuration).getSession(sessionId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Session Resources
   * @param {} sessionId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public getSessionResources(
    sessionId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return CoachApiFp(this.configuration).getSessionResources(
      sessionId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Sessions
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public getSessions(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return CoachApiFp(this.configuration).getSessions(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Studies
   * @param {} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public getStudies(type?: string, options?: any) {
    return CoachApiFp(this.configuration).getStudies(type, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Tripartita
   * @param {} processID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public listTripartita(processID: number, options?: any) {
    return CoachApiFp(this.configuration).listTripartita(processID, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Coaching Login
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public loginCoaching(body: Credentials, options?: any) {
    return CoachApiFp(this.configuration).loginCoaching(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * # Note  The `photo` in `personal` is a base64 encoded image.
   * @summary Coach Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public registerCoach(body: Body5, options?: any) {
    return CoachApiFp(this.configuration).registerCoach(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Reset password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public resetPassword(body: Body14, options?: any) {
    return CoachApiFp(this.configuration).resetPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Schedule Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public scheduleSession(sessionId: number, body: Body17, options?: any) {
    return CoachApiFp(this.configuration).scheduleSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Coaching
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public updateCoaching(body: Body20, options?: any) {
    return CoachApiFp(this.configuration).updateCoaching(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Evaluation
   * @param {} evaluationId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public updateEvaluation(evaluationId: number, body: Body19, options?: any) {
    return CoachApiFp(this.configuration).updateEvaluation(
      evaluationId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Experience
   * @param {} type
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public updateExperience(
    type: string,
    body: Array<Experience>,
    options?: any
  ) {
    return CoachApiFp(this.configuration).updateExperience(
      type,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Final
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public updateFinalTripartita(
    tripartitaID: number,
    body: Body1,
    options?: any
  ) {
    return CoachApiFp(this.configuration).updateFinalTripartita(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Initial Coach
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public updateInitialTripartitaCoach(
    tripartitaID: number,
    body: Body3,
    options?: any
  ) {
    return CoachApiFp(this.configuration).updateInitialTripartitaCoach(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Intermediate
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public updateIntermediateTripartita(
    tripartitaID: number,
    body: Body,
    options?: any
  ) {
    return CoachApiFp(this.configuration).updateIntermediateTripartita(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Change password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public updatePassword(body: Body21, options?: any) {
    return CoachApiFp(this.configuration).updatePassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Personal Info
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public updatePersonalInfo(body: PersonalInfo, options?: any) {
    return CoachApiFp(this.configuration).updatePersonalInfo(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
   * @summary Update Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public updateSession(sessionId: number, body: Body16, options?: any) {
    return CoachApiFp(this.configuration).updateSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Studies
   * @param {} type
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public updateStudies(type: string, body: Array<Study>, options?: any) {
    return CoachApiFp(this.configuration).updateStudies(
      type,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Upload Process Resource
   * @param {} processId
   * @param {} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public uploadProcessResource(processId: number, file: any, options?: any) {
    return CoachApiFp(this.configuration).uploadProcessResource(
      processId,
      file,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Upload Session Resource
   * @param {} sessionId
   * @param {} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachApi
   */
  public uploadSessionResource(sessionId: number, file: any, options?: any) {
    return CoachApiFp(this.configuration).uploadSessionResource(
      sessionId,
      file,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * CoacheApi - fetch parameter creator
 * @export
 */
export const CoacheApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling acceptContract.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/accept-contract`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CoacheApi - functional programming interface
 * @export
 */
export const CoacheApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CoacheApiFetchParamCreator(
        configuration
      ).acceptContract(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * CoacheApi - factory interface
 * @export
 */
export const CoacheApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(processId: number, options?: any) {
      return CoacheApiFp(configuration).acceptContract(processId, options)(
        fetch,
        basePath
      )
    },
  }
}

/**
 * CoacheApi - object-oriented interface
 * @export
 * @class CoacheApi
 * @extends {BaseAPI}
 */
export class CoacheApi extends BaseAPI {
  /**
   *
   * @summary Accept contract
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheApi
   */
  public acceptContract(processId: number, options?: any) {
    return CoacheApiFp(this.configuration).acceptContract(processId, options)(
      this.fetch,
      this.basePath
    )
  }
}

/**
 * CoacheeApi - fetch parameter creator
 * @export
 */
export const CoacheeApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling acceptContract.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/accept-contract`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(evaluationId: number, options: any = {}): FetchArgs {
      // verify required parameter 'evaluationId' is not null or undefined
      if (evaluationId === null || evaluationId === undefined) {
        throw new RequiredError(
          'evaluationId',
          'Required parameter evaluationId was null or undefined when calling completeEvaluation.'
        )
      }
      const localVarPath = `/programs/processes/evaluations/{evaluationId}/complete`.replace(
        `{${'evaluationId'}}`,
        encodeURIComponent(String(evaluationId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling forgotPassword.'
        )
      }
      const localVarPath = `/password/forgot`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body13' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Boss
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBoss(options: any = {}): FetchArgs {
      const localVarPath = `/user/boss`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(type?: string, options: any = {}): FetchArgs {
      const localVarPath = `/user/experience`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(options: any = {}): FetchArgs {
      const localVarPath = `/user/personal`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getProcess.'
        )
      }
      const localVarPath = `/programs/process/{processId}`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getProcessResources.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/resources`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling getProcesses.'
        )
      }
      const localVarPath = `/programs/{programId}/processes`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(limit?: number, page?: number, options: any = {}): FetchArgs {
      const localVarPath = `/programs`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(sessionId: number, options: any = {}): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling getSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling getSessionResources.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/resources`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getSessions.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/sessions`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(type?: string, options: any = {}): FetchArgs {
      const localVarPath = `/user/studies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(processID: number, options: any = {}): FetchArgs {
      // verify required parameter 'processID' is not null or undefined
      if (processID === null || processID === undefined) {
        throw new RequiredError(
          'processID',
          'Required parameter processID was null or undefined when calling listTripartita.'
        )
      }
      const localVarPath = `/programs/processes/{processID}/tripartita`.replace(
        `{${'processID'}}`,
        encodeURIComponent(String(processID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(body: Credentials, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling loginCoaching.'
        )
      }
      const localVarPath = `/coaching/login`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Credentials' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coachee Register
     * @param {Body4} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoachee(body: Body4, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerCoachee.'
        )
      }
      const localVarPath = `/coachees`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body4' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling resetPassword.'
        )
      }
      const localVarPath = `/password/reset`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body14' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Boss
     * @param {Boss} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBoss(body: Boss, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateBoss.'
        )
      }
      const localVarPath = `/user/boss`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Boss' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(
      evaluationId: number,
      body: Body19,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'evaluationId' is not null or undefined
      if (evaluationId === null || evaluationId === undefined) {
        throw new RequiredError(
          'evaluationId',
          'Required parameter evaluationId was null or undefined when calling updateEvaluation.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateEvaluation.'
        )
      }
      const localVarPath = `/programs/processes/evaluations/{evaluationId}`.replace(
        `{${'evaluationId'}}`,
        encodeURIComponent(String(evaluationId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body19' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(
      type: string,
      body: Array<Experience>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling updateExperience.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateExperience.'
        )
      }
      const localVarPath = `/user/experience/{type}`.replace(
        `{${'type'}}`,
        encodeURIComponent(String(type))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Array&lt;Experience&gt;' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Initial Coachee
     * @param {number} tripartitaID
     * @param {Body2} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoachee(
      tripartitaID: number,
      body: Body2,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateInitialTripartitaCoachee.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateInitialTripartitaCoachee.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/initial/coachee`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body2' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateIntermediateTripartita.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateIntermediateTripartita.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/intermediate`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(body: Body21, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updatePassword.'
        )
      }
      const localVarPath = `/user/password`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body21' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(body: PersonalInfo, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updatePersonalInfo.'
        )
      }
      const localVarPath = `/user/personal`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'PersonalInfo' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(
      type: string,
      body: Array<Study>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling updateStudies.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateStudies.'
        )
      }
      const localVarPath = `/user/studies/{type}`.replace(
        `{${'type'}}`,
        encodeURIComponent(String(type))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Array&lt;Study&gt;' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CoacheeApi - functional programming interface
 * @export
 */
export const CoacheeApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).acceptContract(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(
      evaluationId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).completeEvaluation(evaluationId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(
      body: Body13,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).forgotPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Boss
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBoss(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Boss> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).getBoss(options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(
      type?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Experience>> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).getExperience(type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<PersonalInfo> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).getPersonalInfo(options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Process> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).getProcess(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2002> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).getProcessResources(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2006> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).getProcesses(programId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2004> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).getPrograms(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(
      sessionId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Session> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).getSession(sessionId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2002> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).getSessionResources(sessionId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2003> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).getSessions(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(
      type?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Study>> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).getStudies(type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(
      processID: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<ProcessTripartita> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).listTripartita(processID, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(
      body: Credentials,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).loginCoaching(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coachee Register
     * @param {Body4} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoachee(
      body: Body4,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).registerCoachee(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(
      body: Body14,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).resetPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Boss
     * @param {Boss} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBoss(
      body: Boss,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).updateBoss(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(
      evaluationId: number,
      body: Body19,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<FinalEvaluation> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).updateEvaluation(evaluationId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(
      type: string,
      body: Array<Experience>,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Experience>> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).updateExperience(type, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Initial Coachee
     * @param {number} tripartitaID
     * @param {Body2} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoachee(
      tripartitaID: number,
      body: Body2,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InitialTripartita> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).updateInitialTripartitaCoachee(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<IntermediateTripartita> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).updateIntermediateTripartita(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(
      body: Body21,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).updatePassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(
      body: PersonalInfo,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<PersonalInfo> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).updatePersonalInfo(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(
      type: string,
      body: Array<Study>,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Study>> {
      const localVarFetchArgs = CoacheeApiFetchParamCreator(
        configuration
      ).updateStudies(type, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * CoacheeApi - factory interface
 * @export
 */
export const CoacheeApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(processId: number, options?: any) {
      return CoacheeApiFp(configuration).acceptContract(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(evaluationId: number, options?: any) {
      return CoacheeApiFp(configuration).completeEvaluation(
        evaluationId,
        options
      )(fetch, basePath)
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options?: any) {
      return CoacheeApiFp(configuration).forgotPassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Boss
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBoss(options?: any) {
      return CoacheeApiFp(configuration).getBoss(options)(fetch, basePath)
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(type?: string, options?: any) {
      return CoacheeApiFp(configuration).getExperience(type, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(options?: any) {
      return CoacheeApiFp(configuration).getPersonalInfo(options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: number, options?: any) {
      return CoacheeApiFp(configuration).getProcess(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return CoacheeApiFp(configuration).getProcessResources(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return CoacheeApiFp(configuration).getProcesses(
        programId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(limit?: number, page?: number, options?: any) {
      return CoacheeApiFp(configuration).getPrograms(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(sessionId: number, options?: any) {
      return CoacheeApiFp(configuration).getSession(sessionId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return CoacheeApiFp(configuration).getSessionResources(
        sessionId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return CoacheeApiFp(configuration).getSessions(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(type?: string, options?: any) {
      return CoacheeApiFp(configuration).getStudies(type, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(processID: number, options?: any) {
      return CoacheeApiFp(configuration).listTripartita(processID, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(body: Credentials, options?: any) {
      return CoacheeApiFp(configuration).loginCoaching(body, options)(
        fetch,
        basePath
      )
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coachee Register
     * @param {Body4} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoachee(body: Body4, options?: any) {
      return CoacheeApiFp(configuration).registerCoachee(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options?: any) {
      return CoacheeApiFp(configuration).resetPassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Boss
     * @param {Boss} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBoss(body: Boss, options?: any) {
      return CoacheeApiFp(configuration).updateBoss(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(evaluationId: number, body: Body19, options?: any) {
      return CoacheeApiFp(configuration).updateEvaluation(
        evaluationId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(type: string, body: Array<Experience>, options?: any) {
      return CoacheeApiFp(configuration).updateExperience(
        type,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Initial Coachee
     * @param {number} tripartitaID
     * @param {Body2} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoachee(
      tripartitaID: number,
      body: Body2,
      options?: any
    ) {
      return CoacheeApiFp(configuration).updateInitialTripartitaCoachee(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options?: any
    ) {
      return CoacheeApiFp(configuration).updateIntermediateTripartita(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(body: Body21, options?: any) {
      return CoacheeApiFp(configuration).updatePassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(body: PersonalInfo, options?: any) {
      return CoacheeApiFp(configuration).updatePersonalInfo(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(type: string, body: Array<Study>, options?: any) {
      return CoacheeApiFp(configuration).updateStudies(
        type,
        body,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * CoacheeApi - object-oriented interface
 * @export
 * @class CoacheeApi
 * @extends {BaseAPI}
 */
export class CoacheeApi extends BaseAPI {
  /**
   *
   * @summary Accept contract
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public acceptContract(processId: number, options?: any) {
    return CoacheeApiFp(this.configuration).acceptContract(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Complete Evaluation
   * @param {} evaluationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public completeEvaluation(evaluationId: number, options?: any) {
    return CoacheeApiFp(this.configuration).completeEvaluation(
      evaluationId,
      options
    )(this.fetch, this.basePath)
  }

  /**
   * Sends a mail with the reset link for the given email.
   * @summary Forgot password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public forgotPassword(body: Body13, options?: any) {
    return CoacheeApiFp(this.configuration).forgotPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Boss
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public getBoss(options?: any) {
    return CoacheeApiFp(this.configuration).getBoss(options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Experience
   * @param {} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public getExperience(type?: string, options?: any) {
    return CoacheeApiFp(this.configuration).getExperience(type, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Personal Info
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public getPersonalInfo(options?: any) {
    return CoacheeApiFp(this.configuration).getPersonalInfo(options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Process
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public getProcess(processId: number, options?: any) {
    return CoacheeApiFp(this.configuration).getProcess(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Process Resources
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public getProcessResources(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return CoacheeApiFp(this.configuration).getProcessResources(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Processes
   * @param {} programId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public getProcesses(
    programId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return CoacheeApiFp(this.configuration).getProcesses(
      programId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Programs
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public getPrograms(limit?: number, page?: number, options?: any) {
    return CoacheeApiFp(this.configuration).getPrograms(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Session
   * @param {} sessionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public getSession(sessionId: number, options?: any) {
    return CoacheeApiFp(this.configuration).getSession(sessionId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Session Resources
   * @param {} sessionId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public getSessionResources(
    sessionId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return CoacheeApiFp(this.configuration).getSessionResources(
      sessionId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Sessions
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public getSessions(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return CoacheeApiFp(this.configuration).getSessions(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Studies
   * @param {} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public getStudies(type?: string, options?: any) {
    return CoacheeApiFp(this.configuration).getStudies(type, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Tripartita
   * @param {} processID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public listTripartita(processID: number, options?: any) {
    return CoacheeApiFp(this.configuration).listTripartita(processID, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Coaching Login
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public loginCoaching(body: Credentials, options?: any) {
    return CoacheeApiFp(this.configuration).loginCoaching(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * # Note  The `photo` in `personal` is a base64 encoded image.
   * @summary Coachee Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public registerCoachee(body: Body4, options?: any) {
    return CoacheeApiFp(this.configuration).registerCoachee(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Reset password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public resetPassword(body: Body14, options?: any) {
    return CoacheeApiFp(this.configuration).resetPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Boss
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public updateBoss(body: Boss, options?: any) {
    return CoacheeApiFp(this.configuration).updateBoss(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Evaluation
   * @param {} evaluationId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public updateEvaluation(evaluationId: number, body: Body19, options?: any) {
    return CoacheeApiFp(this.configuration).updateEvaluation(
      evaluationId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Experience
   * @param {} type
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public updateExperience(
    type: string,
    body: Array<Experience>,
    options?: any
  ) {
    return CoacheeApiFp(this.configuration).updateExperience(
      type,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Initial Coachee
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public updateInitialTripartitaCoachee(
    tripartitaID: number,
    body: Body2,
    options?: any
  ) {
    return CoacheeApiFp(this.configuration).updateInitialTripartitaCoachee(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Intermediate
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public updateIntermediateTripartita(
    tripartitaID: number,
    body: Body,
    options?: any
  ) {
    return CoacheeApiFp(this.configuration).updateIntermediateTripartita(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Change password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public updatePassword(body: Body21, options?: any) {
    return CoacheeApiFp(this.configuration).updatePassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Personal Info
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public updatePersonalInfo(body: PersonalInfo, options?: any) {
    return CoacheeApiFp(this.configuration).updatePersonalInfo(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Studies
   * @param {} type
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheeApi
   */
  public updateStudies(type: string, body: Array<Study>, options?: any) {
    return CoacheeApiFp(this.configuration).updateStudies(
      type,
      body,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * CoacheesApi - fetch parameter creator
 * @export
 */
export const CoacheesApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coachee Register
     * @param {Body4} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoachee(body: Body4, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerCoachee.'
        )
      }
      const localVarPath = `/coachees`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body4' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CoacheesApi - functional programming interface
 * @export
 */
export const CoacheesApiFp = function (configuration?: Configuration) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coachee Register
     * @param {Body4} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoachee(
      body: Body4,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = CoacheesApiFetchParamCreator(
        configuration
      ).registerCoachee(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * CoacheesApi - factory interface
 * @export
 */
export const CoacheesApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coachee Register
     * @param {Body4} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoachee(body: Body4, options?: any) {
      return CoacheesApiFp(configuration).registerCoachee(body, options)(
        fetch,
        basePath
      )
    },
  }
}

/**
 * CoacheesApi - object-oriented interface
 * @export
 * @class CoacheesApi
 * @extends {BaseAPI}
 */
export class CoacheesApi extends BaseAPI {
  /**
   * # Note  The `photo` in `personal` is a base64 encoded image.
   * @summary Coachee Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoacheesApi
   */
  public registerCoachee(body: Body4, options?: any) {
    return CoacheesApiFp(this.configuration).registerCoachee(body, options)(
      this.fetch,
      this.basePath
    )
  }
}

/**
 * CoachesApi - fetch parameter creator
 * @export
 */
export const CoachesApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coach Register
     * @param {Body5} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoach(body: Body5, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerCoach.'
        )
      }
      const localVarPath = `/coaches`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body5' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CoachesApi - functional programming interface
 * @export
 */
export const CoachesApiFp = function (configuration?: Configuration) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coach Register
     * @param {Body5} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoach(
      body: Body5,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = CoachesApiFetchParamCreator(
        configuration
      ).registerCoach(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * CoachesApi - factory interface
 * @export
 */
export const CoachesApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coach Register
     * @param {Body5} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoach(body: Body5, options?: any) {
      return CoachesApiFp(configuration).registerCoach(body, options)(
        fetch,
        basePath
      )
    },
  }
}

/**
 * CoachesApi - object-oriented interface
 * @export
 * @class CoachesApi
 * @extends {BaseAPI}
 */
export class CoachesApi extends BaseAPI {
  /**
   * # Note  The `photo` in `personal` is a base64 encoded image.
   * @summary Coach Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachesApi
   */
  public registerCoach(body: Body5, options?: any) {
    return CoachesApiFp(this.configuration).registerCoach(body, options)(
      this.fetch,
      this.basePath
    )
  }
}

/**
 * CoachingApi - fetch parameter creator
 * @export
 */
export const CoachingApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Create Coaching Program
     * @param {Body6} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCoachingProgram(body: Body6, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling createCoachingProgram.'
        )
      }
      const localVarPath = `/coaching/program`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body6' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(body: Credentials, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling loginCoaching.'
        )
      }
      const localVarPath = `/coaching/login`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Credentials' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CoachingApi - functional programming interface
 * @export
 */
export const CoachingApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create Coaching Program
     * @param {Body6} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCoachingProgram(
      body: Body6,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Program> {
      const localVarFetchArgs = CoachingApiFetchParamCreator(
        configuration
      ).createCoachingProgram(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(
      body: Credentials,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = CoachingApiFetchParamCreator(
        configuration
      ).loginCoaching(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * CoachingApi - factory interface
 * @export
 */
export const CoachingApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Create Coaching Program
     * @param {Body6} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCoachingProgram(body: Body6, options?: any) {
      return CoachingApiFp(configuration).createCoachingProgram(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(body: Credentials, options?: any) {
      return CoachingApiFp(configuration).loginCoaching(body, options)(
        fetch,
        basePath
      )
    },
  }
}

/**
 * CoachingApi - object-oriented interface
 * @export
 * @class CoachingApi
 * @extends {BaseAPI}
 */
export class CoachingApi extends BaseAPI {
  /**
   *
   * @summary Create Coaching Program
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachingApi
   */
  public createCoachingProgram(body: Body6, options?: any) {
    return CoachingApiFp(this.configuration).createCoachingProgram(
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Coaching Login
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CoachingApi
   */
  public loginCoaching(body: Credentials, options?: any) {
    return CoachingApiFp(this.configuration).loginCoaching(body, options)(
      this.fetch,
      this.basePath
    )
  }
}

/**
 * CompaniesApi - fetch parameter creator
 * @export
 */
export const CompaniesApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Create Company
     * @param {Body8} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCompany(body: Body8, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling createCompany.'
        )
      }
      const localVarPath = `/companies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body8' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportCompanies(
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/export/companies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Users
     * @param {string} type
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportUsers(
      type: string,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling exportUsers.'
        )
      }
      const localVarPath = `/export/users`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanies(limit?: number, page?: number, options: any = {}): FetchArgs {
      const localVarPath = `/companies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Company
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompany(companyId: number, options: any = {}): FetchArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          'companyId',
          'Required parameter companyId was null or undefined when calling getCompany.'
        )
      }
      const localVarPath = `/companies/{companyId}`.replace(
        `{${'companyId'}}`,
        encodeURIComponent(String(companyId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * # Notes  The company details will be entered by BLC, so the company will only have to set the password when registering.
     * @summary Company Register
     * @param {Body9} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCompany(body: Body9, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerCompany.'
        )
      }
      const localVarPath = `/companies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body9' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Company
     * @param {number} companyId
     * @param {Body7} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompany(
      companyId: number,
      body: Body7,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'companyId' is not null or undefined
      if (companyId === null || companyId === undefined) {
        throw new RequiredError(
          'companyId',
          'Required parameter companyId was null or undefined when calling updateCompany.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateCompany.'
        )
      }
      const localVarPath = `/companies/{companyId}`.replace(
        `{${'companyId'}}`,
        encodeURIComponent(String(companyId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body7' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CompaniesApi - functional programming interface
 * @export
 */
export const CompaniesApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create Company
     * @param {Body8} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCompany(
      body: Body8,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
      const localVarFetchArgs = CompaniesApiFetchParamCreator(
        configuration
      ).createCompany(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportCompanies(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = CompaniesApiFetchParamCreator(
        configuration
      ).exportCompanies(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Users
     * @param {string} type
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportUsers(
      type: string,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = CompaniesApiFetchParamCreator(
        configuration
      ).exportUsers(type, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanies(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2001> {
      const localVarFetchArgs = CompaniesApiFetchParamCreator(
        configuration
      ).getCompanies(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Company
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompany(
      companyId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
      const localVarFetchArgs = CompaniesApiFetchParamCreator(
        configuration
      ).getCompany(companyId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * # Notes  The company details will be entered by BLC, so the company will only have to set the password when registering.
     * @summary Company Register
     * @param {Body9} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCompany(
      body: Body9,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = CompaniesApiFetchParamCreator(
        configuration
      ).registerCompany(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Company
     * @param {number} companyId
     * @param {Body7} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompany(
      companyId: number,
      body: Body7,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CompaniesApiFetchParamCreator(
        configuration
      ).updateCompany(companyId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * CompaniesApi - factory interface
 * @export
 */
export const CompaniesApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Create Company
     * @param {Body8} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCompany(body: Body8, options?: any) {
      return CompaniesApiFp(configuration).createCompany(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportCompanies(limit?: number, page?: number, options?: any) {
      return CompaniesApiFp(configuration).exportCompanies(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Users
     * @param {string} type
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportUsers(type: string, limit?: number, page?: number, options?: any) {
      return CompaniesApiFp(configuration).exportUsers(
        type,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanies(limit?: number, page?: number, options?: any) {
      return CompaniesApiFp(configuration).getCompanies(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Company
     * @param {number} companyId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompany(companyId: number, options?: any) {
      return CompaniesApiFp(configuration).getCompany(companyId, options)(
        fetch,
        basePath
      )
    },
    /**
     * # Notes  The company details will be entered by BLC, so the company will only have to set the password when registering.
     * @summary Company Register
     * @param {Body9} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCompany(body: Body9, options?: any) {
      return CompaniesApiFp(configuration).registerCompany(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Company
     * @param {number} companyId
     * @param {Body7} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompany(companyId: number, body: Body7, options?: any) {
      return CompaniesApiFp(configuration).updateCompany(
        companyId,
        body,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * CompaniesApi - object-oriented interface
 * @export
 * @class CompaniesApi
 * @extends {BaseAPI}
 */
export class CompaniesApi extends BaseAPI {
  /**
   *
   * @summary Create Company
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompaniesApi
   */
  public createCompany(body: Body8, options?: any) {
    return CompaniesApiFp(this.configuration).createCompany(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Companies
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompaniesApi
   */
  public exportCompanies(limit?: number, page?: number, options?: any) {
    return CompaniesApiFp(this.configuration).exportCompanies(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Users
   * @param {} type
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompaniesApi
   */
  public exportUsers(
    type: string,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return CompaniesApiFp(this.configuration).exportUsers(
      type,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Companies
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompaniesApi
   */
  public getCompanies(limit?: number, page?: number, options?: any) {
    return CompaniesApiFp(this.configuration).getCompanies(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Company
   * @param {} companyId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompaniesApi
   */
  public getCompany(companyId: number, options?: any) {
    return CompaniesApiFp(this.configuration).getCompany(companyId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * # Notes  The company details will be entered by BLC, so the company will only have to set the password when registering.
   * @summary Company Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompaniesApi
   */
  public registerCompany(body: Body9, options?: any) {
    return CompaniesApiFp(this.configuration).registerCompany(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Company
   * @param {} companyId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompaniesApi
   */
  public updateCompany(companyId: number, body: Body7, options?: any) {
    return CompaniesApiFp(this.configuration).updateCompany(
      companyId,
      body,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * CompanyApi - fetch parameter creator
 * @export
 */
export const CompanyApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling forgotPassword.'
        )
      }
      const localVarPath = `/password/forgot`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body13' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Company Contacts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyContacts(options: any = {}): FetchArgs {
      const localVarPath = `/user/contacts`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Company Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyDetails(options: any = {}): FetchArgs {
      const localVarPath = `/user/company-details`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling getProcesses.'
        )
      }
      const localVarPath = `/programs/{programId}/processes`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Program
     * @param {number} programId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProgram(programId: number, options: any = {}): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling getProgram.'
        )
      }
      const localVarPath = `/programs/{programId}`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(limit?: number, page?: number, options: any = {}): FetchArgs {
      const localVarPath = `/programs`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(userId: number, options: any = {}): FetchArgs {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling getUser.'
        )
      }
      const localVarPath = `/users/{userId}`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Users
     * @param {string} type The type of the account, e.g. \&quot;coach\&quot;, \&quot;coachee\&quot;
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers(
      type: string,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling getUsers.'
        )
      }
      const localVarPath = `/users`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(body: Credentials, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling loginCoaching.'
        )
      }
      const localVarPath = `/coaching/login`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Credentials' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(body: Credentials, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling loginMentoring.'
        )
      }
      const localVarPath = `/mentoring/login`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Credentials' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * # Notes  The company details will be entered by BLC, so the company will only have to set the password when registering.
     * @summary Company Register
     * @param {Body9} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCompany(body: Body9, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerCompany.'
        )
      }
      const localVarPath = `/companies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body9' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling resetPassword.'
        )
      }
      const localVarPath = `/password/reset`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body14' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Company Contacts
     * @param {Contacts} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompanyContacts(body: Contacts, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateCompanyContacts.'
        )
      }
      const localVarPath = `/user/contacts`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Contacts' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * # Note  This is called by the company itself, not by BLC.
     * @summary Update Company Details
     * @param {Company} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompanyDetails(body: Company, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateCompanyDetails.'
        )
      }
      const localVarPath = `/user/company-details`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Company' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(body: Body21, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updatePassword.'
        )
      }
      const localVarPath = `/user/password`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body21' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * CompanyApi - functional programming interface
 * @export
 */
export const CompanyApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(
      body: Body13,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).forgotPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Company Contacts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyContacts(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Contacts> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).getCompanyContacts(options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Company Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyDetails(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).getCompanyDetails(options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2006> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).getProcesses(programId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Program
     * @param {number} programId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProgram(
      programId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Program> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).getProgram(programId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2004> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).getPrograms(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(
      userId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<User> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).getUser(userId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Users
     * @param {string} type The type of the account, e.g. \&quot;coach\&quot;, \&quot;coachee\&quot;
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers(
      type: string,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20010> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).getUsers(type, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(
      body: Credentials,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).loginCoaching(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(
      body: Credentials,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).loginMentoring(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * # Notes  The company details will be entered by BLC, so the company will only have to set the password when registering.
     * @summary Company Register
     * @param {Body9} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCompany(
      body: Body9,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).registerCompany(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(
      body: Body14,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).resetPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Company Contacts
     * @param {Contacts} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompanyContacts(
      body: Contacts,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Contacts> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).updateCompanyContacts(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * # Note  This is called by the company itself, not by BLC.
     * @summary Update Company Details
     * @param {Company} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompanyDetails(
      body: Company,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).updateCompanyDetails(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(
      body: Body21,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CompanyApiFetchParamCreator(
        configuration
      ).updatePassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * CompanyApi - factory interface
 * @export
 */
export const CompanyApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options?: any) {
      return CompanyApiFp(configuration).forgotPassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Company Contacts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyContacts(options?: any) {
      return CompanyApiFp(configuration).getCompanyContacts(options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Company Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyDetails(options?: any) {
      return CompanyApiFp(configuration).getCompanyDetails(options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return CompanyApiFp(configuration).getProcesses(
        programId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Program
     * @param {number} programId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProgram(programId: number, options?: any) {
      return CompanyApiFp(configuration).getProgram(programId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(limit?: number, page?: number, options?: any) {
      return CompanyApiFp(configuration).getPrograms(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(userId: number, options?: any) {
      return CompanyApiFp(configuration).getUser(userId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Users
     * @param {string} type The type of the account, e.g. \&quot;coach\&quot;, \&quot;coachee\&quot;
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers(type: string, limit?: number, page?: number, options?: any) {
      return CompanyApiFp(configuration).getUsers(
        type,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(body: Credentials, options?: any) {
      return CompanyApiFp(configuration).loginCoaching(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(body: Credentials, options?: any) {
      return CompanyApiFp(configuration).loginMentoring(body, options)(
        fetch,
        basePath
      )
    },
    /**
     * # Notes  The company details will be entered by BLC, so the company will only have to set the password when registering.
     * @summary Company Register
     * @param {Body9} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCompany(body: Body9, options?: any) {
      return CompanyApiFp(configuration).registerCompany(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options?: any) {
      return CompanyApiFp(configuration).resetPassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Company Contacts
     * @param {Contacts} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompanyContacts(body: Contacts, options?: any) {
      return CompanyApiFp(configuration).updateCompanyContacts(body, options)(
        fetch,
        basePath
      )
    },
    /**
     * # Note  This is called by the company itself, not by BLC.
     * @summary Update Company Details
     * @param {Company} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompanyDetails(body: Company, options?: any) {
      return CompanyApiFp(configuration).updateCompanyDetails(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(body: Body21, options?: any) {
      return CompanyApiFp(configuration).updatePassword(body, options)(
        fetch,
        basePath
      )
    },
  }
}

/**
 * CompanyApi - object-oriented interface
 * @export
 * @class CompanyApi
 * @extends {BaseAPI}
 */
export class CompanyApi extends BaseAPI {
  /**
   * Sends a mail with the reset link for the given email.
   * @summary Forgot password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public forgotPassword(body: Body13, options?: any) {
    return CompanyApiFp(this.configuration).forgotPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Company Contacts
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public getCompanyContacts(options?: any) {
    return CompanyApiFp(this.configuration).getCompanyContacts(options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Company Details
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public getCompanyDetails(options?: any) {
    return CompanyApiFp(this.configuration).getCompanyDetails(options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Processes
   * @param {} programId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public getProcesses(
    programId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return CompanyApiFp(this.configuration).getProcesses(
      programId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Program
   * @param {} programId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public getProgram(programId: number, options?: any) {
    return CompanyApiFp(this.configuration).getProgram(programId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Programs
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public getPrograms(limit?: number, page?: number, options?: any) {
    return CompanyApiFp(this.configuration).getPrograms(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get User
   * @param {} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public getUser(userId: number, options?: any) {
    return CompanyApiFp(this.configuration).getUser(userId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Users
   * @param {} type The type of the account, e.g. \&quot;coach\&quot;, \&quot;coachee\&quot;
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public getUsers(type: string, limit?: number, page?: number, options?: any) {
    return CompanyApiFp(this.configuration).getUsers(
      type,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Coaching Login
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public loginCoaching(body: Credentials, options?: any) {
    return CompanyApiFp(this.configuration).loginCoaching(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Mentoring Login
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public loginMentoring(body: Credentials, options?: any) {
    return CompanyApiFp(this.configuration).loginMentoring(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * # Notes  The company details will be entered by BLC, so the company will only have to set the password when registering.
   * @summary Company Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public registerCompany(body: Body9, options?: any) {
    return CompanyApiFp(this.configuration).registerCompany(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Reset password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public resetPassword(body: Body14, options?: any) {
    return CompanyApiFp(this.configuration).resetPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Company Contacts
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public updateCompanyContacts(body: Contacts, options?: any) {
    return CompanyApiFp(this.configuration).updateCompanyContacts(
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   * # Note  This is called by the company itself, not by BLC.
   * @summary Update Company Details
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public updateCompanyDetails(body: Company, options?: any) {
    return CompanyApiFp(this.configuration).updateCompanyDetails(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Change password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CompanyApi
   */
  public updatePassword(body: Body21, options?: any) {
    return CompanyApiFp(this.configuration).updatePassword(body, options)(
      this.fetch,
      this.basePath
    )
  }
}

/**
 * EvaluationsApi - fetch parameter creator
 * @export
 */
export const EvaluationsApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(evaluationId: number, options: any = {}): FetchArgs {
      // verify required parameter 'evaluationId' is not null or undefined
      if (evaluationId === null || evaluationId === undefined) {
        throw new RequiredError(
          'evaluationId',
          'Required parameter evaluationId was null or undefined when calling completeEvaluation.'
        )
      }
      const localVarPath = `/programs/processes/evaluations/{evaluationId}/complete`.replace(
        `{${'evaluationId'}}`,
        encodeURIComponent(String(evaluationId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(
      evaluationId: number,
      body: Body19,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'evaluationId' is not null or undefined
      if (evaluationId === null || evaluationId === undefined) {
        throw new RequiredError(
          'evaluationId',
          'Required parameter evaluationId was null or undefined when calling updateEvaluation.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateEvaluation.'
        )
      }
      const localVarPath = `/programs/processes/evaluations/{evaluationId}`.replace(
        `{${'evaluationId'}}`,
        encodeURIComponent(String(evaluationId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body19' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * EvaluationsApi - functional programming interface
 * @export
 */
export const EvaluationsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(
      evaluationId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = EvaluationsApiFetchParamCreator(
        configuration
      ).completeEvaluation(evaluationId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(
      evaluationId: number,
      body: Body19,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<FinalEvaluation> {
      const localVarFetchArgs = EvaluationsApiFetchParamCreator(
        configuration
      ).updateEvaluation(evaluationId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * EvaluationsApi - factory interface
 * @export
 */
export const EvaluationsApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(evaluationId: number, options?: any) {
      return EvaluationsApiFp(configuration).completeEvaluation(
        evaluationId,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(evaluationId: number, body: Body19, options?: any) {
      return EvaluationsApiFp(configuration).updateEvaluation(
        evaluationId,
        body,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * EvaluationsApi - object-oriented interface
 * @export
 * @class EvaluationsApi
 * @extends {BaseAPI}
 */
export class EvaluationsApi extends BaseAPI {
  /**
   *
   * @summary Complete Evaluation
   * @param {} evaluationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EvaluationsApi
   */
  public completeEvaluation(evaluationId: number, options?: any) {
    return EvaluationsApiFp(this.configuration).completeEvaluation(
      evaluationId,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Evaluation
   * @param {} evaluationId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EvaluationsApi
   */
  public updateEvaluation(evaluationId: number, body: Body19, options?: any) {
    return EvaluationsApiFp(this.configuration).updateEvaluation(
      evaluationId,
      body,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * ExportApi - fetch parameter creator
 * @export
 */
export const ExportApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportCompanies(
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/export/companies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling exportProcesses.'
        )
      }
      const localVarPath = `/export/programs/{programId}/processes`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportPrograms(
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/export/programs`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportSessions(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling exportSessions.'
        )
      }
      const localVarPath = `/export/programs/processes/{ProcessId}/sessions`.replace(
        `{${'ProcessId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Users
     * @param {string} type
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportUsers(
      type: string,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling exportUsers.'
        )
      }
      const localVarPath = `/export/users`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ExportApi - functional programming interface
 * @export
 */
export const ExportApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportCompanies(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = ExportApiFetchParamCreator(
        configuration
      ).exportCompanies(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = ExportApiFetchParamCreator(
        configuration
      ).exportProcesses(programId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportPrograms(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = ExportApiFetchParamCreator(
        configuration
      ).exportPrograms(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = ExportApiFetchParamCreator(
        configuration
      ).exportSessions(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Users
     * @param {string} type
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportUsers(
      type: string,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = ExportApiFetchParamCreator(
        configuration
      ).exportUsers(type, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * ExportApi - factory interface
 * @export
 */
export const ExportApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Companies
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportCompanies(limit?: number, page?: number, options?: any) {
      return ExportApiFp(configuration).exportCompanies(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return ExportApiFp(configuration).exportProcesses(
        programId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportPrograms(limit?: number, page?: number, options?: any) {
      return ExportApiFp(configuration).exportPrograms(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return ExportApiFp(configuration).exportSessions(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Users
     * @param {string} type
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportUsers(type: string, limit?: number, page?: number, options?: any) {
      return ExportApiFp(configuration).exportUsers(
        type,
        limit,
        page,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * ExportApi - object-oriented interface
 * @export
 * @class ExportApi
 * @extends {BaseAPI}
 */
export class ExportApi extends BaseAPI {
  /**
   *
   * @summary Companies
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportApi
   */
  public exportCompanies(limit?: number, page?: number, options?: any) {
    return ExportApiFp(this.configuration).exportCompanies(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Processes
   * @param {} programId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportApi
   */
  public exportProcesses(
    programId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return ExportApiFp(this.configuration).exportProcesses(
      programId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Programs
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportApi
   */
  public exportPrograms(limit?: number, page?: number, options?: any) {
    return ExportApiFp(this.configuration).exportPrograms(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Sessions
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportApi
   */
  public exportSessions(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return ExportApiFp(this.configuration).exportSessions(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Users
   * @param {} type
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ExportApi
   */
  public exportUsers(
    type: string,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return ExportApiFp(this.configuration).exportUsers(
      type,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * ForgotPasswordApi - fetch parameter creator
 * @export
 */
export const ForgotPasswordApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling forgotPassword.'
        )
      }
      const localVarPath = `/password/forgot`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body13' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling resetPassword.'
        )
      }
      const localVarPath = `/password/reset`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body14' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ForgotPasswordApi - functional programming interface
 * @export
 */
export const ForgotPasswordApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(
      body: Body13,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = ForgotPasswordApiFetchParamCreator(
        configuration
      ).forgotPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(
      body: Body14,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = ForgotPasswordApiFetchParamCreator(
        configuration
      ).resetPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * ForgotPasswordApi - factory interface
 * @export
 */
export const ForgotPasswordApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options?: any) {
      return ForgotPasswordApiFp(configuration).forgotPassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options?: any) {
      return ForgotPasswordApiFp(configuration).resetPassword(body, options)(
        fetch,
        basePath
      )
    },
  }
}

/**
 * ForgotPasswordApi - object-oriented interface
 * @export
 * @class ForgotPasswordApi
 * @extends {BaseAPI}
 */
export class ForgotPasswordApi extends BaseAPI {
  /**
   * Sends a mail with the reset link for the given email.
   * @summary Forgot password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ForgotPasswordApi
   */
  public forgotPassword(body: Body13, options?: any) {
    return ForgotPasswordApiFp(this.configuration).forgotPassword(
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Reset password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ForgotPasswordApi
   */
  public resetPassword(body: Body14, options?: any) {
    return ForgotPasswordApiFp(this.configuration).resetPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }
}

/**
 * LoginApi - fetch parameter creator
 * @export
 */
export const LoginApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(body: Credentials, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling loginCoaching.'
        )
      }
      const localVarPath = `/coaching/login`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Credentials' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(body: Credentials, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling loginMentoring.'
        )
      }
      const localVarPath = `/mentoring/login`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Credentials' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * LoginApi - functional programming interface
 * @export
 */
export const LoginApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(
      body: Credentials,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = LoginApiFetchParamCreator(
        configuration
      ).loginCoaching(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(
      body: Credentials,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = LoginApiFetchParamCreator(
        configuration
      ).loginMentoring(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * LoginApi - factory interface
 * @export
 */
export const LoginApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Coaching Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginCoaching(body: Credentials, options?: any) {
      return LoginApiFp(configuration).loginCoaching(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(body: Credentials, options?: any) {
      return LoginApiFp(configuration).loginMentoring(body, options)(
        fetch,
        basePath
      )
    },
  }
}

/**
 * LoginApi - object-oriented interface
 * @export
 * @class LoginApi
 * @extends {BaseAPI}
 */
export class LoginApi extends BaseAPI {
  /**
   *
   * @summary Coaching Login
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LoginApi
   */
  public loginCoaching(body: Credentials, options?: any) {
    return LoginApiFp(this.configuration).loginCoaching(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Mentoring Login
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof LoginApi
   */
  public loginMentoring(body: Credentials, options?: any) {
    return LoginApiFp(this.configuration).loginMentoring(body, options)(
      this.fetch,
      this.basePath
    )
  }
}

/**
 * MenteeApi - fetch parameter creator
 * @export
 */
export const MenteeApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling acceptContract.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/accept-contract`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(
      sessionId: number,
      body: Body18,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling completeSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling completeSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/complete`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body18' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling forgotPassword.'
        )
      }
      const localVarPath = `/password/forgot`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body13' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(type?: string, options: any = {}): FetchArgs {
      const localVarPath = `/user/experience`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(options: any = {}): FetchArgs {
      const localVarPath = `/user/personal`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getProcess.'
        )
      }
      const localVarPath = `/programs/process/{processId}`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getProcessResources.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/resources`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling getProcesses.'
        )
      }
      const localVarPath = `/programs/{programId}/processes`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(limit?: number, page?: number, options: any = {}): FetchArgs {
      const localVarPath = `/programs`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(sessionId: number, options: any = {}): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling getSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling getSessionResources.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/resources`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getSessions.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/sessions`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(type?: string, options: any = {}): FetchArgs {
      const localVarPath = `/user/studies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(body: Credentials, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling loginMentoring.'
        )
      }
      const localVarPath = `/mentoring/login`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Credentials' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentee Register
     * @param {Body10} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentee(body: Body10, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerMentee.'
        )
      }
      const localVarPath = `/mentees`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body10' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling resetPassword.'
        )
      }
      const localVarPath = `/password/reset`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body14' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(
      sessionId: number,
      body: Body17,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling scheduleSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling scheduleSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/schedule`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body17' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(
      type: string,
      body: Array<Experience>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling updateExperience.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateExperience.'
        )
      }
      const localVarPath = `/user/experience/{type}`.replace(
        `{${'type'}}`,
        encodeURIComponent(String(type))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Array&lt;Experience&gt;' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(body: Body21, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updatePassword.'
        )
      }
      const localVarPath = `/user/password`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body21' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(body: PersonalInfo, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updatePersonalInfo.'
        )
      }
      const localVarPath = `/user/personal`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'PersonalInfo' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(
      sessionId: number,
      body: Body16,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling updateSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body16' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(
      type: string,
      body: Array<Study>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling updateStudies.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateStudies.'
        )
      }
      const localVarPath = `/user/studies/{type}`.replace(
        `{${'type'}}`,
        encodeURIComponent(String(type))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Array&lt;Study&gt;' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(
      processId: number,
      file: any,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling uploadProcessResource.'
        )
      }
      // verify required parameter 'file' is not null or undefined
      if (file === null || file === undefined) {
        throw new RequiredError(
          'file',
          'Required parameter file was null or undefined when calling uploadProcessResource.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/resources`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new url.URLSearchParams()

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (file !== undefined) {
        localVarFormParams.set('file', file as any)
      }

      localVarHeaderParameter['Content-Type'] =
        'application/x-www-form-urlencoded'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      localVarRequestOptions.body = localVarFormParams.toString()

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Upload Session Resource
     * @param {number} sessionId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionResource(
      sessionId: number,
      file: any,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling uploadSessionResource.'
        )
      }
      // verify required parameter 'file' is not null or undefined
      if (file === null || file === undefined) {
        throw new RequiredError(
          'file',
          'Required parameter file was null or undefined when calling uploadSessionResource.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/resources`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new url.URLSearchParams()

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (file !== undefined) {
        localVarFormParams.set('file', file as any)
      }

      localVarHeaderParameter['Content-Type'] =
        'application/x-www-form-urlencoded'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      localVarRequestOptions.body = localVarFormParams.toString()

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * MenteeApi - functional programming interface
 * @export
 */
export const MenteeApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).acceptContract(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(
      sessionId: number,
      body: Body18,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).completeSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(
      body: Body13,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).forgotPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(
      type?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Experience>> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).getExperience(type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<PersonalInfo> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).getPersonalInfo(options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Process> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).getProcess(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2002> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).getProcessResources(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2006> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).getProcesses(programId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2004> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).getPrograms(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(
      sessionId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Session> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).getSession(sessionId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2002> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).getSessionResources(sessionId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2003> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).getSessions(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(
      type?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Study>> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).getStudies(type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(
      body: Credentials,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).loginMentoring(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentee Register
     * @param {Body10} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentee(
      body: Body10,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).registerMentee(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(
      body: Body14,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).resetPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(
      sessionId: number,
      body: Body17,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).scheduleSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(
      type: string,
      body: Array<Experience>,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Experience>> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).updateExperience(type, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(
      body: Body21,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).updatePassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(
      body: PersonalInfo,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<PersonalInfo> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).updatePersonalInfo(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(
      sessionId: number,
      body: Body16,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Session> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).updateSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(
      type: string,
      body: Array<Study>,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Study>> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).updateStudies(type, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(
      processId: number,
      file: any,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Resource> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).uploadProcessResource(processId, file, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Upload Session Resource
     * @param {number} sessionId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionResource(
      sessionId: number,
      file: any,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Resource> {
      const localVarFetchArgs = MenteeApiFetchParamCreator(
        configuration
      ).uploadSessionResource(sessionId, file, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * MenteeApi - factory interface
 * @export
 */
export const MenteeApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(processId: number, options?: any) {
      return MenteeApiFp(configuration).acceptContract(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(sessionId: number, body: Body18, options?: any) {
      return MenteeApiFp(configuration).completeSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options?: any) {
      return MenteeApiFp(configuration).forgotPassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(type?: string, options?: any) {
      return MenteeApiFp(configuration).getExperience(type, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(options?: any) {
      return MenteeApiFp(configuration).getPersonalInfo(options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: number, options?: any) {
      return MenteeApiFp(configuration).getProcess(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return MenteeApiFp(configuration).getProcessResources(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return MenteeApiFp(configuration).getProcesses(
        programId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(limit?: number, page?: number, options?: any) {
      return MenteeApiFp(configuration).getPrograms(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(sessionId: number, options?: any) {
      return MenteeApiFp(configuration).getSession(sessionId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return MenteeApiFp(configuration).getSessionResources(
        sessionId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return MenteeApiFp(configuration).getSessions(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(type?: string, options?: any) {
      return MenteeApiFp(configuration).getStudies(type, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(body: Credentials, options?: any) {
      return MenteeApiFp(configuration).loginMentoring(body, options)(
        fetch,
        basePath
      )
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentee Register
     * @param {Body10} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentee(body: Body10, options?: any) {
      return MenteeApiFp(configuration).registerMentee(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options?: any) {
      return MenteeApiFp(configuration).resetPassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(sessionId: number, body: Body17, options?: any) {
      return MenteeApiFp(configuration).scheduleSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(type: string, body: Array<Experience>, options?: any) {
      return MenteeApiFp(configuration).updateExperience(
        type,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(body: Body21, options?: any) {
      return MenteeApiFp(configuration).updatePassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(body: PersonalInfo, options?: any) {
      return MenteeApiFp(configuration).updatePersonalInfo(body, options)(
        fetch,
        basePath
      )
    },
    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(sessionId: number, body: Body16, options?: any) {
      return MenteeApiFp(configuration).updateSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(type: string, body: Array<Study>, options?: any) {
      return MenteeApiFp(configuration).updateStudies(
        type,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(processId: number, file: any, options?: any) {
      return MenteeApiFp(configuration).uploadProcessResource(
        processId,
        file,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Upload Session Resource
     * @param {number} sessionId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionResource(sessionId: number, file: any, options?: any) {
      return MenteeApiFp(configuration).uploadSessionResource(
        sessionId,
        file,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * MenteeApi - object-oriented interface
 * @export
 * @class MenteeApi
 * @extends {BaseAPI}
 */
export class MenteeApi extends BaseAPI {
  /**
   *
   * @summary Accept contract
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public acceptContract(processId: number, options?: any) {
    return MenteeApiFp(this.configuration).acceptContract(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Complete Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public completeSession(sessionId: number, body: Body18, options?: any) {
    return MenteeApiFp(this.configuration).completeSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   * Sends a mail with the reset link for the given email.
   * @summary Forgot password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public forgotPassword(body: Body13, options?: any) {
    return MenteeApiFp(this.configuration).forgotPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Experience
   * @param {} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public getExperience(type?: string, options?: any) {
    return MenteeApiFp(this.configuration).getExperience(type, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Personal Info
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public getPersonalInfo(options?: any) {
    return MenteeApiFp(this.configuration).getPersonalInfo(options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Process
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public getProcess(processId: number, options?: any) {
    return MenteeApiFp(this.configuration).getProcess(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Process Resources
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public getProcessResources(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return MenteeApiFp(this.configuration).getProcessResources(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Processes
   * @param {} programId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public getProcesses(
    programId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return MenteeApiFp(this.configuration).getProcesses(
      programId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Programs
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public getPrograms(limit?: number, page?: number, options?: any) {
    return MenteeApiFp(this.configuration).getPrograms(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Session
   * @param {} sessionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public getSession(sessionId: number, options?: any) {
    return MenteeApiFp(this.configuration).getSession(sessionId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Session Resources
   * @param {} sessionId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public getSessionResources(
    sessionId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return MenteeApiFp(this.configuration).getSessionResources(
      sessionId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Sessions
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public getSessions(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return MenteeApiFp(this.configuration).getSessions(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Studies
   * @param {} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public getStudies(type?: string, options?: any) {
    return MenteeApiFp(this.configuration).getStudies(type, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Mentoring Login
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public loginMentoring(body: Credentials, options?: any) {
    return MenteeApiFp(this.configuration).loginMentoring(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * # Note  The `photo` in `personal` is a base64 encoded image.
   * @summary Mentee Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public registerMentee(body: Body10, options?: any) {
    return MenteeApiFp(this.configuration).registerMentee(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Reset password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public resetPassword(body: Body14, options?: any) {
    return MenteeApiFp(this.configuration).resetPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Schedule Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public scheduleSession(sessionId: number, body: Body17, options?: any) {
    return MenteeApiFp(this.configuration).scheduleSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Experience
   * @param {} type
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public updateExperience(
    type: string,
    body: Array<Experience>,
    options?: any
  ) {
    return MenteeApiFp(this.configuration).updateExperience(
      type,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Change password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public updatePassword(body: Body21, options?: any) {
    return MenteeApiFp(this.configuration).updatePassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Personal Info
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public updatePersonalInfo(body: PersonalInfo, options?: any) {
    return MenteeApiFp(this.configuration).updatePersonalInfo(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
   * @summary Update Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public updateSession(sessionId: number, body: Body16, options?: any) {
    return MenteeApiFp(this.configuration).updateSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Studies
   * @param {} type
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public updateStudies(type: string, body: Array<Study>, options?: any) {
    return MenteeApiFp(this.configuration).updateStudies(
      type,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Upload Process Resource
   * @param {} processId
   * @param {} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public uploadProcessResource(processId: number, file: any, options?: any) {
    return MenteeApiFp(this.configuration).uploadProcessResource(
      processId,
      file,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Upload Session Resource
   * @param {} sessionId
   * @param {} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteeApi
   */
  public uploadSessionResource(sessionId: number, file: any, options?: any) {
    return MenteeApiFp(this.configuration).uploadSessionResource(
      sessionId,
      file,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * MenteesApi - fetch parameter creator
 * @export
 */
export const MenteesApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentee Register
     * @param {Body10} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentee(body: Body10, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerMentee.'
        )
      }
      const localVarPath = `/mentees`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body10' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * MenteesApi - functional programming interface
 * @export
 */
export const MenteesApiFp = function (configuration?: Configuration) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentee Register
     * @param {Body10} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentee(
      body: Body10,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = MenteesApiFetchParamCreator(
        configuration
      ).registerMentee(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * MenteesApi - factory interface
 * @export
 */
export const MenteesApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentee Register
     * @param {Body10} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentee(body: Body10, options?: any) {
      return MenteesApiFp(configuration).registerMentee(body, options)(
        fetch,
        basePath
      )
    },
  }
}

/**
 * MenteesApi - object-oriented interface
 * @export
 * @class MenteesApi
 * @extends {BaseAPI}
 */
export class MenteesApi extends BaseAPI {
  /**
   * # Note  The `photo` in `personal` is a base64 encoded image.
   * @summary Mentee Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MenteesApi
   */
  public registerMentee(body: Body10, options?: any) {
    return MenteesApiFp(this.configuration).registerMentee(body, options)(
      this.fetch,
      this.basePath
    )
  }
}

/**
 * MentorApi - fetch parameter creator
 * @export
 */
export const MentorApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling acceptContract.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/accept-contract`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling forgotPassword.'
        )
      }
      const localVarPath = `/password/forgot`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body13' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(type?: string, options: any = {}): FetchArgs {
      const localVarPath = `/user/experience`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(options: any = {}): FetchArgs {
      const localVarPath = `/user/personal`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getProcess.'
        )
      }
      const localVarPath = `/programs/process/{processId}`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getProcessResources.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/resources`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling getProcesses.'
        )
      }
      const localVarPath = `/programs/{programId}/processes`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(limit?: number, page?: number, options: any = {}): FetchArgs {
      const localVarPath = `/programs`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(sessionId: number, options: any = {}): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling getSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling getSessionResources.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/resources`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getSessions.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/sessions`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(type?: string, options: any = {}): FetchArgs {
      const localVarPath = `/user/studies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(body: Credentials, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling loginMentoring.'
        )
      }
      const localVarPath = `/mentoring/login`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Credentials' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentor Register
     * @param {Body12} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentor(body: Body12, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerMentor.'
        )
      }
      const localVarPath = `/mentors`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body12' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling resetPassword.'
        )
      }
      const localVarPath = `/password/reset`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body14' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(
      type: string,
      body: Array<Experience>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling updateExperience.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateExperience.'
        )
      }
      const localVarPath = `/user/experience/{type}`.replace(
        `{${'type'}}`,
        encodeURIComponent(String(type))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Array&lt;Experience&gt;' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(body: Body21, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updatePassword.'
        )
      }
      const localVarPath = `/user/password`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body21' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(body: PersonalInfo, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updatePersonalInfo.'
        )
      }
      const localVarPath = `/user/personal`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'PersonalInfo' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(
      type: string,
      body: Array<Study>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling updateStudies.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateStudies.'
        )
      }
      const localVarPath = `/user/studies/{type}`.replace(
        `{${'type'}}`,
        encodeURIComponent(String(type))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Array&lt;Study&gt;' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * MentorApi - functional programming interface
 * @export
 */
export const MentorApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).acceptContract(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(
      body: Body13,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).forgotPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(
      type?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Experience>> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).getExperience(type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<PersonalInfo> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).getPersonalInfo(options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Process> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).getProcess(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2002> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).getProcessResources(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2006> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).getProcesses(programId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2004> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).getPrograms(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(
      sessionId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Session> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).getSession(sessionId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2002> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).getSessionResources(sessionId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2003> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).getSessions(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(
      type?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Study>> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).getStudies(type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(
      body: Credentials,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).loginMentoring(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentor Register
     * @param {Body12} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentor(
      body: Body12,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).registerMentor(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(
      body: Body14,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).resetPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(
      type: string,
      body: Array<Experience>,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Experience>> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).updateExperience(type, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(
      body: Body21,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).updatePassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(
      body: PersonalInfo,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<PersonalInfo> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).updatePersonalInfo(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(
      type: string,
      body: Array<Study>,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Study>> {
      const localVarFetchArgs = MentorApiFetchParamCreator(
        configuration
      ).updateStudies(type, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * MentorApi - factory interface
 * @export
 */
export const MentorApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(processId: number, options?: any) {
      return MentorApiFp(configuration).acceptContract(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options?: any) {
      return MentorApiFp(configuration).forgotPassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(type?: string, options?: any) {
      return MentorApiFp(configuration).getExperience(type, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(options?: any) {
      return MentorApiFp(configuration).getPersonalInfo(options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: number, options?: any) {
      return MentorApiFp(configuration).getProcess(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return MentorApiFp(configuration).getProcessResources(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return MentorApiFp(configuration).getProcesses(
        programId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(limit?: number, page?: number, options?: any) {
      return MentorApiFp(configuration).getPrograms(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(sessionId: number, options?: any) {
      return MentorApiFp(configuration).getSession(sessionId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return MentorApiFp(configuration).getSessionResources(
        sessionId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return MentorApiFp(configuration).getSessions(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(type?: string, options?: any) {
      return MentorApiFp(configuration).getStudies(type, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(body: Credentials, options?: any) {
      return MentorApiFp(configuration).loginMentoring(body, options)(
        fetch,
        basePath
      )
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentor Register
     * @param {Body12} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentor(body: Body12, options?: any) {
      return MentorApiFp(configuration).registerMentor(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options?: any) {
      return MentorApiFp(configuration).resetPassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(type: string, body: Array<Experience>, options?: any) {
      return MentorApiFp(configuration).updateExperience(
        type,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(body: Body21, options?: any) {
      return MentorApiFp(configuration).updatePassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(body: PersonalInfo, options?: any) {
      return MentorApiFp(configuration).updatePersonalInfo(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(type: string, body: Array<Study>, options?: any) {
      return MentorApiFp(configuration).updateStudies(
        type,
        body,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * MentorApi - object-oriented interface
 * @export
 * @class MentorApi
 * @extends {BaseAPI}
 */
export class MentorApi extends BaseAPI {
  /**
   *
   * @summary Accept contract
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public acceptContract(processId: number, options?: any) {
    return MentorApiFp(this.configuration).acceptContract(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * Sends a mail with the reset link for the given email.
   * @summary Forgot password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public forgotPassword(body: Body13, options?: any) {
    return MentorApiFp(this.configuration).forgotPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Experience
   * @param {} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public getExperience(type?: string, options?: any) {
    return MentorApiFp(this.configuration).getExperience(type, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Personal Info
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public getPersonalInfo(options?: any) {
    return MentorApiFp(this.configuration).getPersonalInfo(options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Process
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public getProcess(processId: number, options?: any) {
    return MentorApiFp(this.configuration).getProcess(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Process Resources
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public getProcessResources(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return MentorApiFp(this.configuration).getProcessResources(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Processes
   * @param {} programId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public getProcesses(
    programId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return MentorApiFp(this.configuration).getProcesses(
      programId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Programs
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public getPrograms(limit?: number, page?: number, options?: any) {
    return MentorApiFp(this.configuration).getPrograms(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Session
   * @param {} sessionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public getSession(sessionId: number, options?: any) {
    return MentorApiFp(this.configuration).getSession(sessionId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Session Resources
   * @param {} sessionId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public getSessionResources(
    sessionId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return MentorApiFp(this.configuration).getSessionResources(
      sessionId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Sessions
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public getSessions(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return MentorApiFp(this.configuration).getSessions(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Studies
   * @param {} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public getStudies(type?: string, options?: any) {
    return MentorApiFp(this.configuration).getStudies(type, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Mentoring Login
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public loginMentoring(body: Credentials, options?: any) {
    return MentorApiFp(this.configuration).loginMentoring(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * # Note  The `photo` in `personal` is a base64 encoded image.
   * @summary Mentor Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public registerMentor(body: Body12, options?: any) {
    return MentorApiFp(this.configuration).registerMentor(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Reset password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public resetPassword(body: Body14, options?: any) {
    return MentorApiFp(this.configuration).resetPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Experience
   * @param {} type
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public updateExperience(
    type: string,
    body: Array<Experience>,
    options?: any
  ) {
    return MentorApiFp(this.configuration).updateExperience(
      type,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Change password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public updatePassword(body: Body21, options?: any) {
    return MentorApiFp(this.configuration).updatePassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Personal Info
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public updatePersonalInfo(body: PersonalInfo, options?: any) {
    return MentorApiFp(this.configuration).updatePersonalInfo(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Studies
   * @param {} type
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorApi
   */
  public updateStudies(type: string, body: Array<Study>, options?: any) {
    return MentorApiFp(this.configuration).updateStudies(
      type,
      body,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * MentoringApi - fetch parameter creator
 * @export
 */
export const MentoringApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Create Mentoring Program
     * @param {Body11} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMentoringProgram(body: Body11, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling createMentoringProgram.'
        )
      }
      const localVarPath = `/mentoring/program`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body11' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(body: Credentials, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling loginMentoring.'
        )
      }
      const localVarPath = `/mentoring/login`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Credentials' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * MentoringApi - functional programming interface
 * @export
 */
export const MentoringApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Create Mentoring Program
     * @param {Body11} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMentoringProgram(
      body: Body11,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Program> {
      const localVarFetchArgs = MentoringApiFetchParamCreator(
        configuration
      ).createMentoringProgram(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(
      body: Credentials,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = MentoringApiFetchParamCreator(
        configuration
      ).loginMentoring(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * MentoringApi - factory interface
 * @export
 */
export const MentoringApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Create Mentoring Program
     * @param {Body11} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMentoringProgram(body: Body11, options?: any) {
      return MentoringApiFp(configuration).createMentoringProgram(
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Mentoring Login
     * @param {Credentials} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginMentoring(body: Credentials, options?: any) {
      return MentoringApiFp(configuration).loginMentoring(body, options)(
        fetch,
        basePath
      )
    },
  }
}

/**
 * MentoringApi - object-oriented interface
 * @export
 * @class MentoringApi
 * @extends {BaseAPI}
 */
export class MentoringApi extends BaseAPI {
  /**
   *
   * @summary Create Mentoring Program
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentoringApi
   */
  public createMentoringProgram(body: Body11, options?: any) {
    return MentoringApiFp(this.configuration).createMentoringProgram(
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Mentoring Login
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentoringApi
   */
  public loginMentoring(body: Credentials, options?: any) {
    return MentoringApiFp(this.configuration).loginMentoring(body, options)(
      this.fetch,
      this.basePath
    )
  }
}

/**
 * MentorsApi - fetch parameter creator
 * @export
 */
export const MentorsApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentor Register
     * @param {Body12} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentor(body: Body12, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerMentor.'
        )
      }
      const localVarPath = `/mentors`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body12' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * MentorsApi - functional programming interface
 * @export
 */
export const MentorsApiFp = function (configuration?: Configuration) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentor Register
     * @param {Body12} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentor(
      body: Body12,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = MentorsApiFetchParamCreator(
        configuration
      ).registerMentor(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * MentorsApi - factory interface
 * @export
 */
export const MentorsApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentor Register
     * @param {Body12} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentor(body: Body12, options?: any) {
      return MentorsApiFp(configuration).registerMentor(body, options)(
        fetch,
        basePath
      )
    },
  }
}

/**
 * MentorsApi - object-oriented interface
 * @export
 * @class MentorsApi
 * @extends {BaseAPI}
 */
export class MentorsApi extends BaseAPI {
  /**
   * # Note  The `photo` in `personal` is a base64 encoded image.
   * @summary Mentor Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MentorsApi
   */
  public registerMentor(body: Body12, options?: any) {
    return MentorsApiFp(this.configuration).registerMentor(body, options)(
      this.fetch,
      this.basePath
    )
  }
}

/**
 * PasswordApi - fetch parameter creator
 * @export
 */
export const PasswordApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling forgotPassword.'
        )
      }
      const localVarPath = `/password/forgot`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body13' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling resetPassword.'
        )
      }
      const localVarPath = `/password/reset`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body14' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * PasswordApi - functional programming interface
 * @export
 */
export const PasswordApiFp = function (configuration?: Configuration) {
  return {
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(
      body: Body13,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = PasswordApiFetchParamCreator(
        configuration
      ).forgotPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(
      body: Body14,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = PasswordApiFetchParamCreator(
        configuration
      ).resetPassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * PasswordApi - factory interface
 * @export
 */
export const PasswordApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * Sends a mail with the reset link for the given email.
     * @summary Forgot password
     * @param {Body13} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    forgotPassword(body: Body13, options?: any) {
      return PasswordApiFp(configuration).forgotPassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Reset password
     * @param {Body14} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(body: Body14, options?: any) {
      return PasswordApiFp(configuration).resetPassword(body, options)(
        fetch,
        basePath
      )
    },
  }
}

/**
 * PasswordApi - object-oriented interface
 * @export
 * @class PasswordApi
 * @extends {BaseAPI}
 */
export class PasswordApi extends BaseAPI {
  /**
   * Sends a mail with the reset link for the given email.
   * @summary Forgot password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PasswordApi
   */
  public forgotPassword(body: Body13, options?: any) {
    return PasswordApiFp(this.configuration).forgotPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Reset password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PasswordApi
   */
  public resetPassword(body: Body14, options?: any) {
    return PasswordApiFp(this.configuration).resetPassword(body, options)(
      this.fetch,
      this.basePath
    )
  }
}

/**
 * ProcessApi - fetch parameter creator
 * @export
 */
export const ProcessApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Remove Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcess(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling deleteProcess.'
        )
      }
      const localVarPath = `/programs/process/{processId}`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign(
        { method: 'DELETE' },
        options
      )
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(processID: number, options: any = {}): FetchArgs {
      // verify required parameter 'processID' is not null or undefined
      if (processID === null || processID === undefined) {
        throw new RequiredError(
          'processID',
          'Required parameter processID was null or undefined when calling listTripartita.'
        )
      }
      const localVarPath = `/programs/processes/{processID}/tripartita`.replace(
        `{${'processID'}}`,
        encodeURIComponent(String(processID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Final
     * @param {number} tripartitaID
     * @param {Body1} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinalTripartita(
      tripartitaID: number,
      body: Body1,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateFinalTripartita.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateFinalTripartita.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/final`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body1' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Initial Coach
     * @param {number} tripartitaID
     * @param {Body3} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoach(
      tripartitaID: number,
      body: Body3,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateInitialTripartitaCoach.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateInitialTripartitaCoach.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/initial/coach`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body3' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Initial Coachee
     * @param {number} tripartitaID
     * @param {Body2} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoachee(
      tripartitaID: number,
      body: Body2,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateInitialTripartitaCoachee.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateInitialTripartitaCoachee.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/initial/coachee`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body2' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateIntermediateTripartita.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateIntermediateTripartita.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/intermediate`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProcessApi - functional programming interface
 * @export
 */
export const ProcessApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Remove Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcess(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = ProcessApiFetchParamCreator(
        configuration
      ).deleteProcess(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(
      processID: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<ProcessTripartita> {
      const localVarFetchArgs = ProcessApiFetchParamCreator(
        configuration
      ).listTripartita(processID, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Final
     * @param {number} tripartitaID
     * @param {Body1} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinalTripartita(
      tripartitaID: number,
      body: Body1,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<FinalTripartita> {
      const localVarFetchArgs = ProcessApiFetchParamCreator(
        configuration
      ).updateFinalTripartita(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Initial Coach
     * @param {number} tripartitaID
     * @param {Body3} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoach(
      tripartitaID: number,
      body: Body3,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InitialTripartita> {
      const localVarFetchArgs = ProcessApiFetchParamCreator(
        configuration
      ).updateInitialTripartitaCoach(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Initial Coachee
     * @param {number} tripartitaID
     * @param {Body2} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoachee(
      tripartitaID: number,
      body: Body2,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InitialTripartita> {
      const localVarFetchArgs = ProcessApiFetchParamCreator(
        configuration
      ).updateInitialTripartitaCoachee(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<IntermediateTripartita> {
      const localVarFetchArgs = ProcessApiFetchParamCreator(
        configuration
      ).updateIntermediateTripartita(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * ProcessApi - factory interface
 * @export
 */
export const ProcessApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Remove Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcess(processId: number, options?: any) {
      return ProcessApiFp(configuration).deleteProcess(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(processID: number, options?: any) {
      return ProcessApiFp(configuration).listTripartita(processID, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Final
     * @param {number} tripartitaID
     * @param {Body1} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinalTripartita(tripartitaID: number, body: Body1, options?: any) {
      return ProcessApiFp(configuration).updateFinalTripartita(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Initial Coach
     * @param {number} tripartitaID
     * @param {Body3} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoach(
      tripartitaID: number,
      body: Body3,
      options?: any
    ) {
      return ProcessApiFp(configuration).updateInitialTripartitaCoach(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Initial Coachee
     * @param {number} tripartitaID
     * @param {Body2} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoachee(
      tripartitaID: number,
      body: Body2,
      options?: any
    ) {
      return ProcessApiFp(configuration).updateInitialTripartitaCoachee(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options?: any
    ) {
      return ProcessApiFp(configuration).updateIntermediateTripartita(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * ProcessApi - object-oriented interface
 * @export
 * @class ProcessApi
 * @extends {BaseAPI}
 */
export class ProcessApi extends BaseAPI {
  /**
   *
   * @summary Remove Process
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessApi
   */
  public deleteProcess(processId: number, options?: any) {
    return ProcessApiFp(this.configuration).deleteProcess(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Tripartita
   * @param {} processID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessApi
   */
  public listTripartita(processID: number, options?: any) {
    return ProcessApiFp(this.configuration).listTripartita(processID, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Final
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessApi
   */
  public updateFinalTripartita(
    tripartitaID: number,
    body: Body1,
    options?: any
  ) {
    return ProcessApiFp(this.configuration).updateFinalTripartita(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Initial Coach
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessApi
   */
  public updateInitialTripartitaCoach(
    tripartitaID: number,
    body: Body3,
    options?: any
  ) {
    return ProcessApiFp(this.configuration).updateInitialTripartitaCoach(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Initial Coachee
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessApi
   */
  public updateInitialTripartitaCoachee(
    tripartitaID: number,
    body: Body2,
    options?: any
  ) {
    return ProcessApiFp(this.configuration).updateInitialTripartitaCoachee(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Intermediate
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessApi
   */
  public updateIntermediateTripartita(
    tripartitaID: number,
    body: Body,
    options?: any
  ) {
    return ProcessApiFp(this.configuration).updateIntermediateTripartita(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * ProcessesApi - fetch parameter creator
 * @export
 */
export const ProcessesApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling acceptContract.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/accept-contract`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(evaluationId: number, options: any = {}): FetchArgs {
      // verify required parameter 'evaluationId' is not null or undefined
      if (evaluationId === null || evaluationId === undefined) {
        throw new RequiredError(
          'evaluationId',
          'Required parameter evaluationId was null or undefined when calling completeEvaluation.'
        )
      }
      const localVarPath = `/programs/processes/evaluations/{evaluationId}/complete`.replace(
        `{${'evaluationId'}}`,
        encodeURIComponent(String(evaluationId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling exportProcesses.'
        )
      }
      const localVarPath = `/export/programs/{programId}/processes`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportSessions(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling exportSessions.'
        )
      }
      const localVarPath = `/export/programs/processes/{ProcessId}/sessions`.replace(
        `{${'ProcessId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getProcess.'
        )
      }
      const localVarPath = `/programs/process/{processId}`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling getProcesses.'
        )
      }
      const localVarPath = `/programs/{programId}/processes`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(
      evaluationId: number,
      body: Body19,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'evaluationId' is not null or undefined
      if (evaluationId === null || evaluationId === undefined) {
        throw new RequiredError(
          'evaluationId',
          'Required parameter evaluationId was null or undefined when calling updateEvaluation.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateEvaluation.'
        )
      }
      const localVarPath = `/programs/processes/evaluations/{evaluationId}`.replace(
        `{${'evaluationId'}}`,
        encodeURIComponent(String(evaluationId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body19' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProcessesApi - functional programming interface
 * @export
 */
export const ProcessesApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = ProcessesApiFetchParamCreator(
        configuration
      ).acceptContract(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(
      evaluationId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = ProcessesApiFetchParamCreator(
        configuration
      ).completeEvaluation(evaluationId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = ProcessesApiFetchParamCreator(
        configuration
      ).exportProcesses(programId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = ProcessesApiFetchParamCreator(
        configuration
      ).exportSessions(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Process> {
      const localVarFetchArgs = ProcessesApiFetchParamCreator(
        configuration
      ).getProcess(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2006> {
      const localVarFetchArgs = ProcessesApiFetchParamCreator(
        configuration
      ).getProcesses(programId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(
      evaluationId: number,
      body: Body19,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<FinalEvaluation> {
      const localVarFetchArgs = ProcessesApiFetchParamCreator(
        configuration
      ).updateEvaluation(evaluationId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * ProcessesApi - factory interface
 * @export
 */
export const ProcessesApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(processId: number, options?: any) {
      return ProcessesApiFp(configuration).acceptContract(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(evaluationId: number, options?: any) {
      return ProcessesApiFp(configuration).completeEvaluation(
        evaluationId,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return ProcessesApiFp(configuration).exportProcesses(
        programId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return ProcessesApiFp(configuration).exportSessions(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: number, options?: any) {
      return ProcessesApiFp(configuration).getProcess(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return ProcessesApiFp(configuration).getProcesses(
        programId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(evaluationId: number, body: Body19, options?: any) {
      return ProcessesApiFp(configuration).updateEvaluation(
        evaluationId,
        body,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * ProcessesApi - object-oriented interface
 * @export
 * @class ProcessesApi
 * @extends {BaseAPI}
 */
export class ProcessesApi extends BaseAPI {
  /**
   *
   * @summary Accept contract
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessesApi
   */
  public acceptContract(processId: number, options?: any) {
    return ProcessesApiFp(this.configuration).acceptContract(
      processId,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Complete Evaluation
   * @param {} evaluationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessesApi
   */
  public completeEvaluation(evaluationId: number, options?: any) {
    return ProcessesApiFp(this.configuration).completeEvaluation(
      evaluationId,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Processes
   * @param {} programId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessesApi
   */
  public exportProcesses(
    programId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return ProcessesApiFp(this.configuration).exportProcesses(
      programId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Sessions
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessesApi
   */
  public exportSessions(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return ProcessesApiFp(this.configuration).exportSessions(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Process
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessesApi
   */
  public getProcess(processId: number, options?: any) {
    return ProcessesApiFp(this.configuration).getProcess(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Processes
   * @param {} programId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessesApi
   */
  public getProcesses(
    programId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return ProcessesApiFp(this.configuration).getProcesses(
      programId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Evaluation
   * @param {} evaluationId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessesApi
   */
  public updateEvaluation(evaluationId: number, body: Body19, options?: any) {
    return ProcessesApiFp(this.configuration).updateEvaluation(
      evaluationId,
      body,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * ProgramsApi - fetch parameter creator
 * @export
 */
export const ProgramsApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling acceptContract.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/accept-contract`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(evaluationId: number, options: any = {}): FetchArgs {
      // verify required parameter 'evaluationId' is not null or undefined
      if (evaluationId === null || evaluationId === undefined) {
        throw new RequiredError(
          'evaluationId',
          'Required parameter evaluationId was null or undefined when calling completeEvaluation.'
        )
      }
      const localVarPath = `/programs/processes/evaluations/{evaluationId}/complete`.replace(
        `{${'evaluationId'}}`,
        encodeURIComponent(String(evaluationId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(
      sessionId: number,
      body: Body18,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling completeSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling completeSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/complete`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body18' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create Coaching Program
     * @param {Body6} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCoachingProgram(body: Body6, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling createCoachingProgram.'
        )
      }
      const localVarPath = `/coaching/program`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body6' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Create Mentoring Program
     * @param {Body11} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMentoringProgram(body: Body11, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling createMentoringProgram.'
        )
      }
      const localVarPath = `/mentoring/program`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body11' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Remove Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcess(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling deleteProcess.'
        )
      }
      const localVarPath = `/programs/process/{processId}`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign(
        { method: 'DELETE' },
        options
      )
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportPrograms(
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/export/programs`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },

    deleteProgram(programId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling deleteProcess.'
        )
      }
      const localVarPath = `/programs/{programId}`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign(
        { method: 'DELETE' },
        options
      )
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },

    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: number, options: any = {}): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getProcess.'
        )
      }
      const localVarPath = `/programs/process/{processId}`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getProcessResources.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/resources`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling getProcesses.'
        )
      }
      const localVarPath = `/programs/{programId}/processes`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Program
     * @param {number} programId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProgram(programId: number, options: any = {}): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling getProgram.'
        )
      }
      const localVarPath = `/programs/{programId}`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(limit?: number, page?: number, options: any = {}): FetchArgs {
      const localVarPath = `/programs`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(sessionId: number, options: any = {}): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling getSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling getSessionResources.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/resources`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getSessions.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/sessions`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * This is only called by BLC and it doesn't include the session details, since they are not allowed to see it.
     * @summary List Sessions Company
     * @param {string} programId
     * @param {string} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsForCompany(
      programId: string,
      processId: string,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling getSessionsForCompany.'
        )
      }
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getSessionsForCompany.'
        )
      }
      const localVarPath = `/programs/{programId}/processes/{processId}/sessions-company`
        .replace(`{${'programId'}}`, encodeURIComponent(String(programId)))
        .replace(`{${'processId'}}`, encodeURIComponent(String(processId)))
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(
      sessionId: number,
      body: Body17,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling scheduleSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling scheduleSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/schedule`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body17' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(
      evaluationId: number,
      body: Body19,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'evaluationId' is not null or undefined
      if (evaluationId === null || evaluationId === undefined) {
        throw new RequiredError(
          'evaluationId',
          'Required parameter evaluationId was null or undefined when calling updateEvaluation.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateEvaluation.'
        )
      }
      const localVarPath = `/programs/processes/evaluations/{evaluationId}`.replace(
        `{${'evaluationId'}}`,
        encodeURIComponent(String(evaluationId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body19' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Program
     * @param {number} programId
     * @param {Body15} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProgram(
      programId: number,
      body: Body15,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling updateProgram.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateProgram.'
        )
      }
      const localVarPath = `/programs/{programId}`.replace(
        `{${'programId'}}`,
        encodeURIComponent(String(programId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body15' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },

    

    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(
      sessionId: number,
      body: Body16,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling updateSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body16' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(
      processId: number,
      file: any,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling uploadProcessResource.'
        )
      }
      // verify required parameter 'file' is not null or undefined
      if (file === null || file === undefined) {
        throw new RequiredError(
          'file',
          'Required parameter file was null or undefined when calling uploadProcessResource.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/resources`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new url.URLSearchParams()

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (file !== undefined) {
        localVarFormParams.set('file', file as any)
      }

      localVarHeaderParameter['Content-Type'] =
        'application/x-www-form-urlencoded'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      localVarRequestOptions.body = localVarFormParams.toString()

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Upload Session Resource
     * @param {number} sessionId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionResource(
      sessionId: number,
      file: any,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling uploadSessionResource.'
        )
      }
      // verify required parameter 'file' is not null or undefined
      if (file === null || file === undefined) {
        throw new RequiredError(
          'file',
          'Required parameter file was null or undefined when calling uploadSessionResource.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/resources`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new url.URLSearchParams()

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (file !== undefined) {
        localVarFormParams.set('file', file as any)
      }

      localVarHeaderParameter['Content-Type'] =
        'application/x-www-form-urlencoded'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      localVarRequestOptions.body = localVarFormParams.toString()

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ProgramsApi - functional programming interface
 * @export
 */
export const ProgramsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).acceptContract(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(
      evaluationId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).completeEvaluation(evaluationId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(
      sessionId: number,
      body: Body18,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).completeSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Create Coaching Program
     * @param {Body6} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCoachingProgram(
      body: Body6,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Program> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).createCoachingProgram(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Create Mentoring Program
     * @param {Body11} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMentoringProgram(
      body: Body11,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Program> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).createMentoringProgram(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Remove Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcess(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).deleteProcess(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportPrograms(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).exportPrograms(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Remove Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
     deleteProgram(
      programId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).deleteProgram(programId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(
      processId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Process> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).getProcess(processId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2002> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).getProcessResources(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2006> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).getProcesses(programId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Program
     * @param {number} programId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProgram(
      programId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Program> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).getProgram(programId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2004> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).getPrograms(limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(
      sessionId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Session> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).getSession(sessionId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2002> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).getSessionResources(sessionId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2003> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).getSessions(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * This is only called by BLC and it doesn't include the session details, since they are not allowed to see it.
     * @summary List Sessions Company
     * @param {string} programId
     * @param {string} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsForCompany(
      programId: string,
      processId: string,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2005> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).getSessionsForCompany(programId, processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(
      sessionId: number,
      body: Body17,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).scheduleSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(
      evaluationId: number,
      body: Body19,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<FinalEvaluation> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).updateEvaluation(evaluationId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Program
     * @param {number} programId
     * @param {Body15} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProgram(
      programId: number,
      body: Body15,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Program> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).updateProgram(programId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(
      sessionId: number,
      body: Body16,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Session> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).updateSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(
      processId: number,
      file: any,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Resource> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).uploadProcessResource(processId, file, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Upload Session Resource
     * @param {number} sessionId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionResource(
      sessionId: number,
      file: any,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Resource> {
      const localVarFetchArgs = ProgramsApiFetchParamCreator(
        configuration
      ).uploadSessionResource(sessionId, file, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * ProgramsApi - factory interface
 * @export
 */
export const ProgramsApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Accept contract
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptContract(processId: number, options?: any) {
      return ProgramsApiFp(configuration).acceptContract(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Complete Evaluation
     * @param {number} evaluationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeEvaluation(evaluationId: number, options?: any) {
      return ProgramsApiFp(configuration).completeEvaluation(
        evaluationId,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(sessionId: number, body: Body18, options?: any) {
      return ProgramsApiFp(configuration).completeSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Create Coaching Program
     * @param {Body6} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCoachingProgram(body: Body6, options?: any) {
      return ProgramsApiFp(configuration).createCoachingProgram(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Create Mentoring Program
     * @param {Body11} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createMentoringProgram(body: Body11, options?: any) {
      return ProgramsApiFp(configuration).createMentoringProgram(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Remove Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcess(processId: number, options?: any) {
      return ProgramsApiFp(configuration).deleteProcess(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    exportPrograms(limit?: number, page?: number, options?: any) {
      return ProgramsApiFp(configuration).exportPrograms(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Process
     * @param {number} processId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: number, options?: any) {
      return ProgramsApiFp(configuration).getProcess(processId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return ProgramsApiFp(configuration).getProcessResources(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Processes
     * @param {number} programId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcesses(
      programId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return ProgramsApiFp(configuration).getProcesses(
        programId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Program
     * @param {number} programId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProgram(programId: number, options?: any) {
      return ProgramsApiFp(configuration).getProgram(programId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Programs
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPrograms(limit?: number, page?: number, options?: any) {
      return ProgramsApiFp(configuration).getPrograms(
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(sessionId: number, options?: any) {
      return ProgramsApiFp(configuration).getSession(sessionId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return ProgramsApiFp(configuration).getSessionResources(
        sessionId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return ProgramsApiFp(configuration).getSessions(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     * This is only called by BLC and it doesn't include the session details, since they are not allowed to see it.
     * @summary List Sessions Company
     * @param {string} programId
     * @param {string} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsForCompany(
      programId: string,
      processId: string,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return ProgramsApiFp(configuration).getSessionsForCompany(
        programId,
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(sessionId: number, body: Body17, options?: any) {
      return ProgramsApiFp(configuration).scheduleSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Evaluation
     * @param {number} evaluationId
     * @param {Body19} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEvaluation(evaluationId: number, body: Body19, options?: any) {
      return ProgramsApiFp(configuration).updateEvaluation(
        evaluationId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Program
     * @param {number} programId
     * @param {Body15} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProgram(programId: number, body: Body15, options?: any) {
      return ProgramsApiFp(configuration).updateProgram(
        programId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(sessionId: number, body: Body16, options?: any) {
      return ProgramsApiFp(configuration).updateSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(processId: number, file: any, options?: any) {
      return ProgramsApiFp(configuration).uploadProcessResource(
        processId,
        file,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Upload Session Resource
     * @param {number} sessionId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionResource(sessionId: number, file: any, options?: any) {
      return ProgramsApiFp(configuration).uploadSessionResource(
        sessionId,
        file,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * ProgramsApi - object-oriented interface
 * @export
 * @class ProgramsApi
 * @extends {BaseAPI}
 */
export class ProgramsApi extends BaseAPI {
  /**
   *
   * @summary Accept contract
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public acceptContract(processId: number, options?: any) {
    return ProgramsApiFp(this.configuration).acceptContract(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Complete Evaluation
   * @param {} evaluationId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public completeEvaluation(evaluationId: number, options?: any) {
    return ProgramsApiFp(this.configuration).completeEvaluation(
      evaluationId,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Complete Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public completeSession(sessionId: number, body: Body18, options?: any) {
    return ProgramsApiFp(this.configuration).completeSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Create Coaching Program
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public createCoachingProgram(body: Body6, options?: any) {
    return ProgramsApiFp(this.configuration).createCoachingProgram(
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Create Mentoring Program
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public createMentoringProgram(body: Body11, options?: any) {
    return ProgramsApiFp(this.configuration).createMentoringProgram(
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Remove Process
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public deleteProcess(processId: number, options?: any) {
    return ProgramsApiFp(this.configuration).deleteProcess(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Programs
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public exportPrograms(limit?: number, page?: number, options?: any) {
    return ProgramsApiFp(this.configuration).exportPrograms(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Process
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public getProcess(processId: number, options?: any) {
    return ProgramsApiFp(this.configuration).getProcess(processId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Process Resources
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public getProcessResources(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return ProgramsApiFp(this.configuration).getProcessResources(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Processes
   * @param {} programId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public getProcesses(
    programId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return ProgramsApiFp(this.configuration).getProcesses(
      programId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Program
   * @param {} programId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public getProgram(programId: number, options?: any) {
    return ProgramsApiFp(this.configuration).getProgram(programId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Programs
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public getPrograms(limit?: number, page?: number, options?: any) {
    return ProgramsApiFp(this.configuration).getPrograms(
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Session
   * @param {} sessionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public getSession(sessionId: number, options?: any) {
    return ProgramsApiFp(this.configuration).getSession(sessionId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Session Resources
   * @param {} sessionId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public getSessionResources(
    sessionId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return ProgramsApiFp(this.configuration).getSessionResources(
      sessionId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Sessions
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public getSessions(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return ProgramsApiFp(this.configuration).getSessions(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   * This is only called by BLC and it doesn't include the session details, since they are not allowed to see it.
   * @summary List Sessions Company
   * @param {} programId
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public getSessionsForCompany(
    programId: string,
    processId: string,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return ProgramsApiFp(this.configuration).getSessionsForCompany(
      programId,
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Schedule Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public scheduleSession(sessionId: number, body: Body17, options?: any) {
    return ProgramsApiFp(this.configuration).scheduleSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Evaluation
   * @param {} evaluationId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public updateEvaluation(evaluationId: number, body: Body19, options?: any) {
    return ProgramsApiFp(this.configuration).updateEvaluation(
      evaluationId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Program
   * @param {} programId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public updateProgram(programId: number, body: Body15, options?: any) {
    return ProgramsApiFp(this.configuration).updateProgram(
      programId,
      body,
      options
    )(this.fetch, this.basePath)
  }


  /**
   *
   * @summary Remove Process
   * @param {} processId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
   public deleteProgram(programId: number, options?: any) {
    return ProgramsApiFp(this.configuration).deleteProgram(programId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
   * @summary Update Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public updateSession(sessionId: number, body: Body16, options?: any) {
    return ProgramsApiFp(this.configuration).updateSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Upload Process Resource
   * @param {} processId
   * @param {} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public uploadProcessResource(processId: number, file: any, options?: any) {
    return ProgramsApiFp(this.configuration).uploadProcessResource(
      processId,
      file,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Upload Session Resource
   * @param {} sessionId
   * @param {} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProgramsApi
   */
  public uploadSessionResource(sessionId: number, file: any, options?: any) {
    return ProgramsApiFp(this.configuration).uploadSessionResource(
      sessionId,
      file,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * RegisterApi - fetch parameter creator
 * @export
 */
export const RegisterApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coach Register
     * @param {Body5} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoach(body: Body5, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerCoach.'
        )
      }
      const localVarPath = `/coaches`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body5' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coachee Register
     * @param {Body4} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoachee(body: Body4, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerCoachee.'
        )
      }
      const localVarPath = `/coachees`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body4' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * # Notes  The company details will be entered by BLC, so the company will only have to set the password when registering.
     * @summary Company Register
     * @param {Body9} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCompany(body: Body9, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerCompany.'
        )
      }
      const localVarPath = `/companies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body9' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentee Register
     * @param {Body10} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentee(body: Body10, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerMentee.'
        )
      }
      const localVarPath = `/mentees`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body10' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentor Register
     * @param {Body12} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentor(body: Body12, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling registerMentor.'
        )
      }
      const localVarPath = `/mentors`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body12' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * RegisterApi - functional programming interface
 * @export
 */
export const RegisterApiFp = function (configuration?: Configuration) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coach Register
     * @param {Body5} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoach(
      body: Body5,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = RegisterApiFetchParamCreator(
        configuration
      ).registerCoach(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coachee Register
     * @param {Body4} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoachee(
      body: Body4,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = RegisterApiFetchParamCreator(
        configuration
      ).registerCoachee(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * # Notes  The company details will be entered by BLC, so the company will only have to set the password when registering.
     * @summary Company Register
     * @param {Body9} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCompany(
      body: Body9,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = RegisterApiFetchParamCreator(
        configuration
      ).registerCompany(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentee Register
     * @param {Body10} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentee(
      body: Body10,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = RegisterApiFetchParamCreator(
        configuration
      ).registerMentee(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentor Register
     * @param {Body12} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentor(
      body: Body12,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<AuthResponse> {
      const localVarFetchArgs = RegisterApiFetchParamCreator(
        configuration
      ).registerMentor(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * RegisterApi - factory interface
 * @export
 */
export const RegisterApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coach Register
     * @param {Body5} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoach(body: Body5, options?: any) {
      return RegisterApiFp(configuration).registerCoach(body, options)(
        fetch,
        basePath
      )
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Coachee Register
     * @param {Body4} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCoachee(body: Body4, options?: any) {
      return RegisterApiFp(configuration).registerCoachee(body, options)(
        fetch,
        basePath
      )
    },
    /**
     * # Notes  The company details will be entered by BLC, so the company will only have to set the password when registering.
     * @summary Company Register
     * @param {Body9} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerCompany(body: Body9, options?: any) {
      return RegisterApiFp(configuration).registerCompany(body, options)(
        fetch,
        basePath
      )
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentee Register
     * @param {Body10} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentee(body: Body10, options?: any) {
      return RegisterApiFp(configuration).registerMentee(body, options)(
        fetch,
        basePath
      )
    },
    /**
     * # Note  The `photo` in `personal` is a base64 encoded image.
     * @summary Mentor Register
     * @param {Body12} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerMentor(body: Body12, options?: any) {
      return RegisterApiFp(configuration).registerMentor(body, options)(
        fetch,
        basePath
      )
    },
  }
}

/**
 * RegisterApi - object-oriented interface
 * @export
 * @class RegisterApi
 * @extends {BaseAPI}
 */
export class RegisterApi extends BaseAPI {
  /**
   * # Note  The `photo` in `personal` is a base64 encoded image.
   * @summary Coach Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegisterApi
   */
  public registerCoach(body: Body5, options?: any) {
    return RegisterApiFp(this.configuration).registerCoach(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * # Note  The `photo` in `personal` is a base64 encoded image.
   * @summary Coachee Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegisterApi
   */
  public registerCoachee(body: Body4, options?: any) {
    return RegisterApiFp(this.configuration).registerCoachee(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * # Notes  The company details will be entered by BLC, so the company will only have to set the password when registering.
   * @summary Company Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegisterApi
   */
  public registerCompany(body: Body9, options?: any) {
    return RegisterApiFp(this.configuration).registerCompany(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * # Note  The `photo` in `personal` is a base64 encoded image.
   * @summary Mentee Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegisterApi
   */
  public registerMentee(body: Body10, options?: any) {
    return RegisterApiFp(this.configuration).registerMentee(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * # Note  The `photo` in `personal` is a base64 encoded image.
   * @summary Mentor Register
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegisterApi
   */
  public registerMentor(body: Body12, options?: any) {
    return RegisterApiFp(this.configuration).registerMentor(body, options)(
      this.fetch,
      this.basePath
    )
  }
}

/**
 * ResourcesApi - fetch parameter creator
 * @export
 */
export const ResourcesApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getProcessResources.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/resources`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling getSessionResources.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/resources`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(
      processId: number,
      file: any,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling uploadProcessResource.'
        )
      }
      // verify required parameter 'file' is not null or undefined
      if (file === null || file === undefined) {
        throw new RequiredError(
          'file',
          'Required parameter file was null or undefined when calling uploadProcessResource.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/resources`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new url.URLSearchParams()

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (file !== undefined) {
        localVarFormParams.set('file', file as any)
      }

      localVarHeaderParameter['Content-Type'] =
        'application/x-www-form-urlencoded'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      localVarRequestOptions.body = localVarFormParams.toString()

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Upload Session Resource
     * @param {number} sessionId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionResource(
      sessionId: number,
      file: any,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling uploadSessionResource.'
        )
      }
      // verify required parameter 'file' is not null or undefined
      if (file === null || file === undefined) {
        throw new RequiredError(
          'file',
          'Required parameter file was null or undefined when calling uploadSessionResource.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/resources`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any
      const localVarFormParams = new url.URLSearchParams()

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (file !== undefined) {
        localVarFormParams.set('file', file as any)
      }

      localVarHeaderParameter['Content-Type'] =
        'application/x-www-form-urlencoded'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      localVarRequestOptions.body = localVarFormParams.toString()

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * ResourcesApi - functional programming interface
 * @export
 */
export const ResourcesApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2002> {
      const localVarFetchArgs = ResourcesApiFetchParamCreator(
        configuration
      ).getProcessResources(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2002> {
      const localVarFetchArgs = ResourcesApiFetchParamCreator(
        configuration
      ).getSessionResources(sessionId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(
      processId: number,
      file: any,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Resource> {
      const localVarFetchArgs = ResourcesApiFetchParamCreator(
        configuration
      ).uploadProcessResource(processId, file, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Upload Session Resource
     * @param {number} sessionId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionResource(
      sessionId: number,
      file: any,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Resource> {
      const localVarFetchArgs = ResourcesApiFetchParamCreator(
        configuration
      ).uploadSessionResource(sessionId, file, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * ResourcesApi - factory interface
 * @export
 */
export const ResourcesApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary List Process Resources
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessResources(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return ResourcesApiFp(configuration).getProcessResources(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary List Session Resources
     * @param {number} sessionId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionResources(
      sessionId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return ResourcesApiFp(configuration).getSessionResources(
        sessionId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Upload Process Resource
     * @param {number} processId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadProcessResource(processId: number, file: any, options?: any) {
      return ResourcesApiFp(configuration).uploadProcessResource(
        processId,
        file,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Upload Session Resource
     * @param {number} sessionId
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    uploadSessionResource(sessionId: number, file: any, options?: any) {
      return ResourcesApiFp(configuration).uploadSessionResource(
        sessionId,
        file,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * ResourcesApi - object-oriented interface
 * @export
 * @class ResourcesApi
 * @extends {BaseAPI}
 */
export class ResourcesApi extends BaseAPI {
  /**
   *
   * @summary List Process Resources
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcesApi
   */
  public getProcessResources(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return ResourcesApiFp(this.configuration).getProcessResources(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary List Session Resources
   * @param {} sessionId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcesApi
   */
  public getSessionResources(
    sessionId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return ResourcesApiFp(this.configuration).getSessionResources(
      sessionId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Upload Process Resource
   * @param {} processId
   * @param {} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcesApi
   */
  public uploadProcessResource(processId: number, file: any, options?: any) {
    return ResourcesApiFp(this.configuration).uploadProcessResource(
      processId,
      file,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Upload Session Resource
   * @param {} sessionId
   * @param {} file
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcesApi
   */
  public uploadSessionResource(sessionId: number, file: any, options?: any) {
    return ResourcesApiFp(this.configuration).uploadSessionResource(
      sessionId,
      file,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * RootApi - fetch parameter creator
 * @export
 */
export const RootApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary V1 Base
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1Base(options: any = {}): FetchArgs {
      const localVarPath = `/`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * RootApi - functional programming interface
 * @export
 */
export const RootApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary V1 Base
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1Base(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2007> {
      const localVarFetchArgs = RootApiFetchParamCreator(configuration).v1Base(
        options
      )
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * RootApi - factory interface
 * @export
 */
export const RootApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary V1 Base
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    v1Base(options?: any) {
      return RootApiFp(configuration).v1Base(options)(fetch, basePath)
    },
  }
}

/**
 * RootApi - object-oriented interface
 * @export
 * @class RootApi
 * @extends {BaseAPI}
 */
export class RootApi extends BaseAPI {
  /**
   *
   * @summary V1 Base
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RootApi
   */
  public v1Base(options?: any) {
    return RootApiFp(this.configuration).v1Base(options)(
      this.fetch,
      this.basePath
    )
  }
}

/**
 * SessionsApi - fetch parameter creator
 * @export
 */
export const SessionsApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(
      sessionId: number,
      body: Body18,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling completeSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling completeSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/complete`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body18' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(sessionId: number, options: any = {}): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling getSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getSessions.'
        )
      }
      const localVarPath = `/programs/processes/{processId}/sessions`.replace(
        `{${'processId'}}`,
        encodeURIComponent(String(processId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * This is only called by BLC and it doesn't include the session details, since they are not allowed to see it.
     * @summary List Sessions Company
     * @param {string} programId
     * @param {string} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsForCompany(
      programId: string,
      processId: string,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'programId' is not null or undefined
      if (programId === null || programId === undefined) {
        throw new RequiredError(
          'programId',
          'Required parameter programId was null or undefined when calling getSessionsForCompany.'
        )
      }
      // verify required parameter 'processId' is not null or undefined
      if (processId === null || processId === undefined) {
        throw new RequiredError(
          'processId',
          'Required parameter processId was null or undefined when calling getSessionsForCompany.'
        )
      }
      const localVarPath = `/programs/{programId}/processes/{processId}/sessions-company`
        .replace(`{${'programId'}}`, encodeURIComponent(String(programId)))
        .replace(`{${'processId'}}`, encodeURIComponent(String(processId)))
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(
      sessionId: number,
      body: Body17,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling scheduleSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling scheduleSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}/schedule`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body17' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(
      sessionId: number,
      body: Body16,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'sessionId' is not null or undefined
      if (sessionId === null || sessionId === undefined) {
        throw new RequiredError(
          'sessionId',
          'Required parameter sessionId was null or undefined when calling updateSession.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateSession.'
        )
      }
      const localVarPath = `/programs/processes/sessions/{sessionId}`.replace(
        `{${'sessionId'}}`,
        encodeURIComponent(String(sessionId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body16' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * SessionsApi - functional programming interface
 * @export
 */
export const SessionsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(
      sessionId: number,
      body: Body18,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = SessionsApiFetchParamCreator(
        configuration
      ).completeSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(
      sessionId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Session> {
      const localVarFetchArgs = SessionsApiFetchParamCreator(
        configuration
      ).getSession(sessionId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2003> {
      const localVarFetchArgs = SessionsApiFetchParamCreator(
        configuration
      ).getSessions(processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * This is only called by BLC and it doesn't include the session details, since they are not allowed to see it.
     * @summary List Sessions Company
     * @param {string} programId
     * @param {string} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsForCompany(
      programId: string,
      processId: string,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2005> {
      const localVarFetchArgs = SessionsApiFetchParamCreator(
        configuration
      ).getSessionsForCompany(programId, processId, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(
      sessionId: number,
      body: Body17,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = SessionsApiFetchParamCreator(
        configuration
      ).scheduleSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(
      sessionId: number,
      body: Body16,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Session> {
      const localVarFetchArgs = SessionsApiFetchParamCreator(
        configuration
      ).updateSession(sessionId, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * SessionsApi - factory interface
 * @export
 */
export const SessionsApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Complete Session
     * @param {number} sessionId
     * @param {Body18} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    completeSession(sessionId: number, body: Body18, options?: any) {
      return SessionsApiFp(configuration).completeSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Get Session
     * @param {number} sessionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(sessionId: number, options?: any) {
      return SessionsApiFp(configuration).getSession(sessionId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary List Sessions
     * @param {number} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessions(
      processId: number,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return SessionsApiFp(configuration).getSessions(
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     * This is only called by BLC and it doesn't include the session details, since they are not allowed to see it.
     * @summary List Sessions Company
     * @param {string} programId
     * @param {string} processId
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSessionsForCompany(
      programId: string,
      processId: string,
      limit?: number,
      page?: number,
      options?: any
    ) {
      return SessionsApiFp(configuration).getSessionsForCompany(
        programId,
        processId,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Schedule Session
     * @param {number} sessionId
     * @param {Body17} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    scheduleSession(sessionId: number, body: Body17, options?: any) {
      return SessionsApiFp(configuration).scheduleSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
    /**
     * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
     * @summary Update Session
     * @param {number} sessionId
     * @param {Body16} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateSession(sessionId: number, body: Body16, options?: any) {
      return SessionsApiFp(configuration).updateSession(
        sessionId,
        body,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * SessionsApi - object-oriented interface
 * @export
 * @class SessionsApi
 * @extends {BaseAPI}
 */
export class SessionsApi extends BaseAPI {
  /**
   *
   * @summary Complete Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public completeSession(sessionId: number, body: Body18, options?: any) {
    return SessionsApiFp(this.configuration).completeSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Get Session
   * @param {} sessionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public getSession(sessionId: number, options?: any) {
    return SessionsApiFp(this.configuration).getSession(sessionId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Sessions
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public getSessions(
    processId: number,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return SessionsApiFp(this.configuration).getSessions(
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   * This is only called by BLC and it doesn't include the session details, since they are not allowed to see it.
   * @summary List Sessions Company
   * @param {} programId
   * @param {} processId
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public getSessionsForCompany(
    programId: string,
    processId: string,
    limit?: number,
    page?: number,
    options?: any
  ) {
    return SessionsApiFp(this.configuration).getSessionsForCompany(
      programId,
      processId,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Schedule Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public scheduleSession(sessionId: number, body: Body17, options?: any) {
    return SessionsApiFp(this.configuration).scheduleSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   * The fields can be updated based on the current session status, e.g. if the session is scheduled, you can only update the date, if the session is done you can update the goals and achievements but not the date etc.  # Need more info here
   * @summary Update Session
   * @param {} sessionId
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SessionsApi
   */
  public updateSession(sessionId: number, body: Body16, options?: any) {
    return SessionsApiFp(this.configuration).updateSession(
      sessionId,
      body,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * TripartitaApi - fetch parameter creator
 * @export
 */
export const TripartitaApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(processID: number, options: any = {}): FetchArgs {
      // verify required parameter 'processID' is not null or undefined
      if (processID === null || processID === undefined) {
        throw new RequiredError(
          'processID',
          'Required parameter processID was null or undefined when calling listTripartita.'
        )
      }
      const localVarPath = `/programs/processes/{processID}/tripartita`.replace(
        `{${'processID'}}`,
        encodeURIComponent(String(processID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Final
     * @param {number} tripartitaID
     * @param {Body1} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinalTripartita(
      tripartitaID: number,
      body: Body1,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateFinalTripartita.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateFinalTripartita.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/final`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body1' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Initial Coach
     * @param {number} tripartitaID
     * @param {Body3} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoach(
      tripartitaID: number,
      body: Body3,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateInitialTripartitaCoach.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateInitialTripartitaCoach.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/initial/coach`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body3' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Initial Coachee
     * @param {number} tripartitaID
     * @param {Body2} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoachee(
      tripartitaID: number,
      body: Body2,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateInitialTripartitaCoachee.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateInitialTripartitaCoachee.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/initial/coachee`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body2' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'tripartitaID' is not null or undefined
      if (tripartitaID === null || tripartitaID === undefined) {
        throw new RequiredError(
          'tripartitaID',
          'Required parameter tripartitaID was null or undefined when calling updateIntermediateTripartita.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateIntermediateTripartita.'
        )
      }
      const localVarPath = `/programs/processes/tripartita/{tripartitaID}/intermediate`.replace(
        `{${'tripartitaID'}}`,
        encodeURIComponent(String(tripartitaID))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * TripartitaApi - functional programming interface
 * @export
 */
export const TripartitaApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(
      processID: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<ProcessTripartita> {
      const localVarFetchArgs = TripartitaApiFetchParamCreator(
        configuration
      ).listTripartita(processID, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Final
     * @param {number} tripartitaID
     * @param {Body1} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinalTripartita(
      tripartitaID: number,
      body: Body1,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<FinalTripartita> {
      const localVarFetchArgs = TripartitaApiFetchParamCreator(
        configuration
      ).updateFinalTripartita(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Initial Coach
     * @param {number} tripartitaID
     * @param {Body3} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoach(
      tripartitaID: number,
      body: Body3,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InitialTripartita> {
      const localVarFetchArgs = TripartitaApiFetchParamCreator(
        configuration
      ).updateInitialTripartitaCoach(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Initial Coachee
     * @param {number} tripartitaID
     * @param {Body2} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoachee(
      tripartitaID: number,
      body: Body2,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InitialTripartita> {
      const localVarFetchArgs = TripartitaApiFetchParamCreator(
        configuration
      ).updateInitialTripartitaCoachee(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<IntermediateTripartita> {
      const localVarFetchArgs = TripartitaApiFetchParamCreator(
        configuration
      ).updateIntermediateTripartita(tripartitaID, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * TripartitaApi - factory interface
 * @export
 */
export const TripartitaApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary List Tripartita
     * @param {number} processID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listTripartita(processID: number, options?: any) {
      return TripartitaApiFp(configuration).listTripartita(processID, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Final
     * @param {number} tripartitaID
     * @param {Body1} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateFinalTripartita(tripartitaID: number, body: Body1, options?: any) {
      return TripartitaApiFp(configuration).updateFinalTripartita(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Initial Coach
     * @param {number} tripartitaID
     * @param {Body3} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoach(
      tripartitaID: number,
      body: Body3,
      options?: any
    ) {
      return TripartitaApiFp(configuration).updateInitialTripartitaCoach(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Initial Coachee
     * @param {number} tripartitaID
     * @param {Body2} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateInitialTripartitaCoachee(
      tripartitaID: number,
      body: Body2,
      options?: any
    ) {
      return TripartitaApiFp(configuration).updateInitialTripartitaCoachee(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Update Intermediate
     * @param {number} tripartitaID
     * @param {Body} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateIntermediateTripartita(
      tripartitaID: number,
      body: Body,
      options?: any
    ) {
      return TripartitaApiFp(configuration).updateIntermediateTripartita(
        tripartitaID,
        body,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * TripartitaApi - object-oriented interface
 * @export
 * @class TripartitaApi
 * @extends {BaseAPI}
 */
export class TripartitaApi extends BaseAPI {
  /**
   *
   * @summary List Tripartita
   * @param {} processID
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TripartitaApi
   */
  public listTripartita(processID: number, options?: any) {
    return TripartitaApiFp(this.configuration).listTripartita(
      processID,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Final
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TripartitaApi
   */
  public updateFinalTripartita(
    tripartitaID: number,
    body: Body1,
    options?: any
  ) {
    return TripartitaApiFp(this.configuration).updateFinalTripartita(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Initial Coach
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TripartitaApi
   */
  public updateInitialTripartitaCoach(
    tripartitaID: number,
    body: Body3,
    options?: any
  ) {
    return TripartitaApiFp(this.configuration).updateInitialTripartitaCoach(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Initial Coachee
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TripartitaApi
   */
  public updateInitialTripartitaCoachee(
    tripartitaID: number,
    body: Body2,
    options?: any
  ) {
    return TripartitaApiFp(this.configuration).updateInitialTripartitaCoachee(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Update Intermediate
   * @param {} tripartitaID
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TripartitaApi
   */
  public updateIntermediateTripartita(
    tripartitaID: number,
    body: Body,
    options?: any
  ) {
    return TripartitaApiFp(this.configuration).updateIntermediateTripartita(
      tripartitaID,
      body,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * UserApi - fetch parameter creator
 * @export
 */
export const UserApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Get Boss
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBoss(options: any = {}): FetchArgs {
      const localVarPath = `/user/boss`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Coaching
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCoaching(options: any = {}): FetchArgs {
      const localVarPath = `/user/coaching`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Company Contacts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyContacts(options: any = {}): FetchArgs {
      const localVarPath = `/user/contacts`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Company Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyDetails(options: any = {}): FetchArgs {
      const localVarPath = `/user/company-details`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(type?: string, options: any = {}): FetchArgs {
      const localVarPath = `/user/experience`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(options: any = {}): FetchArgs {
      const localVarPath = `/user/personal`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(type?: string, options: any = {}): FetchArgs {
      const localVarPath = `/user/studies`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Boss
     * @param {Boss} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBoss(body: Boss, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateBoss.'
        )
      }
      const localVarPath = `/user/boss`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Boss' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Coaching
     * @param {Body20} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCoaching(body: Body20, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateCoaching.'
        )
      }
      const localVarPath = `/user/coaching`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body20' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Company Contacts
     * @param {Contacts} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompanyContacts(body: Contacts, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateCompanyContacts.'
        )
      }
      const localVarPath = `/user/contacts`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Contacts' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * # Note  This is called by the company itself, not by BLC.
     * @summary Update Company Details
     * @param {Company} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompanyDetails(body: Company, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateCompanyDetails.'
        )
      }
      const localVarPath = `/user/company-details`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Company' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(
      type: string,
      body: Array<Experience>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling updateExperience.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateExperience.'
        )
      }
      const localVarPath = `/user/experience/{type}`.replace(
        `{${'type'}}`,
        encodeURIComponent(String(type))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Array&lt;Experience&gt;' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(body: Body21, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updatePassword.'
        )
      }
      const localVarPath = `/user/password`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body21' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(body: PersonalInfo, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updatePersonalInfo.'
        )
      }
      const localVarPath = `/user/personal`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'PersonalInfo' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(
      type: string,
      body: Array<Study>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling updateStudies.'
        )
      }
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling updateStudies.'
        )
      }
      const localVarPath = `/user/studies/{type}`.replace(
        `{${'type'}}`,
        encodeURIComponent(String(type))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'PUT' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Array&lt;Study&gt;' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get Boss
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBoss(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Boss> {
      const localVarFetchArgs = UserApiFetchParamCreator(configuration).getBoss(
        options
      )
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Coaching
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCoaching(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2008> {
      const localVarFetchArgs = UserApiFetchParamCreator(
        configuration
      ).getCoaching(options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Company Contacts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyContacts(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Contacts> {
      const localVarFetchArgs = UserApiFetchParamCreator(
        configuration
      ).getCompanyContacts(options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Company Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyDetails(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
      const localVarFetchArgs = UserApiFetchParamCreator(
        configuration
      ).getCompanyDetails(options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(
      type?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Experience>> {
      const localVarFetchArgs = UserApiFetchParamCreator(
        configuration
      ).getExperience(type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<PersonalInfo> {
      const localVarFetchArgs = UserApiFetchParamCreator(
        configuration
      ).getPersonalInfo(options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(
      type?: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Study>> {
      const localVarFetchArgs = UserApiFetchParamCreator(
        configuration
      ).getStudies(type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Boss
     * @param {Boss} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBoss(
      body: Boss,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = UserApiFetchParamCreator(
        configuration
      ).updateBoss(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Coaching
     * @param {Body20} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCoaching(
      body: Body20,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2008> {
      const localVarFetchArgs = UserApiFetchParamCreator(
        configuration
      ).updateCoaching(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Company Contacts
     * @param {Contacts} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompanyContacts(
      body: Contacts,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Contacts> {
      const localVarFetchArgs = UserApiFetchParamCreator(
        configuration
      ).updateCompanyContacts(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     * # Note  This is called by the company itself, not by BLC.
     * @summary Update Company Details
     * @param {Company} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompanyDetails(
      body: Company,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
      const localVarFetchArgs = UserApiFetchParamCreator(
        configuration
      ).updateCompanyDetails(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(
      type: string,
      body: Array<Experience>,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Experience>> {
      const localVarFetchArgs = UserApiFetchParamCreator(
        configuration
      ).updateExperience(type, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(
      body: Body21,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = UserApiFetchParamCreator(
        configuration
      ).updatePassword(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(
      body: PersonalInfo,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<PersonalInfo> {
      const localVarFetchArgs = UserApiFetchParamCreator(
        configuration
      ).updatePersonalInfo(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(
      type: string,
      body: Array<Study>,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<Study>> {
      const localVarFetchArgs = UserApiFetchParamCreator(
        configuration
      ).updateStudies(type, body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Get Boss
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getBoss(options?: any) {
      return UserApiFp(configuration).getBoss(options)(fetch, basePath)
    },
    /**
     *
     * @summary Get Coaching
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCoaching(options?: any) {
      return UserApiFp(configuration).getCoaching(options)(fetch, basePath)
    },
    /**
     *
     * @summary Get Company Contacts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyContacts(options?: any) {
      return UserApiFp(configuration).getCompanyContacts(options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Company Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCompanyDetails(options?: any) {
      return UserApiFp(configuration).getCompanyDetails(options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Experience
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getExperience(type?: string, options?: any) {
      return UserApiFp(configuration).getExperience(type, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get Personal Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonalInfo(options?: any) {
      return UserApiFp(configuration).getPersonalInfo(options)(fetch, basePath)
    },
    /**
     *
     * @summary Get Studies
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStudies(type?: string, options?: any) {
      return UserApiFp(configuration).getStudies(type, options)(fetch, basePath)
    },
    /**
     *
     * @summary Update Boss
     * @param {Boss} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateBoss(body: Boss, options?: any) {
      return UserApiFp(configuration).updateBoss(body, options)(fetch, basePath)
    },
    /**
     *
     * @summary Update Coaching
     * @param {Body20} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCoaching(body: Body20, options?: any) {
      return UserApiFp(configuration).updateCoaching(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Company Contacts
     * @param {Contacts} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompanyContacts(body: Contacts, options?: any) {
      return UserApiFp(configuration).updateCompanyContacts(body, options)(
        fetch,
        basePath
      )
    },
    /**
     * # Note  This is called by the company itself, not by BLC.
     * @summary Update Company Details
     * @param {Company} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCompanyDetails(body: Company, options?: any) {
      return UserApiFp(configuration).updateCompanyDetails(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Experience
     * @param {string} type
     * @param {Array&lt;Experience&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateExperience(type: string, body: Array<Experience>, options?: any) {
      return UserApiFp(configuration).updateExperience(
        type,
        body,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Change password
     * @param {Body21} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePassword(body: Body21, options?: any) {
      return UserApiFp(configuration).updatePassword(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Personal Info
     * @param {PersonalInfo} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonalInfo(body: PersonalInfo, options?: any) {
      return UserApiFp(configuration).updatePersonalInfo(body, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Update Studies
     * @param {string} type
     * @param {Array&lt;Study&gt;} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStudies(type: string, body: Array<Study>, options?: any) {
      return UserApiFp(configuration).updateStudies(
        type,
        body,
        options
      )(fetch, basePath)
    },
  }
}

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
  /**
   *
   * @summary Get Boss
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public getBoss(options?: any) {
    return UserApiFp(this.configuration).getBoss(options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Coaching
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public getCoaching(options?: any) {
    return UserApiFp(this.configuration).getCoaching(options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Company Contacts
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public getCompanyContacts(options?: any) {
    return UserApiFp(this.configuration).getCompanyContacts(options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Company Details
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public getCompanyDetails(options?: any) {
    return UserApiFp(this.configuration).getCompanyDetails(options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Experience
   * @param {} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public getExperience(type?: string, options?: any) {
    return UserApiFp(this.configuration).getExperience(type, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Personal Info
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public getPersonalInfo(options?: any) {
    return UserApiFp(this.configuration).getPersonalInfo(options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get Studies
   * @param {} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public getStudies(type?: string, options?: any) {
    return UserApiFp(this.configuration).getStudies(type, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Boss
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public updateBoss(body: Boss, options?: any) {
    return UserApiFp(this.configuration).updateBoss(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Coaching
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public updateCoaching(body: Body20, options?: any) {
    return UserApiFp(this.configuration).updateCoaching(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Company Contacts
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public updateCompanyContacts(body: Contacts, options?: any) {
    return UserApiFp(this.configuration).updateCompanyContacts(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   * # Note  This is called by the company itself, not by BLC.
   * @summary Update Company Details
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public updateCompanyDetails(body: Company, options?: any) {
    return UserApiFp(this.configuration).updateCompanyDetails(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Experience
   * @param {} type
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public updateExperience(
    type: string,
    body: Array<Experience>,
    options?: any
  ) {
    return UserApiFp(this.configuration).updateExperience(
      type,
      body,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Change password
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public updatePassword(body: Body21, options?: any) {
    return UserApiFp(this.configuration).updatePassword(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Personal Info
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public updatePersonalInfo(body: PersonalInfo, options?: any) {
    return UserApiFp(this.configuration).updatePersonalInfo(body, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Update Studies
   * @param {} type
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UserApi
   */
  public updateStudies(type: string, body: Array<Study>, options?: any) {
    return UserApiFp(this.configuration).updateStudies(
      type,
      body,
      options
    )(this.fetch, this.basePath)
  }
}

/**
 * UsersApi - fetch parameter creator
 * @export
 */
export const UsersApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Check User
     * @param {string} email
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkUser(email: string, type: string, options: any = {}): FetchArgs {
      // verify required parameter 'email' is not null or undefined
      if (email === null || email === undefined) {
        throw new RequiredError(
          'email',
          'Required parameter email was null or undefined when calling checkUser.'
        )
      }
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling checkUser.'
        )
      }
      const localVarPath = `/users/{email}/{type}`
        .replace(`{${'email'}}`, encodeURIComponent(String(email)))
        .replace(`{${'type'}}`, encodeURIComponent(String(type)))
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Delete User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(userId: number, options: any = {}): FetchArgs {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling deleteUser.'
        )
      }
      const localVarPath = `/users/{userId}`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign(
        { method: 'DELETE' },
        options
      )
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Get User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(userId: number, options: any = {}): FetchArgs {
      // verify required parameter 'userId' is not null or undefined
      if (userId === null || userId === undefined) {
        throw new RequiredError(
          'userId',
          'Required parameter userId was null or undefined when calling getUser.'
        )
      }
      const localVarPath = `/users/{userId}`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(userId))
      )
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary List Users
     * @param {string} type The type of the account, e.g. \&quot;coach\&quot;, \&quot;coachee\&quot;
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers(
      type: string,
      limit?: number,
      page?: number,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'type' is not null or undefined
      if (type === null || type === undefined) {
        throw new RequiredError(
          'type',
          'Required parameter type was null or undefined when calling getUsers.'
        )
      }
      const localVarPath = `/users`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'GET' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      if (limit !== undefined) {
        localVarQueryParameter['limit'] = limit
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Invite User
     * @param {Body22} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteUser(body: Body22, options: any = {}): FetchArgs {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling inviteUser.'
        )
      }
      const localVarPath = `/users/invite`
      const localVarUrlObj = url.parse(localVarPath, true)
      const localVarRequestOptions = Object.assign({ method: 'POST' }, options)
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Authorization required
      if (configuration && configuration.apiKey) {
        const localVarApiKeyValue =
          typeof configuration.apiKey === 'function'
            ? configuration.apiKey('Authorization')
            : configuration.apiKey
        localVarHeaderParameter['Authorization'] = localVarApiKeyValue
      }

      localVarHeaderParameter['Content-Type'] = 'application/json'

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      )
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      )
      const needsSerialization =
        <any>'Body22' !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json'
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || ''

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Check User
     * @param {string} email
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkUser(
      email: string,
      type: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = UsersApiFetchParamCreator(
        configuration
      ).checkUser(email, type, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Delete User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(
      userId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = UsersApiFetchParamCreator(
        configuration
      ).deleteUser(userId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Get User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(
      userId: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<User> {
      const localVarFetchArgs = UsersApiFetchParamCreator(
        configuration
      ).getUser(userId, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary List Users
     * @param {string} type The type of the account, e.g. \&quot;coach\&quot;, \&quot;coachee\&quot;
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers(
      type: string,
      limit?: number,
      page?: number,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20010> {
      const localVarFetchArgs = UsersApiFetchParamCreator(
        configuration
      ).getUsers(type, limit, page, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
    /**
     *
     * @summary Invite User
     * @param {Body22} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteUser(
      body: Body22,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2009> {
      const localVarFetchArgs = UsersApiFetchParamCreator(
        configuration
      ).inviteUser(body, options)
      return (
        fetch: FetchAPI = portableFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json()
          } else {
            throw response
          }
        })
      }
    },
  }
}

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @summary Check User
     * @param {string} email
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    checkUser(email: string, type: string, options?: any) {
      return UsersApiFp(configuration).checkUser(
        email,
        type,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Delete User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(userId: number, options?: any) {
      return UsersApiFp(configuration).deleteUser(userId, options)(
        fetch,
        basePath
      )
    },
    /**
     *
     * @summary Get User
     * @param {number} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUser(userId: number, options?: any) {
      return UsersApiFp(configuration).getUser(userId, options)(fetch, basePath)
    },
    /**
     *
     * @summary List Users
     * @param {string} type The type of the account, e.g. \&quot;coach\&quot;, \&quot;coachee\&quot;
     * @param {number} [limit]
     * @param {number} [page]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsers(type: string, limit?: number, page?: number, options?: any) {
      return UsersApiFp(configuration).getUsers(
        type,
        limit,
        page,
        options
      )(fetch, basePath)
    },
    /**
     *
     * @summary Invite User
     * @param {Body22} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    inviteUser(body: Body22, options?: any) {
      return UsersApiFp(configuration).inviteUser(body, options)(
        fetch,
        basePath
      )
    },
  }
}

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
  /**
   *
   * @summary Check User
   * @param {} email
   * @param {} type
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public checkUser(email: string, type: string, options?: any) {
    return UsersApiFp(this.configuration).checkUser(
      email,
      type,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Delete User
   * @param {} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public deleteUser(userId: number, options?: any) {
    return UsersApiFp(this.configuration).deleteUser(userId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary Get User
   * @param {} userId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public getUser(userId: number, options?: any) {
    return UsersApiFp(this.configuration).getUser(userId, options)(
      this.fetch,
      this.basePath
    )
  }

  /**
   *
   * @summary List Users
   * @param {} type The type of the account, e.g. \&quot;coach\&quot;, \&quot;coachee\&quot;
   * @param {} [limit]
   * @param {} [page]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public getUsers(type: string, limit?: number, page?: number, options?: any) {
    return UsersApiFp(this.configuration).getUsers(
      type,
      limit,
      page,
      options
    )(this.fetch, this.basePath)
  }

  /**
   *
   * @summary Invite User
   * @param {} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public inviteUser(body: Body22, options?: any) {
    return UsersApiFp(this.configuration).inviteUser(body, options)(
      this.fetch,
      this.basePath
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/api.ts